var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366, _path367, _path368, _path369, _path370, _path371, _path372, _path373, _path374, _path375, _path376, _path377, _path378, _path379, _path380, _path381, _path382, _path383, _path384, _path385, _path386, _path387, _path388, _path389, _path390, _path391, _path392, _path393, _path394, _path395, _path396, _path397, _path398, _path399, _path400, _path401, _path402, _path403, _path404, _path405, _path406, _path407, _path408, _path409, _path410, _path411, _path412, _path413, _path414, _path415, _path416, _path417, _path418, _path419, _path420, _path421, _path422, _path423, _path424, _path425, _path426, _path427, _path428, _path429, _path430, _path431, _path432, _path433, _path434, _path435, _path436, _path437, _path438, _path439, _path440, _path441, _path442, _path443, _path444, _path445, _path446, _path447, _path448, _path449, _path450, _path451, _path452, _path453, _path454, _path455, _path456, _path457, _path458, _path459, _path460, _path461, _path462, _path463, _path464, _path465, _path466, _path467, _path468, _path469, _path470, _path471, _path472, _path473, _path474, _path475, _path476, _path477, _path478, _path479, _path480, _path481, _path482, _path483, _path484, _path485, _path486, _path487, _path488, _path489, _path490, _path491, _path492, _path493, _path494, _path495, _path496, _path497, _path498, _path499, _path500, _path501, _path502, _path503, _path504, _path505, _path506, _path507, _path508, _path509, _path510, _path511, _path512, _path513, _path514, _path515, _path516, _path517, _path518, _path519, _path520, _path521, _path522, _path523, _path524, _path525, _path526, _path527, _path528, _path529, _path530, _path531, _path532, _path533, _path534, _path535, _path536, _path537, _path538, _path539, _path540, _path541, _path542, _path543, _path544, _path545, _path546, _path547, _path548, _path549, _path550, _path551, _path552, _path553, _path554, _path555, _path556, _path557, _path558, _path559, _path560, _path561, _path562, _path563, _path564, _path565, _path566, _path567, _path568, _path569, _path570, _path571, _path572, _path573, _path574, _path575, _path576, _path577, _path578, _path579, _path580, _path581, _path582, _path583, _path584, _path585, _path586, _path587, _path588, _path589, _path590, _path591, _path592, _path593, _path594, _path595, _path596, _path597, _path598, _path599, _path600, _path601, _path602, _path603, _path604, _path605, _path606, _path607, _path608, _path609, _path610, _path611, _path612, _path613, _path614, _path615, _path616, _path617, _path618, _path619, _path620, _path621, _path622, _path623, _path624, _path625, _path626, _path627, _path628, _path629, _path630, _path631, _path632, _path633, _path634, _path635, _path636, _path637, _path638, _path639, _path640, _path641, _path642, _path643, _path644, _path645, _path646, _path647, _path648, _path649, _path650, _path651, _path652, _path653, _path654, _path655, _path656, _path657, _path658, _path659, _path660, _path661, _path662, _path663, _path664, _path665, _path666, _path667, _path668, _path669, _path670, _path671, _path672, _path673, _path674, _path675, _path676, _path677, _path678, _path679, _path680, _path681, _path682, _path683, _path684, _path685, _path686, _path687, _path688, _path689, _path690, _path691, _path692, _path693, _path694, _path695, _path696, _path697, _path698, _path699, _path700, _path701, _path702, _path703, _path704, _path705, _path706, _path707, _path708, _path709, _path710, _path711, _path712, _path713, _path714, _path715, _path716, _path717, _path718, _path719, _path720, _path721, _path722, _path723, _path724, _path725, _path726, _path727, _path728, _path729, _path730, _path731, _path732, _path733, _path734, _path735, _path736, _path737, _path738, _path739, _path740, _path741, _path742, _path743, _path744, _path745, _path746, _path747, _path748, _path749, _path750, _path751, _path752, _path753, _path754, _path755, _path756, _path757, _path758, _path759, _path760, _path761, _path762, _path763, _path764, _path765, _path766, _path767, _path768, _path769, _path770, _path771, _path772, _path773, _path774, _path775, _path776, _path777, _path778, _path779, _path780, _path781, _path782, _path783, _path784, _path785, _path786, _path787, _path788, _path789, _path790, _path791, _path792, _path793, _path794, _path795, _path796, _path797, _path798, _path799, _path800, _path801, _path802, _path803, _path804, _path805, _path806, _path807, _path808, _path809, _path810, _path811, _path812, _path813, _path814, _path815, _path816, _path817, _path818, _path819, _path820, _path821, _path822, _path823, _path824, _path825, _path826, _path827, _path828, _path829, _path830, _path831, _path832, _path833, _path834, _path835, _path836, _path837, _path838, _path839, _path840, _path841, _path842, _path843, _path844, _path845, _path846, _path847, _path848, _path849, _path850, _path851, _path852, _path853, _path854, _path855, _path856, _path857, _path858, _path859, _path860, _path861, _path862, _path863, _path864, _path865, _path866, _path867, _path868, _path869, _path870, _path871, _path872, _path873, _path874, _path875, _path876, _path877, _path878, _path879, _path880, _path881, _path882, _path883, _path884, _path885, _path886, _path887, _path888, _path889, _path890, _path891, _path892, _path893, _path894, _path895, _path896, _path897, _path898, _path899, _path900, _path901, _path902, _path903, _path904, _path905, _path906, _path907, _path908, _path909, _path910, _path911, _path912, _path913, _path914, _path915, _path916, _path917, _path918, _path919, _path920, _path921, _path922, _path923, _path924, _path925, _path926, _path927, _path928, _path929, _path930, _path931, _path932, _path933, _path934, _path935, _path936, _path937, _path938, _path939, _path940, _path941, _path942, _path943, _path944, _path945, _path946, _path947, _path948, _path949, _path950, _path951, _path952, _path953, _path954, _path955, _path956, _path957, _path958, _path959, _path960, _path961, _path962, _path963, _path964, _path965, _path966, _path967, _path968, _path969, _path970, _path971, _path972, _path973, _path974, _path975, _path976, _path977, _path978, _path979, _path980, _path981, _path982, _path983, _path984, _path985, _path986, _path987, _path988, _path989, _path990, _path991, _path992, _path993, _path994, _path995, _path996, _path997, _path998, _path999, _path1000, _path1001, _path1002, _path1003, _path1004, _path1005, _path1006, _path1007, _path1008, _path1009, _path1010, _path1011, _path1012, _path1013, _path1014, _path1015, _path1016, _path1017, _path1018, _path1019, _path1020, _path1021, _path1022, _path1023, _path1024, _path1025, _path1026, _path1027, _path1028, _path1029, _path1030, _path1031, _path1032, _path1033, _path1034, _path1035, _path1036, _path1037, _path1038, _path1039, _path1040, _path1041, _path1042, _path1043, _path1044, _path1045, _path1046, _path1047, _path1048, _path1049, _path1050, _path1051, _path1052, _path1053, _path1054, _path1055, _path1056, _path1057, _path1058, _path1059, _path1060, _path1061, _path1062, _path1063, _path1064, _path1065, _path1066, _path1067, _path1068, _path1069, _path1070, _path1071, _path1072, _path1073, _path1074, _path1075, _path1076, _path1077, _path1078, _path1079, _path1080, _path1081, _path1082, _path1083, _path1084, _path1085, _path1086, _path1087, _path1088, _path1089, _path1090, _path1091, _path1092, _path1093, _path1094, _path1095, _path1096, _path1097, _path1098, _path1099, _path1100, _path1101, _path1102, _path1103, _path1104, _path1105, _path1106, _path1107, _path1108, _path1109, _path1110, _path1111, _path1112, _path1113, _path1114, _path1115, _path1116, _path1117, _path1118, _path1119, _path1120, _path1121, _path1122, _path1123, _path1124, _path1125, _path1126, _path1127, _path1128, _path1129, _path1130, _path1131, _path1132, _path1133, _path1134, _path1135, _path1136, _path1137, _path1138, _path1139, _path1140, _path1141, _path1142, _path1143, _path1144, _path1145, _path1146, _path1147, _path1148, _path1149, _path1150, _path1151, _path1152, _path1153, _path1154, _path1155, _path1156, _path1157, _path1158, _path1159, _path1160, _path1161, _path1162, _path1163, _path1164, _path1165, _path1166, _path1167, _path1168, _path1169, _path1170, _path1171, _path1172, _path1173, _path1174, _path1175, _path1176, _path1177, _path1178, _path1179, _path1180, _path1181, _path1182, _path1183, _path1184, _path1185, _path1186, _path1187, _path1188, _path1189, _path1190, _path1191, _path1192, _path1193, _path1194, _path1195, _path1196, _path1197, _path1198, _path1199, _path1200, _path1201, _path1202, _path1203, _path1204, _path1205, _path1206, _path1207, _path1208, _path1209, _path1210, _path1211, _path1212, _path1213, _path1214, _path1215, _path1216, _path1217, _path1218, _path1219, _path1220, _path1221, _path1222, _path1223, _path1224, _path1225, _rect, _rect2, _path1226, _path1227, _path1228, _path1229, _path1230, _path1231, _path1232, _path1233, _path1234, _path1235, _rect3, _circle, _path1236, _path1237, _path1238, _rect4, _path1239, _path1240, _path1241, _path1242, _path1243;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFullSetupDesktop(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1021 458",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-2, .cls-3, .cls-4, .cls-5, .cls-6, .cls-7, .cls-8, .cls-9, .cls-10, .cls-11, .cls-12 {\n        stroke: #fcfcfc;\n      }\n\n      .cls-1, .cls-2, .cls-3, .cls-4, .cls-5, .cls-6, .cls-8, .cls-9, .cls-10, .cls-11, .cls-12 {\n        fill: none;\n      }\n\n      .cls-1, .cls-2, .cls-3, .cls-5, .cls-6, .cls-7, .cls-8, .cls-9, .cls-10, .cls-11, .cls-12 {\n        stroke-opacity: .6;\n      }\n\n      .cls-1, .cls-8 {\n        stroke-linejoin: round;\n      }\n\n      .cls-1, .cls-10 {\n        stroke-width: .2px;\n      }\n\n      .cls-13 {\n        fill: #7f849b;\n      }\n\n      .cls-13, .cls-14, .cls-15, .cls-16, .cls-17, .cls-18, .cls-19 {\n        stroke-width: 0px;\n      }\n\n      .cls-2, .cls-3, .cls-4, .cls-5, .cls-6, .cls-7, .cls-12 {\n        stroke-miterlimit: 10;\n      }\n\n      .cls-2, .cls-3, .cls-8 {\n        stroke-width: .8px;\n      }\n\n      .cls-2, .cls-4, .cls-8, .cls-12 {\n        stroke-linecap: round;\n      }\n\n      .cls-4 {\n        stroke-opacity: .5;\n      }\n\n      .cls-4, .cls-6, .cls-7, .cls-12 {\n        stroke-width: .5px;\n      }\n\n      .cls-14 {\n        fill-opacity: .3;\n      }\n\n      .cls-14, .cls-15, .cls-17, .cls-18 {\n        fill: #fcfcfc;\n      }\n\n      .cls-15, .cls-17, .cls-19 {\n        fill-opacity: .6;\n      }\n\n      .cls-16 {\n        fill: #9e9e9e;\n      }\n\n      .cls-17, .cls-18 {\n        fill-rule: evenodd;\n      }\n\n      .cls-18 {\n        fill-opacity: .5;\n      }\n\n      .cls-7 {\n        fill: #101011;\n      }\n\n      .cls-11 {\n        stroke-width: .1px;\n      }\n\n      .cls-19 {\n        fill: #020203;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1015.6,98.4h-241.6c-2.5,0-4.6,2.1-4.6,4.6v250c0,2.5,2.1,4.6,4.6,4.6h241.6c2.5,0,4.6-2.1,4.6-4.6V103c0-2.5-2.1-4.6-4.6-4.6Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M779.8,199.5c-2,0-3.6,1.6-3.6,3.6s1.6,3.6,3.6,3.6,3.6-1.6,3.6-3.6-1.6-3.6-3.6-3.6Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M797.4,199.5c-2,0-3.6,1.6-3.6,3.6s1.6,3.6,3.6,3.6,3.6-1.6,3.6-3.6-1.6-3.6-3.6-3.6Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M991.9,291.2c2.4,0,4.3-1.9,4.3-4.3s-1.8-4.2-4.1-4.3v4.2c0,0,0,.2-.2.2s-.2,0-.2-.2v-4.2c-2.3,0-4.1,2-4.1,4.3s1.9,4.3,4.3,4.3Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M991.9,281.9c0,0,.2,0,.2-.2v-.7c0,0,0-.2-.2-.2s-.2,0-.2.2v.7c0,0,0,.2.2.2Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M989.8,282.2s0,0,0,0c0,0,.1-.1,0-.2l-.2-.5c0,0-.1-.1-.2,0,0,0-.1.1,0,.2l.2.5c0,0,0,.1.2.1h0Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M988.2,283.3c0,0,0-.2,0-.3l-.4-.4c0,0-.2,0-.3,0,0,0,0,.2,0,.3l.4.4s0,0,.1,0,0,0,.1,0h0Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M995.8,290.6c0,0-.2,0-.3,0,0,0,0,.2,0,.3l1.2,1.2s0,0,.1,0,0,0,.1,0c0,0,0-.2,0-.3l-1.2-1.2h0Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M986.4,284.5c0,0-.2,0-.2,0,0,0,0,.2,0,.2l.6.2s0,0,0,0c0,0,.1,0,.2-.1,0,0,0-.2,0-.2l-.6-.2h0Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M997.5,289.1l-.6-.2c0,0-.2,0-.2,0,0,0,0,.2,0,.2l.6.2s0,0,0,0c0,0,.1,0,.2-.1,0,0,0-.2,0-.2h0Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M986.7,287c0,0,0-.2-.2-.2h-.6c0,0-.2,0-.2.2s0,.2.2.2h.6c0,0,.2,0,.2-.2Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M997.8,286.8h-.6c0,0-.2,0-.2.2s0,.2.2.2h.6c0,0,.2,0,.2-.2s0-.2-.2-.2Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M987.1,289c0,0-.1-.1-.2,0l-.6.2c0,0-.1.1,0,.2,0,0,0,.1.2.1s0,0,0,0l.6-.2c0,0,.1-.1,0-.2h0Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M997.3,284.5l-.6.2c0,0-.1.1,0,.2,0,0,0,.1.2.1s0,0,0,0l.6-.2c0,0,.1-.1,0-.2,0,0-.1-.1-.2,0h0Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M988.2,290.6c0,0-.2,0-.3,0l-1.2,1.1c0,0,0,.2,0,.3,0,0,0,0,.1,0s0,0,.1,0l1.2-1.1c0,0,0-.2,0-.3h0Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M996.2,282.6c0,0-.2,0-.3,0l-.4.4c0,0,0,.2,0,.3,0,0,0,0,.1,0s0,0,.1,0l.4-.4c0,0,0-.2,0-.3h0Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M993.9,282.2c0,0,.1,0,.2-.1l.2-.6c0,0,0-.2,0-.2,0,0-.2,0-.2,0l-.2.6c0,0,0,.2,0,.2,0,0,0,0,0,0h0Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M970.2,210.4h42.1c.3,0,.6.3.6.6v34.9h-43.4v-34.9c0-.3.3-.6.6-.6Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M807.7,89.7h5.8c.2,0,.4.2.4.4v8h-6.7v-8c0-.2.2-.4.4-.4h0Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M828.1,96.1h4c0,0,.2,0,.2.2v1.9h-4.3v-1.9c0,0,0-.2.2-.2Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M842.9,96.1h4c0,0,.2,0,.2.2v1.9h-4.3v-1.9c0,0,0-.2.2-.2Z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M858.4,96.1h4c0,0,.2,0,.2.2v1.9h-4.3v-1.9c0,0,0-.2.2-.2Z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M866.1,96.1h4c0,0,.2,0,.2.2v1.9h-4.3v-1.9c0,0,0-.2.2-.2Z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M888.6,96.1h4c0,0,.2,0,.2.2v1.9h-4.3v-1.9c0,0,0-.2.2-.2Z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M926.7,96.1h4c0,0,.2,0,.2.2v1.9h-4.3v-1.9c0,0,0-.2.2-.2Z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M944.2,96.1h4c0,0,.2,0,.2.2v1.9h-4.3v-1.9c0,0,0-.2.2-.2Z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M956.7,96.1h4c0,0,.2,0,.2.2v1.9h-4.3v-1.9c0,0,0-.2.2-.2Z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M969.9,96.1h4c0,0,.2,0,.2.2v1.9h-4.3v-1.9c0,0,0-.2.2-.2Z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M985.4,89.7h5.8c.2,0,.4.2.4.4v8h-6.7v-8c0-.2.2-.4.4-.4h0Z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M806.6,105.3v88.3"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M806.6,197v11.6"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M806.6,212.9v11.6"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M806.6,228.4v11.6"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M806.6,244.4v11.6"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M806.6,259.7v39.4"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M806.6,302.3v44.8"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M987.1,137c-.9-1.6-2.5-2.5-4.2-2.5v5.2c0,.1,0,.2-.2.2s-.2-.1-.2-.2v-5.2c-.8,0-1.6.3-2.4.7-2.5,1.4-3.3,4.6-1.9,7,1.4,2.5,4.6,3.3,7.1,1.9,2.5-1.4,3.3-4.6,1.9-7Z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M982.6,132.6v.7"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M979.1,133.6l.3.6"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M985.8,145l.3.6"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M976.6,136.1l.6.3"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M988,142.7l.6.3"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M975.7,139.6h.7"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M988.9,139.6h.7"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M976.6,143.1l.6-.3"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M988,136.5l.6-.3"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M979.1,145.6l.3-.6"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M985.8,134.2l.3-.6"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M987.1,162.6c-.9-1.6-2.5-2.5-4.2-2.5v5.2c0,.1,0,.2-.2.2s-.2-.1-.2-.2v-5.2c-.8,0-1.6.3-2.4.7-2.5,1.4-3.3,4.6-1.9,7,1.4,2.5,4.6,3.3,7.1,1.9,2.5-1.4,3.3-4.6,1.9-7Z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M982.6,158.3v.7"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M979.1,159.2l.3.6"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M985.8,170.6l.3.6"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M976.6,161.7l.6.3"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M988,168.3l.6.3"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M975.7,165.2h.7"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M988.9,165.2h.7"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M976.6,168.7l.6-.3"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M988,162.1l.6-.3"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M979.1,171.2l.3-.6"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M985.8,159.8l.3-.6"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M987.1,188.2c-.9-1.6-2.5-2.5-4.2-2.5v5.2c0,.1,0,.2-.2.2s-.2-.1-.2-.2v-5.2c-.8,0-1.6.3-2.4.7-2.5,1.4-3.3,4.6-1.9,7,1.4,2.5,4.6,3.3,7.1,1.9,2.5-1.4,3.3-4.6,1.9-7Z"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M982.6,183.9v.7"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M979.1,184.8l.3.6"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M985.8,196.3l.3.6"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M976.6,187.4l.6.3"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M988,194l.6.3"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M975.7,190.8h.7"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M988.9,190.8h.7"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M976.6,194.3l.6-.3"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M988,187.7l.6-.3"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M979.1,196.8l.3-.6"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M985.8,185.4l.3-.6"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M959.6,290.2c-.5-.8-1.3-1.3-2.2-1.3v2.7c0,0,0,.1,0,.1s-.1,0-.1-.1v-2.7c-.4,0-.9.1-1.2.4-1.3.7-1.7,2.4-1,3.7s2.4,1.7,3.7,1c1.3-.7,1.7-2.4,1-3.7h0Z"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M957.3,287.9v.4"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M955.4,288.4l.2.3"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M958.9,294.4l.2.3"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M954.1,289.7l.3.2"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M960.1,293.2l.3.2"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M953.6,291.5h.4"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M960.5,291.5h.4"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M954.1,293.3l.3-.2"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M960.1,289.9l.3-.2"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M955.4,294.7l.2-.3"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M958.9,288.7l.2-.3"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M994,303c-.5-.8-1.3-1.3-2.2-1.3v2.7c0,0,0,.1,0,.1s-.1,0-.1-.1v-2.7c-.4,0-.9.1-1.2.4-1.3.7-1.7,2.4-1,3.7.7,1.3,2.4,1.7,3.7,1,1.3-.7,1.7-2.4,1-3.7h0Z"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M991.7,300.7v.4"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M989.9,301.2l.2.3"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M993.3,307.1l.2.3"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M988.5,302.5l.3.2"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M994.5,306l.3.2"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M988.1,304.3h.4"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M995,304.3h.3"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M988.5,306.1l.3-.2"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M994.5,302.7l.3-.2"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M989.9,307.5l.2-.3"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M993.3,301.5l.2-.3"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M811,281.8c0,0,0,.2.2.2h6.4c0,0,.2,0,.2-.2s0-.2-.2-.2h-6.4c0,0-.2,0-.2.2Z"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M810.9,281.8c0,.1,0,.2.2.2h6.4c.1,0,.2,0,.2-.2s0-.2-.2-.2h-6.4c-.1,0-.2,0-.2.2Z"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M826.1,281.7h-6.4c0,0-.2,0-.2.2s0,.2.2.2h6.4c0,0,.2,0,.2-.2s0-.2-.2-.2Z"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M826.1,281.6h-6.4c-.1,0-.2,0-.2.2s0,.2.2.2h6.4c.1,0,.2,0,.2-.2s0-.2-.2-.2Z"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M811.1,284.4h6.4c0,0,.2,0,.2-.2s0-.2-.2-.2h-6.4c0,0-.2,0-.2.2s0,.2.2.2Z"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M811.1,284.4h6.4c.1,0,.2,0,.2-.2s0-.2-.2-.2h-6.4c-.1,0-.2,0-.2.2s0,.2.2.2Z"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M826.1,284.1h-6.4c0,0-.2,0-.2.2s0,.2.2.2h6.4c0,0,.2,0,.2-.2s0-.2-.2-.2Z"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M826.1,284h-6.4c-.1,0-.2,0-.2.2s0,.2.2.2h6.4c.1,0,.2,0,.2-.2s0-.2-.2-.2Z"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M811.1,286.8h6.4c0,0,.2,0,.2-.2s0-.2-.2-.2h-6.4c0,0-.2,0-.2.2s0,.2.2.2Z"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M811.1,286.8h6.4c.1,0,.2,0,.2-.2s0-.2-.2-.2h-6.4c-.1,0-.2,0-.2.2s0,.2.2.2Z"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M826.1,286.5h-6.4c0,0-.2,0-.2.2s0,.2.2.2h6.4c0,0,.2,0,.2-.2s0-.2-.2-.2Z"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M826.1,286.4h-6.4c-.1,0-.2,0-.2.2s0,.2.2.2h6.4c.1,0,.2,0,.2-.2s0-.2-.2-.2Z"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M811.1,289.2h6.4c0,0,.2,0,.2-.2s0-.2-.2-.2h-6.4c0,0-.2,0-.2.2s0,.2.2.2Z"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M811.1,289.2h6.4c.1,0,.2,0,.2-.2s0-.2-.2-.2h-6.4c-.1,0-.2,0-.2.2s0,.2.2.2Z"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M826.1,288.9h-6.4c0,0-.2,0-.2.2s0,.2.2.2h6.4c0,0,.2,0,.2-.2s0-.2-.2-.2Z"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M826.1,288.8h-6.4c-.1,0-.2,0-.2.2s0,.2.2.2h6.4c.1,0,.2,0,.2-.2s0-.2-.2-.2Z"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M811.1,291.6h6.4c0,0,.2,0,.2-.2s0-.2-.2-.2h-6.4c0,0-.2,0-.2.2s0,.2.2.2Z"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M811.1,291.6h6.4c.1,0,.2,0,.2-.2s0-.2-.2-.2h-6.4c-.1,0-.2,0-.2.2s0,.2.2.2Z"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M812.9,294h11c.1,0,.3,0,.3-.2s-.1-.2-.3-.2h-11c-.1,0-.3,0-.3.2s.1.2.3.2Z"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M812.9,294h11c0,0,.2,0,.2,0,0,0,.1,0,.1-.2s0-.1-.1-.2c0,0-.1,0-.2,0h-11c0,0-.2,0-.2,0,0,0-.1,0-.1.2s0,.1.1.2c0,0,.1,0,.2,0Z"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M826.1,291.3h-6.4c0,0-.2,0-.2.2s0,.2.2.2h6.4c0,0,.2,0,.2-.2s0-.2-.2-.2Z"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M826.1,291.2h-6.4c-.1,0-.2,0-.2.2s0,.2.2.2h6.4c.1,0,.2,0,.2-.2s0-.2-.2-.2Z"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M811.1,296.4h6.4c0,0,.2,0,.2-.2s0-.2-.2-.2h-6.4c0,0-.2,0-.2.2s0,.2.2.2Z"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M811.1,296.5h6.4c.1,0,.2,0,.2-.2s0-.2-.2-.2h-6.4c-.1,0-.2,0-.2.2s0,.2.2.2Z"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M826.1,296.1h-6.4c0,0-.2,0-.2.2s0,.2.2.2h6.4c0,0,.2,0,.2-.2s0-.2-.2-.2Z"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M826.1,296h-6.4c-.1,0-.2,0-.2.2s0,.2.2.2h6.4c.1,0,.2,0,.2-.2s0-.2-.2-.2Z"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M811.1,298.8h6.4c0,0,.2,0,.2-.2s0-.2-.2-.2h-6.4c0,0-.2,0-.2.2s0,.2.2.2Z"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M811.1,298.9h6.4c.1,0,.2,0,.2-.2s0-.2-.2-.2h-6.4c-.1,0-.2,0-.2.2s0,.2.2.2Z"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M826.1,298.5h-6.4c0,0-.2,0-.2.2s0,.2.2.2h6.4c0,0,.2,0,.2-.2s0-.2-.2-.2Z"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M826.1,298.4h-6.4c-.1,0-.2,0-.2.2s0,.2.2.2h6.4c.1,0,.2,0,.2-.2s0-.2-.2-.2Z"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M811.1,301.2h6.4c0,0,.2,0,.2-.2s0-.2-.2-.2h-6.4c0,0-.2,0-.2.2s0,.2.2.2Z"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M811.1,301.3h6.4c.1,0,.2,0,.2-.2s0-.2-.2-.2h-6.4c-.1,0-.2,0-.2.2s0,.2.2.2Z"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M826.1,300.9h-6.4c0,0-.2,0-.2.2s0,.2.2.2h6.4c0,0,.2,0,.2-.2s0-.2-.2-.2Z"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M826.1,300.9h-6.4c-.1,0-.2,0-.2.2s0,.2.2.2h6.4c.1,0,.2,0,.2-.2s0-.2-.2-.2Z"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M811.1,303.6h6.4c0,0,.2,0,.2-.2s0-.2-.2-.2h-6.4c0,0-.2,0-.2.2s0,.2.2.2Z"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M811.1,303.7h6.4c.1,0,.2,0,.2-.2s0-.2-.2-.2h-6.4c-.1,0-.2,0-.2.2s0,.2.2.2Z"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M826.1,303.3h-6.4c0,0-.2,0-.2.2s0,.2.2.2h6.4c0,0,.2,0,.2-.2s0-.2-.2-.2Z"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M826.1,303.3h-6.4c-.1,0-.2,0-.2.2s0,.2.2.2h6.4c.1,0,.2,0,.2-.2s0-.2-.2-.2Z"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M811.1,306h6.4c0,0,.2,0,.2-.2s0-.2-.2-.2h-6.4c0,0-.2,0-.2.2s0,.2.2.2Z"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M811.1,306h6.4c.1,0,.2,0,.2-.2s0-.2-.2-.2h-6.4c-.1,0-.2,0-.2.2s0,.2.2.2Z"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M826.1,305.6h-6.4c0,0-.2,0-.2.2s0,.2.2.2h6.4c0,0,.2,0,.2-.2s0-.2-.2-.2Z"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M826.1,305.6h-6.4c-.1,0-.2,0-.2.2s0,.2.2.2h6.4c.1,0,.2,0,.2-.2s0-.2-.2-.2Z"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M810.8,145.1v57.7"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M780.9,133.2c0-.6-.5-1.1-1.1-1.1s-1.1.5-1.1,1.1.5,1.1,1.1,1.1,1.1-.5,1.1-1.1Z"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M782.4,133.2c0-1.4-1.2-2.6-2.6-2.6s-2.6,1.1-2.6,2.6,1.2,2.6,2.6,2.6,2.6-1.1,2.6-2.6Z"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M797.9,133.2c0-.6-.5-1.1-1.1-1.1s-1.1.5-1.1,1.1.5,1.1,1.1,1.1,1.1-.5,1.1-1.1Z"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M799.4,133.2c0-1.4-1.2-2.6-2.6-2.6s-2.6,1.1-2.6,2.6,1.2,2.6,2.6,2.6,2.6-1.1,2.6-2.6Z"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M818.6,111.7c0-.2-.1-.3-.3-.3-1.1.2-2,1.1-2,2.3,0,1.3,1,2.5,2.3,2.5,1.3,0,2.5-1,2.5-2.3,0-1.2-.8-2.3-2-2.5-.1,0-.3,0-.3.2v1.3c0,0-.1.1-.2.1s-.1,0-.1-.1v-1.3h0Z"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M815.5,110.8l.9.9"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M817.6,109.8l.2,1.2"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M820,109.8l-.2,1.2"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M821.8,110.8l-.7.9"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M945.2,226.5h-138.1"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M945.2,210.8h-138.1"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M945.2,242h-138.1"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M945.2,258h-138.1"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M871.1,330.7h-56.2"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M938.7,330.7h-56.2"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M799.8,237.4c1.8,0,3.3-1.5,3.3-3.3s-1.5-3.3-3.3-3.3-3.3,1.5-3.3,3.3,1.5,3.3,3.3,3.3Z"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M788.1,237.4c1.8,0,3.3-1.5,3.3-3.3s-1.5-3.3-3.3-3.3-3.3,1.5-3.3,3.3,1.5,3.3,3.3,3.3Z"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M776.5,237.4c1.8,0,3.3-1.5,3.3-3.3s-1.5-3.3-3.3-3.3-3.3,1.5-3.3,3.3,1.5,3.3,3.3,3.3Z"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M799.8,252.2c1.8,0,3.3-1.5,3.3-3.3s-1.5-3.3-3.3-3.3-3.3,1.5-3.3,3.3,1.5,3.3,3.3,3.3Z"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M818.6,237.4c1.8,0,3.3-1.5,3.3-3.3s-1.5-3.3-3.3-3.3-3.3,1.5-3.3,3.3,1.5,3.3,3.3,3.3Z"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M788.1,252.2c1.8,0,3.3-1.5,3.3-3.3s-1.5-3.3-3.3-3.3-3.3,1.5-3.3,3.3,1.5,3.3,3.3,3.3Z"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M776.5,252.2c1.8,0,3.3-1.5,3.3-3.3s-1.5-3.3-3.3-3.3-3.3,1.5-3.3,3.3,1.5,3.3,3.3,3.3Z"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M780.7,160.3h15.8"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1010.7,122.9v-14.3c0-.3-.2-.6-.6-.6h-11.1c-.3,0-.6.2-.6.6v14.3c0,.3.3.6.6.6h11.1c.3,0,.6-.2.6-.6Z"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1009.3,110h-9.5"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M782.2,150.6c-.5-.8-1.3-1.3-2.2-1.3v2.7c0,0,0,.1,0,.1s-.1,0-.1-.1v-2.7c-.4,0-.9.1-1.2.4-1.3.7-1.7,2.4-1,3.7.7,1.3,2.4,1.7,3.7,1,1.3-.7,1.7-2.4,1-3.7h0Z"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M779.8,148.4v.4"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M778,148.9l.2.3"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M781.5,154.8l.2.3"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M776.7,150.2l.3.2"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M782.7,153.6l.3.2"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M776.2,152h.3"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M783.1,152h.4"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M776.7,153.8l.3-.2"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M782.7,150.4l.3-.2"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M778,155.1l.2-.3"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M781.5,149.2l.2-.3"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M799.7,150.6c-.5-.8-1.3-1.3-2.2-1.3v2.7c0,0,0,.1,0,.1s-.1,0-.1-.1v-2.7c-.4,0-.9.1-1.2.4-1.3.7-1.7,2.4-1,3.7.7,1.3,2.4,1.7,3.7,1,1.3-.7,1.7-2.4,1-3.7h0Z"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M797.4,148.4v.4"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M795.5,148.9l.2.3"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M799,154.8l.2.3"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M794.2,150.2l.3.2"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M800.2,153.6l.3.2"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M793.7,152h.3"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M800.6,152h.3"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M794.2,153.8l.3-.2"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M800.2,150.4l.3-.2"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M795.5,155.1l.2-.3"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M799,149.2l.2-.3"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M813.3,124.9c-.8.5-1.3,1.3-1.3,2.2h2.7c0,0,.1,0,.1,0s0,.1-.1.1h-2.7c0,.4.1.9.4,1.2.7,1.3,2.4,1.7,3.7,1,1.3-.7,1.7-2.4,1-3.7-.7-1.3-2.4-1.7-3.7-1h0Z"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M811,127.2h.4"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M811.5,129l.3-.2"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M817.5,125.6l.3-.2"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M812.8,130.3l.2-.3"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M816.3,124.4l.2-.3"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M814.7,130.8v-.4"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M814.7,123.9v-.4"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M816.5,130.3l-.2-.3"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M813,124.4l-.2-.3"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M817.8,129l-.3-.2"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M811.8,125.6l-.3-.2"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M827.6,133.1c-.5-.8-1.3-1.3-2.2-1.3v2.7c0,0,0,.1,0,.1s-.1,0-.1-.1v-2.7c-.4,0-.9.1-1.2.4-1.3.7-1.7,2.4-1,3.7s2.4,1.7,3.7,1c1.3-.7,1.7-2.4,1-3.7h0Z"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M825.2,130.8v.4"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M823.4,131.3l.2.3"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M826.9,137.3l.2.3"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M822.1,132.6l.3.2"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M828.1,136.1l.3.2"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M821.6,134.5h.3"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M828.5,134.5h.4"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M822.1,136.3l.3-.2"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M828.1,132.8l.3-.2"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M823.4,137.6l.2-.3"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M826.9,131.6l.2-.3"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M782.2,167.6c-.5-.8-1.3-1.3-2.2-1.3v2.7c0,0,0,.1,0,.1s-.1,0-.1-.1v-2.7c-.4,0-.9.1-1.2.4-1.3.7-1.7,2.4-1,3.7.7,1.3,2.4,1.7,3.7,1,1.3-.7,1.7-2.4,1-3.7h0Z"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M779.8,165.4v.3"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M778,165.9l.2.3"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M781.5,171.8l.2.3"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M776.7,167.2l.3.2"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M782.7,170.6l.3.2"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M776.2,169h.3"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M783.1,169h.4"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M776.7,170.8l.3-.2"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M782.7,167.4l.3-.2"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M778,172.1l.2-.3"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M781.5,166.2l.2-.3"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M799.7,167.6c-.5-.8-1.3-1.3-2.2-1.3v2.7c0,0,0,.1,0,.1s-.1,0-.1-.1v-2.7c-.4,0-.9.1-1.2.4-1.3.7-1.7,2.4-1,3.7.7,1.3,2.4,1.7,3.7,1,1.3-.7,1.7-2.4,1-3.7h0Z"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M797.4,165.4v.3"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M795.5,165.9l.2.3"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M799,171.8l.2.3"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M794.2,167.2l.3.2"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M800.2,170.6l.3.2"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M793.7,169h.3"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M800.6,169h.3"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M794.2,170.8l.3-.2"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M800.2,167.4l.3-.2"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M795.5,172.1l.2-.3"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M799,166.2l.2-.3"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M775.4,186.3v2.7c0,.6.5,1,1,1h7.2c.6,0,1-.5,1-1v-2.7c0-.6-.5-1-1-1h-7.2c-.6,0-1,.5-1,1Z"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M778.5,189.1v-2.8"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M797.4,189.9c1.2,0,2.3-1,2.3-2.3s-1-2.3-2.3-2.3-2.3,1-2.3,2.3,1,2.3,2.3,2.3Z"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M797.4,191.2c2,0,3.6-1.6,3.6-3.6s-1.6-3.6-3.6-3.6-3.6,1.6-3.6,3.6,1.6,3.6,3.6,3.6Z"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M789,260.6c0-.6-.5-1.1-1.1-1.1s-1.1.5-1.1,1.1.5,1.1,1.1,1.1,1.1-.5,1.1-1.1Z"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M790.5,260.6c0-1.4-1.2-2.6-2.6-2.6s-2.6,1.1-2.6,2.6,1.2,2.6,2.6,2.6,2.6-1.1,2.6-2.6Z"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M789,309.3c0-.6-.5-1.1-1.1-1.1s-1.1.5-1.1,1.1.5,1.1,1.1,1.1,1.1-.5,1.1-1.1Z"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M790.5,309.3c0-1.4-1.2-2.6-2.6-2.6s-2.6,1.1-2.6,2.6,1.2,2.6,2.6,2.6,2.6-1.1,2.6-2.6Z"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M780.8,309.3c0-1.4-1.2-2.6-2.6-2.6s-2.6,1.1-2.6,2.6,1.2,2.6,2.6,2.6,2.6-1.1,2.6-2.6Z"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M824.5,265.8c0-.6-.5-1.1-1.1-1.1s-1.1.5-1.1,1.1.5,1.1,1.1,1.1,1.1-.5,1.1-1.1Z"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M826.1,265.8c0-1.4-1.2-2.6-2.6-2.6s-2.6,1.1-2.6,2.6,1.2,2.6,2.6,2.6,2.6-1.1,2.6-2.6Z"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M816.4,265.8c0-1.4-1.2-2.6-2.6-2.6s-2.6,1.1-2.6,2.6,1.2,2.6,2.6,2.6,2.6-1.1,2.6-2.6Z"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M785.3,345c0-1.1-.9-2-2-2s-2,.9-2,2,.9,2,2,2,2-.9,2-2Z"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M795.6,345c0-1.1-.9-2-2-2s-2,.9-2,2,.9,2,2,2,2-.9,2-2Z"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M799.5,309.3c0-.6-.5-1.1-1.1-1.1s-1.1.5-1.1,1.1.5,1.1,1.1,1.1,1.1-.5,1.1-1.1Z"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M801,309.3c0-1.4-1.2-2.6-2.6-2.6s-2.6,1.1-2.6,2.6,1.2,2.6,2.6,2.6,2.6-1.1,2.6-2.6Z"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M775.8,278.4c-1.6-.9-2.6-2.6-2.6-4.5s1.9-4.7,4.3-5.1"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M778.9,268.8c2.4.4,4.3,2.5,4.3,5.1s-.9,3.3-2.2,4.3"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M794.1,278.4c-1.6-.9-2.6-2.6-2.6-4.5s1.9-4.7,4.3-5.1"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M797.2,268.8c2.4.4,4.3,2.5,4.3,5.1s-.9,3.3-2.2,4.3"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M816.3,254.5c-1.6-.9-2.6-2.6-2.6-4.5s1.9-4.7,4.3-5.1"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M819.4,244.9c2.4.4,4.3,2.5,4.3,5.1s-.9,3.3-2.2,4.3"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M775.8,295.4c-1.6-.9-2.6-2.6-2.6-4.5s1.9-4.7,4.3-5.1"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M778.9,285.8c2.4.4,4.3,2.5,4.3,5.1s-.9,3.3-2.2,4.3"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M794.1,295.4c-1.6-.9-2.6-2.6-2.6-4.5s1.9-4.7,4.3-5.1"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M797.2,285.8c2.4.4,4.3,2.5,4.3,5.1s-.9,3.3-2.2,4.3"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M775.8,328.4c-1.6-.9-2.6-2.6-2.6-4.5s1.9-4.7,4.3-5.1"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M778.9,318.8c2.4.4,4.3,2.5,4.3,5.1s-.9,3.3-2.2,4.3"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M794.1,328.4c-1.6-.9-2.6-2.6-2.6-4.5s1.9-4.7,4.3-5.1"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M797.2,318.8c2.4.4,4.3,2.5,4.3,5.1s-.9,3.3-2.2,4.3"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M785.5,223.4c-1.6-.9-2.6-2.6-2.6-4.5s1.9-4.7,4.3-5.1"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M788.6,213.8c2.4.4,4.3,2.5,4.3,5.1s-.9,3.3-2.2,4.3"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M816.3,223.4c-1.6-.9-2.6-2.6-2.6-4.5s1.9-4.7,4.3-5.1"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M819.4,213.8c2.4.4,4.3,2.5,4.3,5.1s-.9,3.3-2.2,4.3"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M830,105.3v101.7"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M830,212.9v11.6"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M830,228.4v11.6"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M830,244.4v11.6"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M830,259.7v39.4"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M830,302.3v25"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M834.3,281.8c0,0,0,.2.2.2h6.4c0,0,.2,0,.2-.2s0-.2-.2-.2h-6.4c0,0-.2,0-.2.2Z"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M834.2,281.8c0,.1,0,.2.2.2h6.4c.1,0,.2,0,.2-.2s0-.2-.2-.2h-6.4c-.1,0-.2,0-.2.2Z"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M849.4,281.7h-6.4c0,0-.2,0-.2.2s0,.2.2.2h6.4c0,0,.2,0,.2-.2s0-.2-.2-.2Z"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M849.4,281.6h-6.4c-.1,0-.2,0-.2.2s0,.2.2.2h6.4c.1,0,.2,0,.2-.2s0-.2-.2-.2Z"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M834.4,284.4h6.4c0,0,.2,0,.2-.2s0-.2-.2-.2h-6.4c0,0-.2,0-.2.2s0,.2.2.2Z"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M834.4,284.4h6.4c.1,0,.2,0,.2-.2s0-.2-.2-.2h-6.4c-.1,0-.2,0-.2.2s0,.2.2.2Z"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M849.4,284.1h-6.4c0,0-.2,0-.2.2s0,.2.2.2h6.4c0,0,.2,0,.2-.2s0-.2-.2-.2Z"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M849.4,284h-6.4c-.1,0-.2,0-.2.2s0,.2.2.2h6.4c.1,0,.2,0,.2-.2s0-.2-.2-.2Z"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M834.4,286.8h6.4c0,0,.2,0,.2-.2s0-.2-.2-.2h-6.4c0,0-.2,0-.2.2s0,.2.2.2Z"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M834.4,286.8h6.4c.1,0,.2,0,.2-.2s0-.2-.2-.2h-6.4c-.1,0-.2,0-.2.2s0,.2.2.2Z"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M849.4,286.5h-6.4c0,0-.2,0-.2.2s0,.2.2.2h6.4c0,0,.2,0,.2-.2s0-.2-.2-.2Z"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M849.4,286.4h-6.4c-.1,0-.2,0-.2.2s0,.2.2.2h6.4c.1,0,.2,0,.2-.2s0-.2-.2-.2Z"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M834.4,289.2h6.4c0,0,.2,0,.2-.2s0-.2-.2-.2h-6.4c0,0-.2,0-.2.2s0,.2.2.2Z"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M834.4,289.2h6.4c.1,0,.2,0,.2-.2s0-.2-.2-.2h-6.4c-.1,0-.2,0-.2.2s0,.2.2.2Z"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M849.4,288.9h-6.4c0,0-.2,0-.2.2s0,.2.2.2h6.4c0,0,.2,0,.2-.2s0-.2-.2-.2Z"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M849.4,288.8h-6.4c-.1,0-.2,0-.2.2s0,.2.2.2h6.4c.1,0,.2,0,.2-.2s0-.2-.2-.2Z"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M834.4,291.6h6.4c0,0,.2,0,.2-.2s0-.2-.2-.2h-6.4c0,0-.2,0-.2.2s0,.2.2.2Z"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M834.4,291.6h6.4c.1,0,.2,0,.2-.2s0-.2-.2-.2h-6.4c-.1,0-.2,0-.2.2s0,.2.2.2Z"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M836.2,294h11c.1,0,.3,0,.3-.2s-.1-.2-.3-.2h-11c-.1,0-.3,0-.3.2s.1.2.3.2Z"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M836.2,294h11c0,0,.2,0,.2,0,0,0,.1,0,.1-.2s0-.1-.1-.2c0,0-.1,0-.2,0h-11c0,0-.2,0-.2,0,0,0-.1,0-.1.2s0,.1.1.2c0,0,.1,0,.2,0Z"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M849.4,291.3h-6.4c0,0-.2,0-.2.2s0,.2.2.2h6.4c0,0,.2,0,.2-.2s0-.2-.2-.2Z"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M849.4,291.2h-6.4c-.1,0-.2,0-.2.2s0,.2.2.2h6.4c.1,0,.2,0,.2-.2s0-.2-.2-.2Z"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M834.4,296.4h6.4c0,0,.2,0,.2-.2s0-.2-.2-.2h-6.4c0,0-.2,0-.2.2s0,.2.2.2Z"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M834.4,296.5h6.4c.1,0,.2,0,.2-.2s0-.2-.2-.2h-6.4c-.1,0-.2,0-.2.2s0,.2.2.2Z"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M849.4,296.1h-6.4c0,0-.2,0-.2.2s0,.2.2.2h6.4c0,0,.2,0,.2-.2s0-.2-.2-.2Z"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M849.4,296h-6.4c-.1,0-.2,0-.2.2s0,.2.2.2h6.4c.1,0,.2,0,.2-.2s0-.2-.2-.2Z"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M834.4,298.8h6.4c0,0,.2,0,.2-.2s0-.2-.2-.2h-6.4c0,0-.2,0-.2.2s0,.2.2.2Z"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M834.4,298.9h6.4c.1,0,.2,0,.2-.2s0-.2-.2-.2h-6.4c-.1,0-.2,0-.2.2s0,.2.2.2Z"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M849.4,298.5h-6.4c0,0-.2,0-.2.2s0,.2.2.2h6.4c0,0,.2,0,.2-.2s0-.2-.2-.2Z"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M849.4,298.4h-6.4c-.1,0-.2,0-.2.2s0,.2.2.2h6.4c.1,0,.2,0,.2-.2s0-.2-.2-.2Z"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M834.4,301.2h6.4c0,0,.2,0,.2-.2s0-.2-.2-.2h-6.4c0,0-.2,0-.2.2s0,.2.2.2Z"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M834.4,301.3h6.4c.1,0,.2,0,.2-.2s0-.2-.2-.2h-6.4c-.1,0-.2,0-.2.2s0,.2.2.2Z"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M849.4,300.9h-6.4c0,0-.2,0-.2.2s0,.2.2.2h6.4c0,0,.2,0,.2-.2s0-.2-.2-.2Z"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M849.4,300.9h-6.4c-.1,0-.2,0-.2.2s0,.2.2.2h6.4c.1,0,.2,0,.2-.2s0-.2-.2-.2Z"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M834.4,303.6h6.4c0,0,.2,0,.2-.2s0-.2-.2-.2h-6.4c0,0-.2,0-.2.2s0,.2.2.2Z"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M834.4,303.7h6.4c.1,0,.2,0,.2-.2s0-.2-.2-.2h-6.4c-.1,0-.2,0-.2.2s0,.2.2.2Z"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M849.4,303.3h-6.4c0,0-.2,0-.2.2s0,.2.2.2h6.4c0,0,.2,0,.2-.2s0-.2-.2-.2Z"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M849.4,303.3h-6.4c-.1,0-.2,0-.2.2s0,.2.2.2h6.4c.1,0,.2,0,.2-.2s0-.2-.2-.2Z"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M834.4,306h6.4c0,0,.2,0,.2-.2s0-.2-.2-.2h-6.4c0,0-.2,0-.2.2s0,.2.2.2Z"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M834.4,306h6.4c.1,0,.2,0,.2-.2s0-.2-.2-.2h-6.4c-.1,0-.2,0-.2.2s0,.2.2.2Z"
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M849.4,305.6h-6.4c0,0-.2,0-.2.2s0,.2.2.2h6.4c0,0,.2,0,.2-.2s0-.2-.2-.2Z"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M849.4,305.6h-6.4c-.1,0-.2,0-.2.2s0,.2.2.2h6.4c.1,0,.2,0,.2-.2s0-.2-.2-.2Z"
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M834.2,145.1v57.7"
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M841.9,111.7c0-.2-.1-.3-.3-.2-1.1.2-1.9,1.2-1.9,2.4s1.1,2.4,2.4,2.4,2.4-1.1,2.4-2.4-.9-2.2-2.1-2.4c-.1,0-.3,0-.3.2v1.3c0,0,0,.1-.1.1s-.1,0-.1-.1v-1.3h0Z"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M838.8,110.8l.9.9"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M840.9,109.8l.2,1.2"
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M843.2,109.8l-.2,1.2"
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M845,110.8l-.7.9"
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M841.9,237.4c1.8,0,3.3-1.5,3.3-3.3s-1.5-3.3-3.3-3.3-3.3,1.5-3.3,3.3,1.5,3.3,3.3,3.3Z"
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M839.1,125c-.9-.4-1.8-.3-2.6.2l1.6,2.2c0,0,0,.1,0,.2,0,0-.1,0-.2,0l-1.6-2.2c-.3.3-.6.6-.8,1-.6,1.3,0,2.9,1.3,3.6,1.3.6,3,0,3.6-1.3.6-1.3,0-2.9-1.3-3.6Z"
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M835.9,124.4l.2.3"
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M834.7,125.9h.3"
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M840.9,128.8h.3"
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M834.3,127.7h.3"
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M841.2,127.1h.3"
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M835,129.5l.3-.2"
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M840.6,125.5l.3-.2"
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M836.4,130.7l.2-.3"
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M839.3,124.4l.2-.3"
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M838.3,131v-.3"
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M837.7,124.2v-.4"
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M851,133.1c-.5-.8-1.3-1.3-2.2-1.3v2.7c0,0,0,.1,0,.1s-.1,0-.1-.1v-2.7c-.4,0-.9.1-1.2.4-1.3.7-1.7,2.4-1,3.7s2.4,1.7,3.7,1c1.3-.7,1.7-2.4,1-3.7h0Z"
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M848.6,130.8v.4"
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M846.8,131.3l.2.3"
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M850.3,137.3l.2.3"
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M845.5,132.6l.3.2"
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M851.5,136.1l.3.2"
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M845,134.5h.4"
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M851.9,134.5h.4"
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M845.5,136.3l.3-.2"
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M851.5,132.8l.3-.2"
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M846.8,137.6l.2-.3"
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M850.3,131.6l.2-.3"
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M847.8,265.8c0-.6-.5-1.1-1.1-1.1s-1.1.5-1.1,1.1.5,1.1,1.1,1.1,1.1-.5,1.1-1.1Z"
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M849.3,265.8c0-1.4-1.2-2.6-2.6-2.6s-2.6,1.1-2.6,2.6,1.2,2.6,2.6,2.6,2.6-1.1,2.6-2.6Z"
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M839.6,265.8c0-1.4-1.2-2.6-2.6-2.6s-2.6,1.1-2.6,2.6,1.2,2.6,2.6,2.6,2.6-1.1,2.6-2.6Z"
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M839.5,254.5c-1.6-.9-2.6-2.6-2.6-4.5s1.9-4.7,4.3-5.1"
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M842.6,244.9c2.4.4,4.3,2.5,4.3,5.1s-.9,3.3-2.2,4.3"
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M839.5,223.4c-1.6-.9-2.6-2.6-2.6-4.5s1.9-4.7,4.3-5.1"
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M842.6,213.8c2.4.4,4.3,2.5,4.3,5.1s-.9,3.3-2.2,4.3"
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M853.4,105.3v101.7"
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M853.4,212.9v11.6"
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M853.4,228.4v11.6"
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M853.4,244.4v11.6"
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M853.4,259.7v39.4"
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M853.4,302.3v25"
  })), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M857.5,281.8c0,0,0,.2.2.2h6.4c0,0,.2,0,.2-.2s0-.2-.2-.2h-6.4c0,0-.2,0-.2.2Z"
  })), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M857.4,281.8c0,.1,0,.2.2.2h6.4c.1,0,.2,0,.2-.2s0-.2-.2-.2h-6.4c-.1,0-.2,0-.2.2Z"
  })), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M872.6,281.7h-6.4c0,0-.2,0-.2.2s0,.2.2.2h6.4c0,0,.2,0,.2-.2s0-.2-.2-.2Z"
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M872.6,281.6h-6.4c-.1,0-.2,0-.2.2s0,.2.2.2h6.4c.1,0,.2,0,.2-.2s0-.2-.2-.2Z"
  })), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M857.6,284.4h6.4c0,0,.2,0,.2-.2s0-.2-.2-.2h-6.4c0,0-.2,0-.2.2s0,.2.2.2Z"
  })), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M857.6,284.4h6.4c.1,0,.2,0,.2-.2s0-.2-.2-.2h-6.4c-.1,0-.2,0-.2.2s0,.2.2.2Z"
  })), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M872.6,284.1h-6.4c0,0-.2,0-.2.2s0,.2.2.2h6.4c0,0,.2,0,.2-.2s0-.2-.2-.2Z"
  })), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M872.6,284h-6.4c-.1,0-.2,0-.2.2s0,.2.2.2h6.4c.1,0,.2,0,.2-.2s0-.2-.2-.2Z"
  })), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M857.6,286.8h6.4c0,0,.2,0,.2-.2s0-.2-.2-.2h-6.4c0,0-.2,0-.2.2s0,.2.2.2Z"
  })), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M857.6,286.8h6.4c.1,0,.2,0,.2-.2s0-.2-.2-.2h-6.4c-.1,0-.2,0-.2.2s0,.2.2.2Z"
  })), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M872.6,286.5h-6.4c0,0-.2,0-.2.2s0,.2.2.2h6.4c0,0,.2,0,.2-.2s0-.2-.2-.2Z"
  })), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M872.6,286.4h-6.4c-.1,0-.2,0-.2.2s0,.2.2.2h6.4c.1,0,.2,0,.2-.2s0-.2-.2-.2Z"
  })), _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M857.6,289.2h6.4c0,0,.2,0,.2-.2s0-.2-.2-.2h-6.4c0,0-.2,0-.2.2s0,.2.2.2Z"
  })), _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M857.6,289.2h6.4c.1,0,.2,0,.2-.2s0-.2-.2-.2h-6.4c-.1,0-.2,0-.2.2s0,.2.2.2Z"
  })), _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M872.6,288.9h-6.4c0,0-.2,0-.2.2s0,.2.2.2h6.4c0,0,.2,0,.2-.2s0-.2-.2-.2Z"
  })), _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M872.6,288.8h-6.4c-.1,0-.2,0-.2.2s0,.2.2.2h6.4c.1,0,.2,0,.2-.2s0-.2-.2-.2Z"
  })), _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M857.6,291.6h6.4c0,0,.2,0,.2-.2s0-.2-.2-.2h-6.4c0,0-.2,0-.2.2s0,.2.2.2Z"
  })), _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M857.6,291.6h6.4c.1,0,.2,0,.2-.2s0-.2-.2-.2h-6.4c-.1,0-.2,0-.2.2s0,.2.2.2Z"
  })), _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M859.4,294h11c.1,0,.3,0,.3-.2s-.1-.2-.3-.2h-11c-.1,0-.3,0-.3.2s.1.2.3.2Z"
  })), _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M859.4,294h11c0,0,.2,0,.2,0,0,0,.1,0,.1-.2s0-.1-.1-.2c0,0-.1,0-.2,0h-11c0,0-.2,0-.2,0,0,0-.1,0-.1.2s0,.1.1.2c0,0,.1,0,.2,0Z"
  })), _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M872.6,291.3h-6.4c0,0-.2,0-.2.2s0,.2.2.2h6.4c0,0,.2,0,.2-.2s0-.2-.2-.2Z"
  })), _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M872.6,291.2h-6.4c-.1,0-.2,0-.2.2s0,.2.2.2h6.4c.1,0,.2,0,.2-.2s0-.2-.2-.2Z"
  })), _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M857.6,296.4h6.4c0,0,.2,0,.2-.2s0-.2-.2-.2h-6.4c0,0-.2,0-.2.2s0,.2.2.2Z"
  })), _path386 || (_path386 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M857.6,296.5h6.4c.1,0,.2,0,.2-.2s0-.2-.2-.2h-6.4c-.1,0-.2,0-.2.2s0,.2.2.2Z"
  })), _path387 || (_path387 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M872.6,296.1h-6.4c0,0-.2,0-.2.2s0,.2.2.2h6.4c0,0,.2,0,.2-.2s0-.2-.2-.2Z"
  })), _path388 || (_path388 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M872.6,296h-6.4c-.1,0-.2,0-.2.2s0,.2.2.2h6.4c.1,0,.2,0,.2-.2s0-.2-.2-.2Z"
  })), _path389 || (_path389 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M857.6,298.8h6.4c0,0,.2,0,.2-.2s0-.2-.2-.2h-6.4c0,0-.2,0-.2.2s0,.2.2.2Z"
  })), _path390 || (_path390 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M857.6,298.9h6.4c.1,0,.2,0,.2-.2s0-.2-.2-.2h-6.4c-.1,0-.2,0-.2.2s0,.2.2.2Z"
  })), _path391 || (_path391 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M872.6,298.5h-6.4c0,0-.2,0-.2.2s0,.2.2.2h6.4c0,0,.2,0,.2-.2s0-.2-.2-.2Z"
  })), _path392 || (_path392 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M872.6,298.4h-6.4c-.1,0-.2,0-.2.2s0,.2.2.2h6.4c.1,0,.2,0,.2-.2s0-.2-.2-.2Z"
  })), _path393 || (_path393 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M857.6,301.2h6.4c0,0,.2,0,.2-.2s0-.2-.2-.2h-6.4c0,0-.2,0-.2.2s0,.2.2.2Z"
  })), _path394 || (_path394 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M857.6,301.3h6.4c.1,0,.2,0,.2-.2s0-.2-.2-.2h-6.4c-.1,0-.2,0-.2.2s0,.2.2.2Z"
  })), _path395 || (_path395 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M872.6,300.9h-6.4c0,0-.2,0-.2.2s0,.2.2.2h6.4c0,0,.2,0,.2-.2s0-.2-.2-.2Z"
  })), _path396 || (_path396 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M872.6,300.9h-6.4c-.1,0-.2,0-.2.2s0,.2.2.2h6.4c.1,0,.2,0,.2-.2s0-.2-.2-.2Z"
  })), _path397 || (_path397 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M857.6,303.6h6.4c0,0,.2,0,.2-.2s0-.2-.2-.2h-6.4c0,0-.2,0-.2.2s0,.2.2.2Z"
  })), _path398 || (_path398 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M857.6,303.7h6.4c.1,0,.2,0,.2-.2s0-.2-.2-.2h-6.4c-.1,0-.2,0-.2.2s0,.2.2.2Z"
  })), _path399 || (_path399 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M872.6,303.3h-6.4c0,0-.2,0-.2.2s0,.2.2.2h6.4c0,0,.2,0,.2-.2s0-.2-.2-.2Z"
  })), _path400 || (_path400 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M872.6,303.3h-6.4c-.1,0-.2,0-.2.2s0,.2.2.2h6.4c.1,0,.2,0,.2-.2s0-.2-.2-.2Z"
  })), _path401 || (_path401 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M857.6,306h6.4c0,0,.2,0,.2-.2s0-.2-.2-.2h-6.4c0,0-.2,0-.2.2s0,.2.2.2Z"
  })), _path402 || (_path402 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M857.6,306h6.4c.1,0,.2,0,.2-.2s0-.2-.2-.2h-6.4c-.1,0-.2,0-.2.2s0,.2.2.2Z"
  })), _path403 || (_path403 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M872.6,305.6h-6.4c0,0-.2,0-.2.2s0,.2.2.2h6.4c0,0,.2,0,.2-.2s0-.2-.2-.2Z"
  })), _path404 || (_path404 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M872.6,305.6h-6.4c-.1,0-.2,0-.2.2s0,.2.2.2h6.4c.1,0,.2,0,.2-.2s0-.2-.2-.2Z"
  })), _path405 || (_path405 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M857.6,145.1v57.7"
  })), _path406 || (_path406 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M865.1,111.7c0-.2-.1-.3-.3-.2-1.1.2-1.9,1.2-1.9,2.4s1.1,2.4,2.4,2.4,2.4-1.1,2.4-2.4-.9-2.2-2.1-2.4c-.1,0-.3,0-.3.2v1.3c0,0,0,.1-.1.1s-.1,0-.1-.1v-1.3h0Z"
  })), _path407 || (_path407 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M862,110.8l.9.9"
  })), _path408 || (_path408 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M864.1,109.8l.2,1.2"
  })), _path409 || (_path409 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M866.4,109.8l-.2,1.2"
  })), _path410 || (_path410 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M868.3,110.8l-.7.9"
  })), _path411 || (_path411 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M865.1,237.4c1.8,0,3.3-1.5,3.3-3.3s-1.5-3.3-3.3-3.3-3.3,1.5-3.3,3.3,1.5,3.3,3.3,3.3Z"
  })), _path412 || (_path412 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M863.4,125.9c-.5-.8-1.4-1.2-2.3-1.2l.2,2.7c0,0,0,.1-.1.1,0,0-.1,0-.1-.1l-.2-2.7c-.4,0-.8.2-1.2.5-1.2.9-1.5,2.5-.7,3.7.9,1.2,2.5,1.5,3.8.7,1.2-.8,1.5-2.5.7-3.7h0Z"
  })), _path413 || (_path413 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M860.9,123.8v.4"
  })), _path414 || (_path414 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M859.2,124.5l.2.3"
  })), _path415 || (_path415 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M863.1,130.1l.2.3"
  })), _path416 || (_path416 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M858,125.9l.3.2"
  })), _path417 || (_path417 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M864.2,128.9h.3"
  })), _path418 || (_path418 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M857.6,127.7h.3"
  })), _path419 || (_path419 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M864.5,127.2h.4"
  })), _path420 || (_path420 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M858.2,129.5l.3-.2"
  })), _path421 || (_path421 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M863.9,125.6l.3-.2"
  })), _path422 || (_path422 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M859.7,130.7v-.3"
  })), _path423 || (_path423 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M862.6,124.5l.2-.3"
  })), _path424 || (_path424 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M959.5,125.9c-.5-.8-1.4-1.2-2.3-1.2l.2,2.7c0,0,0,.1-.1.1,0,0-.1,0-.1-.1l-.2-2.7c-.4,0-.8.2-1.2.5-1.2.9-1.5,2.5-.7,3.7.9,1.2,2.5,1.5,3.8.7,1.2-.9,1.5-2.5.7-3.7h0Z"
  })), _path425 || (_path425 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M957,123.8v.4"
  })), _path426 || (_path426 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M955.2,124.5l.2.3"
  })), _path427 || (_path427 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M959.1,130.1l.2.3"
  })), _path428 || (_path428 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M954,125.9l.3.2"
  })), _path429 || (_path429 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M960.2,128.9h.3"
  })), _path430 || (_path430 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M953.6,127.7h.3"
  })), _path431 || (_path431 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M960.5,127.2h.4"
  })), _path432 || (_path432 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M954.3,129.5l.3-.2"
  })), _path433 || (_path433 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M959.9,125.6l.3-.2"
  })), _path434 || (_path434 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M955.7,130.7v-.3"
  })), _path435 || (_path435 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M958.7,124.5l.2-.3"
  })), _path436 || (_path436 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M874.4,133.1c-.5-.8-1.3-1.3-2.2-1.3v2.7c0,0,0,.1,0,.1s-.1,0-.1-.1v-2.7c-.4,0-.9.1-1.2.4-1.3.7-1.7,2.4-1,3.7s2.4,1.7,3.7,1,1.7-2.4,1-3.7h0Z"
  })), _path437 || (_path437 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M872,130.8v.4"
  })), _path438 || (_path438 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M870.2,131.3l.2.3"
  })), _path439 || (_path439 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M873.7,137.3l.2.3"
  })), _path440 || (_path440 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M868.9,132.6l.3.2"
  })), _path441 || (_path441 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M874.9,136.1l.3.2"
  })), _path442 || (_path442 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M868.4,134.5h.4"
  })), _path443 || (_path443 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M875.3,134.5h.3"
  })), _path444 || (_path444 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M868.9,136.3l.3-.2"
  })), _path445 || (_path445 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M874.9,132.8l.3-.2"
  })), _path446 || (_path446 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M870.2,137.6l.2-.3"
  })), _path447 || (_path447 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M873.7,131.6l.2-.3"
  })), _path448 || (_path448 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M871,265.8c0-.6-.5-1.1-1.1-1.1s-1.1.5-1.1,1.1.5,1.1,1.1,1.1,1.1-.5,1.1-1.1Z"
  })), _path449 || (_path449 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M872.5,265.8c0-1.4-1.2-2.6-2.6-2.6s-2.6,1.1-2.6,2.6,1.2,2.6,2.6,2.6,2.6-1.1,2.6-2.6Z"
  })), _path450 || (_path450 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M862.8,265.8c0-1.4-1.2-2.6-2.6-2.6s-2.6,1.1-2.6,2.6,1.2,2.6,2.6,2.6,2.6-1.1,2.6-2.6Z"
  })), _path451 || (_path451 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M862.8,254.5c-1.6-.9-2.6-2.6-2.6-4.5s1.9-4.7,4.3-5.1"
  })), _path452 || (_path452 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M865.8,244.9c2.4.4,4.3,2.5,4.3,5.1s-.9,3.3-2.2,4.3"
  })), _path453 || (_path453 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M862.8,223.4c-1.6-.9-2.6-2.6-2.6-4.5s1.9-4.7,4.3-5.1"
  })), _path454 || (_path454 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M865.8,213.8c2.4.4,4.3,2.5,4.3,5.1s-.9,3.3-2.2,4.3"
  })), _path455 || (_path455 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M876.8,105.3v101.7"
  })), _path456 || (_path456 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M876.8,212.9v11.6"
  })), _path457 || (_path457 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M876.8,228.4v11.6"
  })), _path458 || (_path458 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M876.8,244.4v11.6"
  })), _path459 || (_path459 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M876.8,259.7v39.4"
  })), _path460 || (_path460 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M876.8,302.3v25"
  })), _path461 || (_path461 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M880.7,281.8c0,0,0,.2.2.2h6.4c0,0,.2,0,.2-.2s0-.2-.2-.2h-6.4c0,0-.2,0-.2.2Z"
  })), _path462 || (_path462 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M880.6,281.8c0,.1,0,.2.2.2h6.4c.1,0,.2,0,.2-.2s0-.2-.2-.2h-6.4c-.1,0-.2,0-.2.2Z"
  })), _path463 || (_path463 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M895.8,281.7h-6.4c0,0-.2,0-.2.2s0,.2.2.2h6.4c0,0,.2,0,.2-.2s0-.2-.2-.2Z"
  })), _path464 || (_path464 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M895.8,281.6h-6.4c-.1,0-.2,0-.2.2s0,.2.2.2h6.4c.1,0,.2,0,.2-.2s0-.2-.2-.2Z"
  })), _path465 || (_path465 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M880.8,284.4h6.4c0,0,.2,0,.2-.2s0-.2-.2-.2h-6.4c0,0-.2,0-.2.2s0,.2.2.2Z"
  })), _path466 || (_path466 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M880.8,284.4h6.4c.1,0,.2,0,.2-.2s0-.2-.2-.2h-6.4c-.1,0-.2,0-.2.2s0,.2.2.2Z"
  })), _path467 || (_path467 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M895.8,284.1h-6.4c0,0-.2,0-.2.2s0,.2.2.2h6.4c0,0,.2,0,.2-.2s0-.2-.2-.2Z"
  })), _path468 || (_path468 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M895.8,284h-6.4c-.1,0-.2,0-.2.2s0,.2.2.2h6.4c.1,0,.2,0,.2-.2s0-.2-.2-.2Z"
  })), _path469 || (_path469 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M880.8,286.8h6.4c0,0,.2,0,.2-.2s0-.2-.2-.2h-6.4c0,0-.2,0-.2.2s0,.2.2.2Z"
  })), _path470 || (_path470 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M880.8,286.8h6.4c.1,0,.2,0,.2-.2s0-.2-.2-.2h-6.4c-.1,0-.2,0-.2.2s0,.2.2.2Z"
  })), _path471 || (_path471 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M895.8,286.5h-6.4c0,0-.2,0-.2.2s0,.2.2.2h6.4c0,0,.2,0,.2-.2s0-.2-.2-.2Z"
  })), _path472 || (_path472 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M895.8,286.4h-6.4c-.1,0-.2,0-.2.2s0,.2.2.2h6.4c.1,0,.2,0,.2-.2s0-.2-.2-.2Z"
  })), _path473 || (_path473 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M880.8,289.2h6.4c0,0,.2,0,.2-.2s0-.2-.2-.2h-6.4c0,0-.2,0-.2.2s0,.2.2.2Z"
  })), _path474 || (_path474 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M880.8,289.2h6.4c.1,0,.2,0,.2-.2s0-.2-.2-.2h-6.4c-.1,0-.2,0-.2.2s0,.2.2.2Z"
  })), _path475 || (_path475 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M895.8,288.9h-6.4c0,0-.2,0-.2.2s0,.2.2.2h6.4c0,0,.2,0,.2-.2s0-.2-.2-.2Z"
  })), _path476 || (_path476 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M895.8,288.8h-6.4c-.1,0-.2,0-.2.2s0,.2.2.2h6.4c.1,0,.2,0,.2-.2s0-.2-.2-.2Z"
  })), _path477 || (_path477 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M880.8,291.6h6.4c0,0,.2,0,.2-.2s0-.2-.2-.2h-6.4c0,0-.2,0-.2.2s0,.2.2.2Z"
  })), _path478 || (_path478 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M880.8,291.6h6.4c.1,0,.2,0,.2-.2s0-.2-.2-.2h-6.4c-.1,0-.2,0-.2.2s0,.2.2.2Z"
  })), _path479 || (_path479 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M882.6,294h11c.1,0,.3,0,.3-.2s-.1-.2-.3-.2h-11c-.1,0-.3,0-.3.2s.1.2.3.2Z"
  })), _path480 || (_path480 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M882.6,294h11c0,0,.2,0,.2,0,0,0,.1,0,.1-.2s0-.1-.1-.2c0,0-.1,0-.2,0h-11c0,0-.2,0-.2,0,0,0-.1,0-.1.2s0,.1.1.2c0,0,.1,0,.2,0Z"
  })), _path481 || (_path481 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M895.8,291.3h-6.4c0,0-.2,0-.2.2s0,.2.2.2h6.4c0,0,.2,0,.2-.2s0-.2-.2-.2Z"
  })), _path482 || (_path482 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M895.8,291.2h-6.4c-.1,0-.2,0-.2.2s0,.2.2.2h6.4c.1,0,.2,0,.2-.2s0-.2-.2-.2Z"
  })), _path483 || (_path483 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M880.8,296.4h6.4c0,0,.2,0,.2-.2s0-.2-.2-.2h-6.4c0,0-.2,0-.2.2s0,.2.2.2Z"
  })), _path484 || (_path484 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M880.8,296.5h6.4c.1,0,.2,0,.2-.2s0-.2-.2-.2h-6.4c-.1,0-.2,0-.2.2s0,.2.2.2Z"
  })), _path485 || (_path485 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M895.8,296.1h-6.4c0,0-.2,0-.2.2s0,.2.2.2h6.4c0,0,.2,0,.2-.2s0-.2-.2-.2Z"
  })), _path486 || (_path486 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M895.8,296h-6.4c-.1,0-.2,0-.2.2s0,.2.2.2h6.4c.1,0,.2,0,.2-.2s0-.2-.2-.2Z"
  })), _path487 || (_path487 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M880.8,298.8h6.4c0,0,.2,0,.2-.2s0-.2-.2-.2h-6.4c0,0-.2,0-.2.2s0,.2.2.2Z"
  })), _path488 || (_path488 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M880.8,298.9h6.4c.1,0,.2,0,.2-.2s0-.2-.2-.2h-6.4c-.1,0-.2,0-.2.2s0,.2.2.2Z"
  })), _path489 || (_path489 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M895.8,298.5h-6.4c0,0-.2,0-.2.2s0,.2.2.2h6.4c0,0,.2,0,.2-.2s0-.2-.2-.2Z"
  })), _path490 || (_path490 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M895.8,298.4h-6.4c-.1,0-.2,0-.2.2s0,.2.2.2h6.4c.1,0,.2,0,.2-.2s0-.2-.2-.2Z"
  })), _path491 || (_path491 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M880.8,301.2h6.4c0,0,.2,0,.2-.2s0-.2-.2-.2h-6.4c0,0-.2,0-.2.2s0,.2.2.2Z"
  })), _path492 || (_path492 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M880.8,301.3h6.4c.1,0,.2,0,.2-.2s0-.2-.2-.2h-6.4c-.1,0-.2,0-.2.2s0,.2.2.2Z"
  })), _path493 || (_path493 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M895.8,300.9h-6.4c0,0-.2,0-.2.2s0,.2.2.2h6.4c0,0,.2,0,.2-.2s0-.2-.2-.2Z"
  })), _path494 || (_path494 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M895.8,300.9h-6.4c-.1,0-.2,0-.2.2s0,.2.2.2h6.4c.1,0,.2,0,.2-.2s0-.2-.2-.2Z"
  })), _path495 || (_path495 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M880.8,303.6h6.4c0,0,.2,0,.2-.2s0-.2-.2-.2h-6.4c0,0-.2,0-.2.2s0,.2.2.2Z"
  })), _path496 || (_path496 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M880.8,303.7h6.4c.1,0,.2,0,.2-.2s0-.2-.2-.2h-6.4c-.1,0-.2,0-.2.2s0,.2.2.2Z"
  })), _path497 || (_path497 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M895.8,303.3h-6.4c0,0-.2,0-.2.2s0,.2.2.2h6.4c0,0,.2,0,.2-.2s0-.2-.2-.2Z"
  })), _path498 || (_path498 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M895.8,303.3h-6.4c-.1,0-.2,0-.2.2s0,.2.2.2h6.4c.1,0,.2,0,.2-.2s0-.2-.2-.2Z"
  })), _path499 || (_path499 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M880.8,306h6.4c0,0,.2,0,.2-.2s0-.2-.2-.2h-6.4c0,0-.2,0-.2.2s0,.2.2.2Z"
  })), _path500 || (_path500 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M880.8,306h6.4c.1,0,.2,0,.2-.2s0-.2-.2-.2h-6.4c-.1,0-.2,0-.2.2s0,.2.2.2Z"
  })), _path501 || (_path501 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M895.8,305.6h-6.4c0,0-.2,0-.2.2s0,.2.2.2h6.4c0,0,.2,0,.2-.2s0-.2-.2-.2Z"
  })), _path502 || (_path502 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M895.8,305.6h-6.4c-.1,0-.2,0-.2.2s0,.2.2.2h6.4c.1,0,.2,0,.2-.2s0-.2-.2-.2Z"
  })), _path503 || (_path503 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M881,145.1v57.7"
  })), _path504 || (_path504 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M888.3,111.7c0-.2-.1-.3-.3-.2-1.1.2-1.9,1.2-1.9,2.4s1.1,2.4,2.4,2.4,2.4-1.1,2.4-2.4-.9-2.2-2.1-2.4c-.1,0-.3,0-.3.2v1.3c0,0,0,.1-.1.1s-.1,0-.1-.1v-1.3h0Z"
  })), _path505 || (_path505 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M885.2,110.8l.9.9"
  })), _path506 || (_path506 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M887.3,109.8l.2,1.2"
  })), _path507 || (_path507 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M889.6,109.8l-.2,1.2"
  })), _path508 || (_path508 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M891.5,110.8l-.7.9"
  })), _path509 || (_path509 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M888.3,237.4c1.8,0,3.3-1.5,3.3-3.3s-1.5-3.3-3.3-3.3-3.3,1.5-3.3,3.3,1.5,3.3,3.3,3.3Z"
  })), _path510 || (_path510 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M883.5,124.9c-.8.5-1.3,1.3-1.3,2.2h2.7c0,0,.1,0,.1,0s0,.1-.1.1h-2.7c0,.4.1.9.4,1.2.7,1.3,2.4,1.7,3.7,1,1.3-.7,1.7-2.4,1-3.7-.7-1.3-2.4-1.7-3.7-1h0Z"
  })), _path511 || (_path511 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M881.2,127.2h.4"
  })), _path512 || (_path512 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M881.7,129l.3-.2"
  })), _path513 || (_path513 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M887.7,125.6l.3-.2"
  })), _path514 || (_path514 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M883,130.3l.2-.3"
  })), _path515 || (_path515 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M886.5,124.4l.2-.3"
  })), _path516 || (_path516 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M884.9,130.8v-.4"
  })), _path517 || (_path517 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M884.9,123.9v-.4"
  })), _path518 || (_path518 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M886.7,130.3l-.2-.3"
  })), _path519 || (_path519 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M883.2,124.4l-.2-.3"
  })), _path520 || (_path520 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M888,129l-.3-.2"
  })), _path521 || (_path521 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M882,125.6l-.3-.2"
  })), _path522 || (_path522 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M897.8,133.1c-.5-.8-1.3-1.3-2.2-1.3v2.7c0,0,0,.1,0,.1s-.1,0-.1-.1v-2.7c-.4,0-.9.1-1.2.4-1.3.7-1.7,2.4-1,3.7s2.4,1.7,3.7,1c1.3-.7,1.7-2.4,1-3.7h0Z"
  })), _path523 || (_path523 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M895.4,130.8v.4"
  })), _path524 || (_path524 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M893.6,131.3l.2.3"
  })), _path525 || (_path525 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M897.1,137.3l.2.3"
  })), _path526 || (_path526 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M892.3,132.6l.3.2"
  })), _path527 || (_path527 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M898.3,136.1l.3.2"
  })), _path528 || (_path528 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M891.8,134.5h.3"
  })), _path529 || (_path529 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M898.7,134.5h.4"
  })), _path530 || (_path530 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M892.3,136.3l.3-.2"
  })), _path531 || (_path531 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M898.3,132.8l.3-.2"
  })), _path532 || (_path532 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M893.6,137.6l.2-.3"
  })), _path533 || (_path533 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M897.1,131.6l.2-.3"
  })), _path534 || (_path534 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M894.2,265.8c0-.6-.5-1.1-1.1-1.1s-1.1.5-1.1,1.1.5,1.1,1.1,1.1,1.1-.5,1.1-1.1Z"
  })), _path535 || (_path535 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M895.8,265.8c0-1.4-1.2-2.6-2.6-2.6s-2.6,1.1-2.6,2.6,1.2,2.6,2.6,2.6,2.6-1.1,2.6-2.6Z"
  })), _path536 || (_path536 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M886.1,265.8c0-1.4-1.2-2.6-2.6-2.6s-2.6,1.1-2.6,2.6,1.2,2.6,2.6,2.6,2.6-1.1,2.6-2.6Z"
  })), _path537 || (_path537 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M886,254.5c-1.6-.9-2.6-2.6-2.6-4.5s1.9-4.7,4.3-5.1"
  })), _path538 || (_path538 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M889.1,244.9c2.4.4,4.3,2.5,4.3,5.1s-.9,3.3-2.2,4.3"
  })), _path539 || (_path539 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M886,222.9c-1.6-.9-2.6-2.6-2.6-4.5s1.9-4.7,4.3-5.1"
  })), _path540 || (_path540 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M889.1,213.3c2.4.4,4.3,2.5,4.3,5.1s-.9,3.3-2.2,4.3"
  })), _path541 || (_path541 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M900.2,105.3v101.7"
  })), _path542 || (_path542 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M900.2,212.9v11.6"
  })), _path543 || (_path543 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M900.2,228.4v11.6"
  })), _path544 || (_path544 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M900.2,244.4v11.6"
  })), _path545 || (_path545 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M900.2,259.7v39.4"
  })), _path546 || (_path546 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M900.2,302.3v25"
  })), _path547 || (_path547 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M903.9,281.8c0,0,0,.2.2.2h6.4c0,0,.2,0,.2-.2s0-.2-.2-.2h-6.4c0,0-.2,0-.2.2Z"
  })), _path548 || (_path548 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M903.9,281.8c0,.1,0,.2.2.2h6.4c.1,0,.2,0,.2-.2s0-.2-.2-.2h-6.4c-.1,0-.2,0-.2.2Z"
  })), _path549 || (_path549 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M919.1,281.7h-6.4c0,0-.2,0-.2.2s0,.2.2.2h6.4c0,0,.2,0,.2-.2s0-.2-.2-.2Z"
  })), _path550 || (_path550 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M919.1,281.6h-6.4c-.1,0-.2,0-.2.2s0,.2.2.2h6.4c.1,0,.2,0,.2-.2s0-.2-.2-.2Z"
  })), _path551 || (_path551 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M904.1,284.4h6.4c0,0,.2,0,.2-.2s0-.2-.2-.2h-6.4c0,0-.2,0-.2.2s0,.2.2.2Z"
  })), _path552 || (_path552 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M904.1,284.4h6.4c.1,0,.2,0,.2-.2s0-.2-.2-.2h-6.4c-.1,0-.2,0-.2.2s0,.2.2.2Z"
  })), _path553 || (_path553 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M919.1,284.1h-6.4c0,0-.2,0-.2.2s0,.2.2.2h6.4c0,0,.2,0,.2-.2s0-.2-.2-.2Z"
  })), _path554 || (_path554 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M919.1,284h-6.4c-.1,0-.2,0-.2.2s0,.2.2.2h6.4c.1,0,.2,0,.2-.2s0-.2-.2-.2Z"
  })), _path555 || (_path555 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M904.1,286.8h6.4c0,0,.2,0,.2-.2s0-.2-.2-.2h-6.4c0,0-.2,0-.2.2s0,.2.2.2Z"
  })), _path556 || (_path556 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M904.1,286.8h6.4c.1,0,.2,0,.2-.2s0-.2-.2-.2h-6.4c-.1,0-.2,0-.2.2s0,.2.2.2Z"
  })), _path557 || (_path557 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M919.1,286.5h-6.4c0,0-.2,0-.2.2s0,.2.2.2h6.4c0,0,.2,0,.2-.2s0-.2-.2-.2Z"
  })), _path558 || (_path558 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M919.1,286.4h-6.4c-.1,0-.2,0-.2.2s0,.2.2.2h6.4c.1,0,.2,0,.2-.2s0-.2-.2-.2Z"
  })), _path559 || (_path559 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M904.1,289.2h6.4c0,0,.2,0,.2-.2s0-.2-.2-.2h-6.4c0,0-.2,0-.2.2s0,.2.2.2Z"
  })), _path560 || (_path560 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M904.1,289.2h6.4c.1,0,.2,0,.2-.2s0-.2-.2-.2h-6.4c-.1,0-.2,0-.2.2s0,.2.2.2Z"
  })), _path561 || (_path561 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M919.1,288.9h-6.4c0,0-.2,0-.2.2s0,.2.2.2h6.4c0,0,.2,0,.2-.2s0-.2-.2-.2Z"
  })), _path562 || (_path562 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M919.1,288.8h-6.4c-.1,0-.2,0-.2.2s0,.2.2.2h6.4c.1,0,.2,0,.2-.2s0-.2-.2-.2Z"
  })), _path563 || (_path563 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M904.1,291.6h6.4c0,0,.2,0,.2-.2s0-.2-.2-.2h-6.4c0,0-.2,0-.2.2s0,.2.2.2Z"
  })), _path564 || (_path564 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M904.1,291.6h6.4c.1,0,.2,0,.2-.2s0-.2-.2-.2h-6.4c-.1,0-.2,0-.2.2s0,.2.2.2Z"
  })), _path565 || (_path565 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M905.8,294h11c.1,0,.3,0,.3-.2s-.1-.2-.3-.2h-11c-.1,0-.3,0-.3.2s.1.2.3.2Z"
  })), _path566 || (_path566 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M905.8,294h11c0,0,.2,0,.2,0,0,0,.1,0,.1-.2s0-.1-.1-.2c0,0-.1,0-.2,0h-11c0,0-.2,0-.2,0,0,0-.1,0-.1.2s0,.1.1.2c0,0,.1,0,.2,0Z"
  })), _path567 || (_path567 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M919.1,291.3h-6.4c0,0-.2,0-.2.2s0,.2.2.2h6.4c0,0,.2,0,.2-.2s0-.2-.2-.2Z"
  })), _path568 || (_path568 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M919.1,291.2h-6.4c-.1,0-.2,0-.2.2s0,.2.2.2h6.4c.1,0,.2,0,.2-.2s0-.2-.2-.2Z"
  })), _path569 || (_path569 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M904.1,296.4h6.4c0,0,.2,0,.2-.2s0-.2-.2-.2h-6.4c0,0-.2,0-.2.2s0,.2.2.2Z"
  })), _path570 || (_path570 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M904.1,296.5h6.4c.1,0,.2,0,.2-.2s0-.2-.2-.2h-6.4c-.1,0-.2,0-.2.2s0,.2.2.2Z"
  })), _path571 || (_path571 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M919.1,296.1h-6.4c0,0-.2,0-.2.2s0,.2.2.2h6.4c0,0,.2,0,.2-.2s0-.2-.2-.2Z"
  })), _path572 || (_path572 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M919.1,296h-6.4c-.1,0-.2,0-.2.2s0,.2.2.2h6.4c.1,0,.2,0,.2-.2s0-.2-.2-.2Z"
  })), _path573 || (_path573 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M904.1,298.8h6.4c0,0,.2,0,.2-.2s0-.2-.2-.2h-6.4c0,0-.2,0-.2.2s0,.2.2.2Z"
  })), _path574 || (_path574 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M904.1,298.9h6.4c.1,0,.2,0,.2-.2s0-.2-.2-.2h-6.4c-.1,0-.2,0-.2.2s0,.2.2.2Z"
  })), _path575 || (_path575 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M919.1,298.5h-6.4c0,0-.2,0-.2.2s0,.2.2.2h6.4c0,0,.2,0,.2-.2s0-.2-.2-.2Z"
  })), _path576 || (_path576 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M919.1,298.4h-6.4c-.1,0-.2,0-.2.2s0,.2.2.2h6.4c.1,0,.2,0,.2-.2s0-.2-.2-.2Z"
  })), _path577 || (_path577 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M904.1,301.2h6.4c0,0,.2,0,.2-.2s0-.2-.2-.2h-6.4c0,0-.2,0-.2.2s0,.2.2.2Z"
  })), _path578 || (_path578 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M904.1,301.3h6.4c.1,0,.2,0,.2-.2s0-.2-.2-.2h-6.4c-.1,0-.2,0-.2.2s0,.2.2.2Z"
  })), _path579 || (_path579 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M919.1,300.9h-6.4c0,0-.2,0-.2.2s0,.2.2.2h6.4c0,0,.2,0,.2-.2s0-.2-.2-.2Z"
  })), _path580 || (_path580 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M919.1,300.9h-6.4c-.1,0-.2,0-.2.2s0,.2.2.2h6.4c.1,0,.2,0,.2-.2s0-.2-.2-.2Z"
  })), _path581 || (_path581 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M904.1,303.6h6.4c0,0,.2,0,.2-.2s0-.2-.2-.2h-6.4c0,0-.2,0-.2.2s0,.2.2.2Z"
  })), _path582 || (_path582 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M904.1,303.7h6.4c.1,0,.2,0,.2-.2s0-.2-.2-.2h-6.4c-.1,0-.2,0-.2.2s0,.2.2.2Z"
  })), _path583 || (_path583 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M919.1,303.3h-6.4c0,0-.2,0-.2.2s0,.2.2.2h6.4c0,0,.2,0,.2-.2s0-.2-.2-.2Z"
  })), _path584 || (_path584 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M919.1,303.3h-6.4c-.1,0-.2,0-.2.2s0,.2.2.2h6.4c.1,0,.2,0,.2-.2s0-.2-.2-.2Z"
  })), _path585 || (_path585 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M904.1,306h6.4c0,0,.2,0,.2-.2s0-.2-.2-.2h-6.4c0,0-.2,0-.2.2s0,.2.2.2Z"
  })), _path586 || (_path586 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M904.1,306h6.4c.1,0,.2,0,.2-.2s0-.2-.2-.2h-6.4c-.1,0-.2,0-.2.2s0,.2.2.2Z"
  })), _path587 || (_path587 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M919.1,305.6h-6.4c0,0-.2,0-.2.2s0,.2.2.2h6.4c0,0,.2,0,.2-.2s0-.2-.2-.2Z"
  })), _path588 || (_path588 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M919.1,305.6h-6.4c-.1,0-.2,0-.2.2s0,.2.2.2h6.4c.1,0,.2,0,.2-.2s0-.2-.2-.2Z"
  })), _path589 || (_path589 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M904.4,145.1v57.7"
  })), _path590 || (_path590 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M911.5,111.7c0-.2-.1-.3-.3-.2-1.1.2-1.9,1.2-1.9,2.4s1.1,2.4,2.4,2.4,2.4-1.1,2.4-2.4-.9-2.2-2.1-2.4c-.1,0-.3,0-.3.2v1.3c0,0,0,.1-.1.1s-.1,0-.1-.1v-1.3h0Z"
  })), _path591 || (_path591 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M908.4,110.8l.9.9"
  })), _path592 || (_path592 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M910.5,109.8l.2,1.2"
  })), _path593 || (_path593 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M912.8,109.8l-.2,1.2"
  })), _path594 || (_path594 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M914.7,110.8l-.7.9"
  })), _path595 || (_path595 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M911.6,237.4c1.8,0,3.3-1.5,3.3-3.3s-1.5-3.3-3.3-3.3-3.3,1.5-3.3,3.3,1.5,3.3,3.3,3.3Z"
  })), _path596 || (_path596 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M910,125.6c-.6-.7-1.6-1-2.5-.8l.6,2.7c0,0,0,.1,0,.1,0,0-.1,0-.1,0l-.6-2.7c-.4.1-.8.3-1.1.6-1.1,1-1.2,2.7-.1,3.8,1,1.1,2.7,1.2,3.8.1,1.1-1,1.2-2.7.1-3.8h0Z"
  })), _path597 || (_path597 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M907.3,123.9v.3"
  })), _path598 || (_path598 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M905.6,124.8l.2.3"
  })), _path599 || (_path599 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M910.3,129.9l.2.3"
  })), _path600 || (_path600 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M904.6,126.4h.3"
  })), _path601 || (_path601 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M911.2,128.4h.3"
  })), _path602 || (_path602 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M904.5,128.2h.3"
  })), _path603 || (_path603 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M911.3,126.7h.3"
  })), _path604 || (_path604 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M905.4,129.9l.3-.2"
  })), _path605 || (_path605 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M910.5,125.2l.3-.2"
  })), _path606 || (_path606 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M907,130.9v-.3"
  })), _path607 || (_path607 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M909,124.3v-.3"
  })), _path608 || (_path608 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M921.2,133.1c-.5-.8-1.3-1.3-2.2-1.3v2.7c0,0,0,.1,0,.1s-.1,0-.1-.1v-2.7c-.4,0-.9.1-1.2.4-1.3.7-1.7,2.4-1,3.7.7,1.3,2.4,1.7,3.7,1,1.3-.7,1.7-2.4,1-3.7h0Z"
  })), _path609 || (_path609 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M918.8,130.8v.4"
  })), _path610 || (_path610 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M917,131.3l.2.3"
  })), _path611 || (_path611 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M920.5,137.3l.2.3"
  })), _path612 || (_path612 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M915.7,132.6l.3.2"
  })), _path613 || (_path613 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M921.7,136.1l.3.2"
  })), _path614 || (_path614 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M915.2,134.5h.4"
  })), _path615 || (_path615 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M922.1,134.5h.4"
  })), _path616 || (_path616 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M915.7,136.3l.3-.2"
  })), _path617 || (_path617 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M921.7,132.8l.3-.2"
  })), _path618 || (_path618 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M917,137.6l.2-.3"
  })), _path619 || (_path619 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M920.5,131.6l.2-.3"
  })), _path620 || (_path620 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M917.5,265.8c0-.6-.5-1.1-1.1-1.1s-1.1.5-1.1,1.1.5,1.1,1.1,1.1,1.1-.5,1.1-1.1Z"
  })), _path621 || (_path621 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M919,265.8c0-1.4-1.2-2.6-2.6-2.6s-2.6,1.1-2.6,2.6,1.2,2.6,2.6,2.6,2.6-1.1,2.6-2.6Z"
  })), _path622 || (_path622 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M909.3,265.8c0-1.4-1.2-2.6-2.6-2.6s-2.6,1.1-2.6,2.6,1.2,2.6,2.6,2.6,2.6-1.1,2.6-2.6Z"
  })), _path623 || (_path623 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M909.2,254.5c-1.6-.9-2.6-2.6-2.6-4.5s1.9-4.7,4.3-5.1"
  })), _path624 || (_path624 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M912.3,244.9c2.4.4,4.3,2.5,4.3,5.1s-.9,3.3-2.2,4.3"
  })), _path625 || (_path625 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M909.2,223.4c-1.6-.9-2.6-2.6-2.6-4.5s1.9-4.7,4.3-5.1"
  })), _path626 || (_path626 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M912.3,213.8c2.4.4,4.3,2.5,4.3,5.1s-.9,3.3-2.2,4.3"
  })), _path627 || (_path627 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M923.6,105.3v101.7"
  })), _path628 || (_path628 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M993.8,105.3v97.5"
  })), _path629 || (_path629 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M947.6,105.3v241.7"
  })), _path630 || (_path630 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M967.6,105.3v241.7"
  })), _path631 || (_path631 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M923.6,212.9v11.6"
  })), _path632 || (_path632 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M923.6,228.4v11.6"
  })), _path633 || (_path633 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M923.6,244.4v11.6"
  })), _path634 || (_path634 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M923.6,259.7v39.4"
  })), _path635 || (_path635 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M923.6,302.3v25"
  })), _path636 || (_path636 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M927.1,281.8c0,0,0,.2.2.2h6.4c0,0,.2,0,.2-.2s0-.2-.2-.2h-6.4c0,0-.2,0-.2.2Z"
  })), _path637 || (_path637 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M927.1,281.8c0,.1,0,.2.2.2h6.4c.1,0,.2,0,.2-.2s0-.2-.2-.2h-6.4c-.1,0-.2,0-.2.2Z"
  })), _path638 || (_path638 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M942.3,281.7h-6.4c0,0-.2,0-.2.2s0,.2.2.2h6.4c0,0,.2,0,.2-.2s0-.2-.2-.2Z"
  })), _path639 || (_path639 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M942.3,281.6h-6.4c-.1,0-.2,0-.2.2s0,.2.2.2h6.4c.1,0,.2,0,.2-.2s0-.2-.2-.2Z"
  })), _path640 || (_path640 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M927.3,284.4h6.4c0,0,.2,0,.2-.2s0-.2-.2-.2h-6.4c0,0-.2,0-.2.2s0,.2.2.2Z"
  })), _path641 || (_path641 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M927.3,284.4h6.4c.1,0,.2,0,.2-.2s0-.2-.2-.2h-6.4c-.1,0-.2,0-.2.2s0,.2.2.2Z"
  })), _path642 || (_path642 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M942.3,284.1h-6.4c0,0-.2,0-.2.2s0,.2.2.2h6.4c0,0,.2,0,.2-.2s0-.2-.2-.2Z"
  })), _path643 || (_path643 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M942.3,284h-6.4c-.1,0-.2,0-.2.2s0,.2.2.2h6.4c.1,0,.2,0,.2-.2s0-.2-.2-.2Z"
  })), _path644 || (_path644 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M927.3,286.8h6.4c0,0,.2,0,.2-.2s0-.2-.2-.2h-6.4c0,0-.2,0-.2.2s0,.2.2.2Z"
  })), _path645 || (_path645 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M927.3,286.8h6.4c.1,0,.2,0,.2-.2s0-.2-.2-.2h-6.4c-.1,0-.2,0-.2.2s0,.2.2.2Z"
  })), _path646 || (_path646 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M942.3,286.5h-6.4c0,0-.2,0-.2.2s0,.2.2.2h6.4c0,0,.2,0,.2-.2s0-.2-.2-.2Z"
  })), _path647 || (_path647 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M942.3,286.4h-6.4c-.1,0-.2,0-.2.2s0,.2.2.2h6.4c.1,0,.2,0,.2-.2s0-.2-.2-.2Z"
  })), _path648 || (_path648 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M927.3,289.2h6.4c0,0,.2,0,.2-.2s0-.2-.2-.2h-6.4c0,0-.2,0-.2.2s0,.2.2.2Z"
  })), _path649 || (_path649 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M927.3,289.2h6.4c.1,0,.2,0,.2-.2s0-.2-.2-.2h-6.4c-.1,0-.2,0-.2.2s0,.2.2.2Z"
  })), _path650 || (_path650 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M942.3,288.9h-6.4c0,0-.2,0-.2.2s0,.2.2.2h6.4c0,0,.2,0,.2-.2s0-.2-.2-.2Z"
  })), _path651 || (_path651 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M942.3,288.8h-6.4c-.1,0-.2,0-.2.2s0,.2.2.2h6.4c.1,0,.2,0,.2-.2s0-.2-.2-.2Z"
  })), _path652 || (_path652 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M927.3,291.6h6.4c0,0,.2,0,.2-.2s0-.2-.2-.2h-6.4c0,0-.2,0-.2.2s0,.2.2.2Z"
  })), _path653 || (_path653 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M927.3,291.6h6.4c.1,0,.2,0,.2-.2s0-.2-.2-.2h-6.4c-.1,0-.2,0-.2.2s0,.2.2.2Z"
  })), _path654 || (_path654 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M929.1,294h11c.1,0,.3,0,.3-.2s-.1-.2-.3-.2h-11c-.1,0-.3,0-.3.2s.1.2.3.2Z"
  })), _path655 || (_path655 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M929.1,294h11c0,0,.2,0,.2,0,0,0,.1,0,.1-.2s0-.1-.1-.2c0,0-.1,0-.2,0h-11c0,0-.2,0-.2,0,0,0-.1,0-.1.2s0,.1.1.2c0,0,.1,0,.2,0Z"
  })), _path656 || (_path656 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M942.3,291.3h-6.4c0,0-.2,0-.2.2s0,.2.2.2h6.4c0,0,.2,0,.2-.2s0-.2-.2-.2Z"
  })), _path657 || (_path657 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M942.3,291.2h-6.4c-.1,0-.2,0-.2.2s0,.2.2.2h6.4c.1,0,.2,0,.2-.2s0-.2-.2-.2Z"
  })), _path658 || (_path658 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M927.3,296.4h6.4c0,0,.2,0,.2-.2s0-.2-.2-.2h-6.4c0,0-.2,0-.2.2s0,.2.2.2Z"
  })), _path659 || (_path659 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M927.3,296.5h6.4c.1,0,.2,0,.2-.2s0-.2-.2-.2h-6.4c-.1,0-.2,0-.2.2s0,.2.2.2Z"
  })), _path660 || (_path660 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M942.3,296.1h-6.4c0,0-.2,0-.2.2s0,.2.2.2h6.4c0,0,.2,0,.2-.2s0-.2-.2-.2Z"
  })), _path661 || (_path661 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M942.3,296h-6.4c-.1,0-.2,0-.2.2s0,.2.2.2h6.4c.1,0,.2,0,.2-.2s0-.2-.2-.2Z"
  })), _path662 || (_path662 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M927.3,298.8h6.4c0,0,.2,0,.2-.2s0-.2-.2-.2h-6.4c0,0-.2,0-.2.2s0,.2.2.2Z"
  })), _path663 || (_path663 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M927.3,298.9h6.4c.1,0,.2,0,.2-.2s0-.2-.2-.2h-6.4c-.1,0-.2,0-.2.2s0,.2.2.2Z"
  })), _path664 || (_path664 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M942.3,298.5h-6.4c0,0-.2,0-.2.2s0,.2.2.2h6.4c0,0,.2,0,.2-.2s0-.2-.2-.2Z"
  })), _path665 || (_path665 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M942.3,298.4h-6.4c-.1,0-.2,0-.2.2s0,.2.2.2h6.4c.1,0,.2,0,.2-.2s0-.2-.2-.2Z"
  })), _path666 || (_path666 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M927.3,301.2h6.4c0,0,.2,0,.2-.2s0-.2-.2-.2h-6.4c0,0-.2,0-.2.2s0,.2.2.2Z"
  })), _path667 || (_path667 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M927.3,301.3h6.4c.1,0,.2,0,.2-.2s0-.2-.2-.2h-6.4c-.1,0-.2,0-.2.2s0,.2.2.2Z"
  })), _path668 || (_path668 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M942.3,300.9h-6.4c0,0-.2,0-.2.2s0,.2.2.2h6.4c0,0,.2,0,.2-.2s0-.2-.2-.2Z"
  })), _path669 || (_path669 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M942.3,300.9h-6.4c-.1,0-.2,0-.2.2s0,.2.2.2h6.4c.1,0,.2,0,.2-.2s0-.2-.2-.2Z"
  })), _path670 || (_path670 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M927.3,303.6h6.4c0,0,.2,0,.2-.2s0-.2-.2-.2h-6.4c0,0-.2,0-.2.2s0,.2.2.2Z"
  })), _path671 || (_path671 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M927.3,303.7h6.4c.1,0,.2,0,.2-.2s0-.2-.2-.2h-6.4c-.1,0-.2,0-.2.2s0,.2.2.2Z"
  })), _path672 || (_path672 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M942.3,303.3h-6.4c0,0-.2,0-.2.2s0,.2.2.2h6.4c0,0,.2,0,.2-.2s0-.2-.2-.2Z"
  })), _path673 || (_path673 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M942.3,303.3h-6.4c-.1,0-.2,0-.2.2s0,.2.2.2h6.4c.1,0,.2,0,.2-.2s0-.2-.2-.2Z"
  })), _path674 || (_path674 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M927.3,306h6.4c0,0,.2,0,.2-.2s0-.2-.2-.2h-6.4c0,0-.2,0-.2.2s0,.2.2.2Z"
  })), _path675 || (_path675 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M927.3,306h6.4c.1,0,.2,0,.2-.2s0-.2-.2-.2h-6.4c-.1,0-.2,0-.2.2s0,.2.2.2Z"
  })), _path676 || (_path676 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M942.3,305.6h-6.4c0,0-.2,0-.2.2s0,.2.2.2h6.4c0,0,.2,0,.2-.2s0-.2-.2-.2Z"
  })), _path677 || (_path677 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M942.3,305.6h-6.4c-.1,0-.2,0-.2.2s0,.2.2.2h6.4c.1,0,.2,0,.2-.2s0-.2-.2-.2Z"
  })), _path678 || (_path678 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M927.8,145.1v57.7"
  })), _path679 || (_path679 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M952.2,146.3v57.7"
  })), _path680 || (_path680 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M961.4,146.3v57.7"
  })), _path681 || (_path681 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M934.6,111.7c0-.2-.1-.3-.3-.2-1.1.2-1.9,1.2-1.9,2.4s1.1,2.4,2.4,2.4,2.4-1.1,2.4-2.4-.9-2.2-2.1-2.4c-.1,0-.3,0-.3.2v1.3c0,0,0,.1-.1.1s-.1,0-.1-.1v-1.3h0Z"
  })), _path682 || (_path682 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M931.6,110.8l.9.9"
  })), _path683 || (_path683 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M933.7,109.8l.2,1.2"
  })), _path684 || (_path684 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M936.1,109.8l-.2,1.2"
  })), _path685 || (_path685 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M937.9,110.8l-.7.9"
  })), _path686 || (_path686 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M934.8,237.4c1.8,0,3.3-1.5,3.3-3.3s-1.5-3.3-3.3-3.3-3.3,1.5-3.3,3.3,1.5,3.3,3.3,3.3Z"
  })), _path687 || (_path687 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M957.3,237.4c1.8,0,3.3-1.5,3.3-3.3s-1.5-3.3-3.3-3.3-3.3,1.5-3.3,3.3,1.5,3.3,3.3,3.3Z"
  })), _path688 || (_path688 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M1004.7,200.1c1.8,0,3.3-1.5,3.3-3.3s-1.5-3.3-3.3-3.3-3.3,1.5-3.3,3.3,1.5,3.3,3.3,3.3Z"
  })), _path689 || (_path689 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M930.3,124.9c-.8.5-1.3,1.3-1.3,2.2h2.7c0,0,.1,0,.1,0s0,.1-.1.1h-2.7c0,.4.1.9.4,1.2.7,1.3,2.4,1.7,3.7,1,1.3-.7,1.7-2.4,1-3.7-.7-1.3-2.4-1.7-3.7-1h0Z"
  })), _path690 || (_path690 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M928,127.2h.3"
  })), _path691 || (_path691 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M928.5,129l.3-.2"
  })), _path692 || (_path692 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M934.5,125.6l.3-.2"
  })), _path693 || (_path693 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M929.8,130.3l.2-.3"
  })), _path694 || (_path694 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M933.3,124.4l.2-.3"
  })), _path695 || (_path695 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M931.7,130.8v-.4"
  })), _path696 || (_path696 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M931.7,123.9v-.4"
  })), _path697 || (_path697 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M933.5,130.3l-.2-.3"
  })), _path698 || (_path698 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M930,124.4l-.2-.3"
  })), _path699 || (_path699 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M934.8,129l-.3-.2"
  })), _path700 || (_path700 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M928.8,125.6l-.3-.2"
  })), _path701 || (_path701 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M944.6,133.1c-.5-.8-1.3-1.3-2.2-1.3v2.7c0,0,0,.1,0,.1s-.1,0-.1-.1v-2.7c-.4,0-.9.1-1.2.4-1.3.7-1.7,2.4-1,3.7s2.4,1.7,3.7,1c1.3-.7,1.7-2.4,1-3.7h0Z"
  })), _path702 || (_path702 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M942.2,130.8v.4"
  })), _path703 || (_path703 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M940.4,131.3l.2.3"
  })), _path704 || (_path704 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M943.9,137.3l.2.3"
  })), _path705 || (_path705 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M939.1,132.6l.3.2"
  })), _path706 || (_path706 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M945.1,136.1l.3.2"
  })), _path707 || (_path707 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M938.6,134.5h.4"
  })), _path708 || (_path708 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M945.5,134.5h.3"
  })), _path709 || (_path709 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M939.1,136.3l.3-.2"
  })), _path710 || (_path710 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M945.1,132.8l.3-.2"
  })), _path711 || (_path711 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M940.4,137.6l.2-.3"
  })), _path712 || (_path712 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M943.9,131.6l.2-.3"
  })), _path713 || (_path713 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M937.1,145.2c-.5-.8-1.3-1.3-2.2-1.3v2.7c0,0,0,.1,0,.1s-.1,0-.1-.1v-2.7c-.4,0-.9.1-1.2.4-1.3.7-1.7,2.4-1,3.7s2.4,1.7,3.7,1c1.3-.7,1.7-2.4,1-3.7h0Z"
  })), _path714 || (_path714 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M934.8,143v.3"
  })), _path715 || (_path715 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M933,143.5l.2.3"
  })), _path716 || (_path716 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M936.4,149.4l.2.3"
  })), _path717 || (_path717 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M931.6,144.8l.3.2"
  })), _path718 || (_path718 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M937.6,148.2l.3.2"
  })), _path719 || (_path719 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M931.1,146.6h.4"
  })), _path720 || (_path720 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M938.1,146.6h.4"
  })), _path721 || (_path721 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M931.6,148.4l.3-.2"
  })), _path722 || (_path722 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M937.6,145l.3-.2"
  })), _path723 || (_path723 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M933,149.7l.2-.3"
  })), _path724 || (_path724 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M936.4,143.8l.2-.3"
  })), _path725 || (_path725 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M937.1,163.3c-.5-.8-1.3-1.3-2.2-1.3v2.7c0,0,0,.1,0,.1s-.1,0-.1-.1v-2.7c-.4,0-.9.1-1.2.4-1.3.7-1.7,2.4-1,3.7.7,1.3,2.4,1.7,3.7,1,1.3-.7,1.7-2.4,1-3.7h0Z"
  })), _path726 || (_path726 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M934.8,161v.3"
  })), _path727 || (_path727 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M933,161.5l.2.3"
  })), _path728 || (_path728 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M936.4,167.4l.2.3"
  })), _path729 || (_path729 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M931.6,162.8l.3.2"
  })), _path730 || (_path730 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M937.6,166.2l.3.2"
  })), _path731 || (_path731 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M931.1,164.6h.4"
  })), _path732 || (_path732 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M938.1,164.6h.4"
  })), _path733 || (_path733 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M931.6,166.4l.3-.2"
  })), _path734 || (_path734 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M937.6,163l.3-.2"
  })), _path735 || (_path735 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M933,167.8l.2-.3"
  })), _path736 || (_path736 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M936.4,161.8l.2-.3"
  })), _path737 || (_path737 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M937.1,181.3c-.5-.8-1.3-1.3-2.2-1.3v2.7c0,0,0,.1,0,.1s-.1,0-.1-.1v-2.7c-.4,0-.9.1-1.2.4-1.3.7-1.7,2.4-1,3.7.7,1.3,2.4,1.7,3.7,1,1.3-.7,1.7-2.4,1-3.7h0Z"
  })), _path738 || (_path738 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M934.8,179v.4"
  })), _path739 || (_path739 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M933,179.5l.2.3"
  })), _path740 || (_path740 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M936.4,185.5l.2.3"
  })), _path741 || (_path741 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M931.6,180.8l.3.2"
  })), _path742 || (_path742 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M937.6,184.3l.3.2"
  })), _path743 || (_path743 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M931.1,182.6h.4"
  })), _path744 || (_path744 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M938.1,182.6h.4"
  })), _path745 || (_path745 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M931.6,184.4l.3-.2"
  })), _path746 || (_path746 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M937.6,181l.3-.2"
  })), _path747 || (_path747 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M933,185.8l.2-.3"
  })), _path748 || (_path748 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M936.4,179.8l.2-.3"
  })), _path749 || (_path749 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M937.1,199.3c-.5-.8-1.3-1.3-2.2-1.3v2.7c0,0,0,.1,0,.1s-.1,0-.1-.1v-2.7c-.4,0-.9.1-1.2.4-1.3.7-1.7,2.4-1,3.7s2.4,1.7,3.7,1c1.3-.7,1.7-2.4,1-3.7h0Z"
  })), _path750 || (_path750 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M934.8,197v.4"
  })), _path751 || (_path751 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M933,197.5l.2.3"
  })), _path752 || (_path752 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M936.4,203.5l.2.3"
  })), _path753 || (_path753 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M931.6,198.8l.3.2"
  })), _path754 || (_path754 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M937.6,202.3l.3.2"
  })), _path755 || (_path755 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M931.1,200.6h.4"
  })), _path756 || (_path756 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M938.1,200.6h.4"
  })), _path757 || (_path757 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M931.6,202.5l.3-.2"
  })), _path758 || (_path758 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M937.6,199l.3-.2"
  })), _path759 || (_path759 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M933,203.8l.2-.3"
  })), _path760 || (_path760 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M936.4,197.8l.2-.3"
  })), _path761 || (_path761 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M913.9,145.2c-.5-.8-1.3-1.3-2.2-1.3v2.7c0,0,0,.1,0,.1s-.1,0-.1-.1v-2.7c-.4,0-.9.1-1.2.4-1.3.7-1.7,2.4-1,3.7s2.4,1.7,3.7,1c1.3-.7,1.7-2.4,1-3.7h0Z"
  })), _path762 || (_path762 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M911.6,143v.3"
  })), _path763 || (_path763 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M909.7,143.5l.2.3"
  })), _path764 || (_path764 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M913.2,149.4l.2.3"
  })), _path765 || (_path765 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M908.4,144.8l.3.2"
  })), _path766 || (_path766 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M914.4,148.2l.3.2"
  })), _path767 || (_path767 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M907.9,146.6h.4"
  })), _path768 || (_path768 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M914.8,146.6h.4"
  })), _path769 || (_path769 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M908.4,148.4l.3-.2"
  })), _path770 || (_path770 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M914.4,145l.3-.2"
  })), _path771 || (_path771 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M909.7,149.7l.2-.3"
  })), _path772 || (_path772 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M913.2,143.8l.2-.3"
  })), _path773 || (_path773 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M913.9,163.3c-.5-.8-1.3-1.3-2.2-1.3v2.7c0,0,0,.1,0,.1s-.1,0-.1-.1v-2.7c-.4,0-.9.1-1.2.4-1.3.7-1.7,2.4-1,3.7.7,1.3,2.4,1.7,3.7,1,1.3-.7,1.7-2.4,1-3.7h0Z"
  })), _path774 || (_path774 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M911.6,161v.3"
  })), _path775 || (_path775 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M909.7,161.5l.2.3"
  })), _path776 || (_path776 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M913.2,167.4l.2.3"
  })), _path777 || (_path777 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M908.4,162.8l.3.2"
  })), _path778 || (_path778 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M914.4,166.2l.3.2"
  })), _path779 || (_path779 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M907.9,164.6h.4"
  })), _path780 || (_path780 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M914.8,164.6h.4"
  })), _path781 || (_path781 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M908.4,166.4l.3-.2"
  })), _path782 || (_path782 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M914.4,163l.3-.2"
  })), _path783 || (_path783 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M909.7,167.8l.2-.3"
  })), _path784 || (_path784 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M913.2,161.8l.2-.3"
  })), _path785 || (_path785 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M913.9,181.3c-.5-.8-1.3-1.3-2.2-1.3v2.7c0,0,0,.1,0,.1s-.1,0-.1-.1v-2.7c-.4,0-.9.1-1.2.4-1.3.7-1.7,2.4-1,3.7.7,1.3,2.4,1.7,3.7,1,1.3-.7,1.7-2.4,1-3.7h0Z"
  })), _path786 || (_path786 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M911.6,179v.4"
  })), _path787 || (_path787 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M909.7,179.5l.2.3"
  })), _path788 || (_path788 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M913.2,185.5l.2.3"
  })), _path789 || (_path789 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M908.4,180.8l.3.2"
  })), _path790 || (_path790 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M914.4,184.3l.3.2"
  })), _path791 || (_path791 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M907.9,182.6h.4"
  })), _path792 || (_path792 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M914.8,182.6h.4"
  })), _path793 || (_path793 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M908.4,184.4l.3-.2"
  })), _path794 || (_path794 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M914.4,181l.3-.2"
  })), _path795 || (_path795 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M909.7,185.8l.2-.3"
  })), _path796 || (_path796 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M913.2,179.8l.2-.3"
  })), _path797 || (_path797 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M913.9,199.3c-.5-.8-1.3-1.3-2.2-1.3v2.7c0,0,0,.1,0,.1s-.1,0-.1-.1v-2.7c-.4,0-.9.1-1.2.4-1.3.7-1.7,2.4-1,3.7s2.4,1.7,3.7,1c1.3-.7,1.7-2.4,1-3.7h0Z"
  })), _path798 || (_path798 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M911.6,197v.4"
  })), _path799 || (_path799 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M909.7,197.5l.2.3"
  })), _path800 || (_path800 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M913.2,203.5l.2.3"
  })), _path801 || (_path801 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M908.4,198.8l.3.2"
  })), _path802 || (_path802 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M914.4,202.3l.3.2"
  })), _path803 || (_path803 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M907.9,200.6h.4"
  })), _path804 || (_path804 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M914.8,200.6h.4"
  })), _path805 || (_path805 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M908.4,202.5l.3-.2"
  })), _path806 || (_path806 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M914.4,199l.3-.2"
  })), _path807 || (_path807 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M909.7,203.8l.2-.3"
  })), _path808 || (_path808 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M913.2,197.8l.2-.3"
  })), _path809 || (_path809 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M890.7,145.2c-.5-.8-1.3-1.3-2.2-1.3v2.7c0,0,0,.1,0,.1s-.1,0-.1-.1v-2.7c-.4,0-.9.1-1.2.4-1.3.7-1.7,2.4-1,3.7.7,1.3,2.4,1.7,3.7,1,1.3-.7,1.7-2.4,1-3.7h0Z"
  })), _path810 || (_path810 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M888.3,143v.3"
  })), _path811 || (_path811 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M886.5,143.5l.2.3"
  })), _path812 || (_path812 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M890,149.4l.2.3"
  })), _path813 || (_path813 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M885.2,144.8l.3.2"
  })), _path814 || (_path814 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M891.2,148.2l.3.2"
  })), _path815 || (_path815 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M884.7,146.6h.3"
  })), _path816 || (_path816 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M891.6,146.6h.4"
  })), _path817 || (_path817 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M885.2,148.4l.3-.2"
  })), _path818 || (_path818 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M891.2,145l.3-.2"
  })), _path819 || (_path819 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M886.5,149.7l.2-.3"
  })), _path820 || (_path820 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M890,143.8l.2-.3"
  })), _path821 || (_path821 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M890.7,163.3c-.5-.8-1.3-1.3-2.2-1.3v2.7c0,0,0,.1,0,.1s-.1,0-.1-.1v-2.7c-.4,0-.9.1-1.2.4-1.3.7-1.7,2.4-1,3.7.7,1.3,2.4,1.7,3.7,1,1.3-.7,1.7-2.4,1-3.7h0Z"
  })), _path822 || (_path822 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M888.3,161v.3"
  })), _path823 || (_path823 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M886.5,161.5l.2.3"
  })), _path824 || (_path824 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M890,167.4l.2.3"
  })), _path825 || (_path825 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M885.2,162.8l.3.2"
  })), _path826 || (_path826 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M891.2,166.2l.3.2"
  })), _path827 || (_path827 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M884.7,164.6h.3"
  })), _path828 || (_path828 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M891.6,164.6h.4"
  })), _path829 || (_path829 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M885.2,166.4l.3-.2"
  })), _path830 || (_path830 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M891.2,163l.3-.2"
  })), _path831 || (_path831 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M886.5,167.8l.2-.3"
  })), _path832 || (_path832 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M890,161.8l.2-.3"
  })), _path833 || (_path833 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M890.7,181.3c-.5-.8-1.3-1.3-2.2-1.3v2.7c0,0,0,.1,0,.1s-.1,0-.1-.1v-2.7c-.4,0-.9.1-1.2.4-1.3.7-1.7,2.4-1,3.7.7,1.3,2.4,1.7,3.7,1,1.3-.7,1.7-2.4,1-3.7h0Z"
  })), _path834 || (_path834 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M888.3,179v.4"
  })), _path835 || (_path835 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M886.5,179.5l.2.3"
  })), _path836 || (_path836 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M890,185.5l.2.3"
  })), _path837 || (_path837 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M885.2,180.8l.3.2"
  })), _path838 || (_path838 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M891.2,184.3l.3.2"
  })), _path839 || (_path839 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M884.7,182.6h.3"
  })), _path840 || (_path840 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M891.6,182.6h.4"
  })), _path841 || (_path841 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M885.2,184.4l.3-.2"
  })), _path842 || (_path842 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M891.2,181l.3-.2"
  })), _path843 || (_path843 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M886.5,185.8l.2-.3"
  })), _path844 || (_path844 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M890,179.8l.2-.3"
  })), _path845 || (_path845 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M890.7,199.3c-.5-.8-1.3-1.3-2.2-1.3v2.7c0,0,0,.1,0,.1s-.1,0-.1-.1v-2.7c-.4,0-.9.1-1.2.4-1.3.7-1.7,2.4-1,3.7.7,1.3,2.4,1.7,3.7,1,1.3-.7,1.7-2.4,1-3.7h0Z"
  })), _path846 || (_path846 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M888.3,197v.4"
  })), _path847 || (_path847 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M886.5,197.5l.2.3"
  })), _path848 || (_path848 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M890,203.5l.2.3"
  })), _path849 || (_path849 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M885.2,198.8l.3.2"
  })), _path850 || (_path850 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M891.2,202.3l.3.2"
  })), _path851 || (_path851 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M884.7,200.6h.3"
  })), _path852 || (_path852 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M891.6,200.6h.4"
  })), _path853 || (_path853 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M885.2,202.5l.3-.2"
  })), _path854 || (_path854 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M891.2,199l.3-.2"
  })), _path855 || (_path855 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M886.5,203.8l.2-.3"
  })), _path856 || (_path856 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M890,197.8l.2-.3"
  })), _path857 || (_path857 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M867.5,145.2c-.5-.8-1.3-1.3-2.2-1.3v2.7c0,0,0,.1,0,.1s-.1,0-.1-.1v-2.7c-.4,0-.9.1-1.2.4-1.3.7-1.7,2.4-1,3.7s2.4,1.7,3.7,1c1.3-.7,1.7-2.4,1-3.7h0Z"
  })), _path858 || (_path858 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M865.1,143v.3"
  })), _path859 || (_path859 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M863.3,143.5l.2.3"
  })), _path860 || (_path860 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M866.8,149.4l.2.3"
  })), _path861 || (_path861 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M862,144.8l.3.2"
  })), _path862 || (_path862 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M868,148.2l.3.2"
  })), _path863 || (_path863 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M861.5,146.6h.3"
  })), _path864 || (_path864 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M868.4,146.6h.4"
  })), _path865 || (_path865 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M862,148.4l.3-.2"
  })), _path866 || (_path866 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M868,145l.3-.2"
  })), _path867 || (_path867 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M863.3,149.7l.2-.3"
  })), _path868 || (_path868 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M866.8,143.8l.2-.3"
  })), _path869 || (_path869 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M867.5,163.3c-.5-.8-1.3-1.3-2.2-1.3v2.7c0,0,0,.1,0,.1s-.1,0-.1-.1v-2.7c-.4,0-.9.1-1.2.4-1.3.7-1.7,2.4-1,3.7.7,1.3,2.4,1.7,3.7,1,1.3-.7,1.7-2.4,1-3.7h0Z"
  })), _path870 || (_path870 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M865.1,161v.3"
  })), _path871 || (_path871 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M863.3,161.5l.2.3"
  })), _path872 || (_path872 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M866.8,167.4l.2.3"
  })), _path873 || (_path873 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M862,162.8l.3.2"
  })), _path874 || (_path874 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M868,166.2l.3.2"
  })), _path875 || (_path875 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M861.5,164.6h.3"
  })), _path876 || (_path876 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M868.4,164.6h.4"
  })), _path877 || (_path877 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M862,166.4l.3-.2"
  })), _path878 || (_path878 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M868,163l.3-.2"
  })), _path879 || (_path879 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M863.3,167.8l.2-.3"
  })), _path880 || (_path880 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M866.8,161.8l.2-.3"
  })), _path881 || (_path881 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M867.5,181.3c-.5-.8-1.3-1.3-2.2-1.3v2.7c0,0,0,.1,0,.1s-.1,0-.1-.1v-2.7c-.4,0-.9.1-1.2.4-1.3.7-1.7,2.4-1,3.7.7,1.3,2.4,1.7,3.7,1,1.3-.7,1.7-2.4,1-3.7h0Z"
  })), _path882 || (_path882 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M865.1,179v.4"
  })), _path883 || (_path883 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M863.3,179.5l.2.3"
  })), _path884 || (_path884 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M866.8,185.5l.2.3"
  })), _path885 || (_path885 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M862,180.8l.3.2"
  })), _path886 || (_path886 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M868,184.3l.3.2"
  })), _path887 || (_path887 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M861.5,182.6h.3"
  })), _path888 || (_path888 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M868.4,182.6h.4"
  })), _path889 || (_path889 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M862,184.4l.3-.2"
  })), _path890 || (_path890 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M868,181l.3-.2"
  })), _path891 || (_path891 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M863.3,185.8l.2-.3"
  })), _path892 || (_path892 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M866.8,179.8l.2-.3"
  })), _path893 || (_path893 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M867.5,199.3c-.5-.8-1.3-1.3-2.2-1.3v2.7c0,0,0,.1,0,.1s-.1,0-.1-.1v-2.7c-.4,0-.9.1-1.2.4-1.3.7-1.7,2.4-1,3.7s2.4,1.7,3.7,1c1.3-.7,1.7-2.4,1-3.7h0Z"
  })), _path894 || (_path894 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M865.1,197v.4"
  })), _path895 || (_path895 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M863.3,197.5l.2.3"
  })), _path896 || (_path896 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M866.8,203.5l.2.3"
  })), _path897 || (_path897 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M862,198.8l.3.2"
  })), _path898 || (_path898 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M868,202.3l.3.2"
  })), _path899 || (_path899 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M861.5,200.6h.3"
  })), _path900 || (_path900 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M868.4,200.6h.4"
  })), _path901 || (_path901 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M862,202.5l.3-.2"
  })), _path902 || (_path902 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M868,199l.3-.2"
  })), _path903 || (_path903 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M863.3,203.8l.2-.3"
  })), _path904 || (_path904 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M866.8,197.8l.2-.3"
  })), _path905 || (_path905 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M844.2,145.2c-.5-.8-1.3-1.3-2.2-1.3v2.7c0,0,0,.1,0,.1s-.1,0-.1-.1v-2.7c-.4,0-.9.1-1.2.4-1.3.7-1.7,2.4-1,3.7s2.4,1.7,3.7,1c1.3-.7,1.7-2.4,1-3.7h0Z"
  })), _path906 || (_path906 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M841.9,143v.3"
  })), _path907 || (_path907 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M840.1,143.5l.2.3"
  })), _path908 || (_path908 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M843.5,149.4l.2.3"
  })), _path909 || (_path909 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M838.8,144.8l.3.2"
  })), _path910 || (_path910 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M844.7,148.2l.3.2"
  })), _path911 || (_path911 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M838.3,146.6h.3"
  })), _path912 || (_path912 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M845.2,146.6h.4"
  })), _path913 || (_path913 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M838.8,148.4l.3-.2"
  })), _path914 || (_path914 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M844.7,145l.3-.2"
  })), _path915 || (_path915 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M840.1,149.7l.2-.3"
  })), _path916 || (_path916 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M843.5,143.8l.2-.3"
  })), _path917 || (_path917 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M844.2,163.3c-.5-.8-1.3-1.3-2.2-1.3v2.7c0,0,0,.1,0,.1s-.1,0-.1-.1v-2.7c-.4,0-.9.1-1.2.4-1.3.7-1.7,2.4-1,3.7.7,1.3,2.4,1.7,3.7,1,1.3-.7,1.7-2.4,1-3.7h0Z"
  })), _path918 || (_path918 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M841.9,161v.3"
  })), _path919 || (_path919 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M840.1,161.5l.2.3"
  })), _path920 || (_path920 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M843.5,167.4l.2.3"
  })), _path921 || (_path921 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M838.8,162.8l.3.2"
  })), _path922 || (_path922 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M844.7,166.2l.3.2"
  })), _path923 || (_path923 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M838.3,164.6h.3"
  })), _path924 || (_path924 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M845.2,164.6h.4"
  })), _path925 || (_path925 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M838.8,166.4l.3-.2"
  })), _path926 || (_path926 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M844.7,163l.3-.2"
  })), _path927 || (_path927 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M840.1,167.8l.2-.3"
  })), _path928 || (_path928 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M843.5,161.8l.2-.3"
  })), _path929 || (_path929 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M844.2,181.3c-.5-.8-1.3-1.3-2.2-1.3v2.7c0,0,0,.1,0,.1s-.1,0-.1-.1v-2.7c-.4,0-.9.1-1.2.4-1.3.7-1.7,2.4-1,3.7.7,1.3,2.4,1.7,3.7,1,1.3-.7,1.7-2.4,1-3.7h0Z"
  })), _path930 || (_path930 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M841.9,179v.4"
  })), _path931 || (_path931 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M840.1,179.5l.2.3"
  })), _path932 || (_path932 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M843.5,185.5l.2.3"
  })), _path933 || (_path933 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M838.8,180.8l.3.2"
  })), _path934 || (_path934 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M844.7,184.3l.3.2"
  })), _path935 || (_path935 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M838.3,182.6h.3"
  })), _path936 || (_path936 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M845.2,182.6h.4"
  })), _path937 || (_path937 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M838.8,184.4l.3-.2"
  })), _path938 || (_path938 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M844.7,181l.3-.2"
  })), _path939 || (_path939 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M840.1,185.8l.2-.3"
  })), _path940 || (_path940 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M843.5,179.8l.2-.3"
  })), _path941 || (_path941 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M844.2,199.3c-.5-.8-1.3-1.3-2.2-1.3v2.7c0,0,0,.1,0,.1s-.1,0-.1-.1v-2.7c-.4,0-.9.1-1.2.4-1.3.7-1.7,2.4-1,3.7s2.4,1.7,3.7,1c1.3-.7,1.7-2.4,1-3.7h0Z"
  })), _path942 || (_path942 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M841.9,197v.4"
  })), _path943 || (_path943 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M840.1,197.5l.2.3"
  })), _path944 || (_path944 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M843.5,203.5l.2.3"
  })), _path945 || (_path945 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M838.8,198.8l.3.2"
  })), _path946 || (_path946 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M844.7,202.3l.3.2"
  })), _path947 || (_path947 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M838.3,200.6h.3"
  })), _path948 || (_path948 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M845.2,200.6h.4"
  })), _path949 || (_path949 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M838.8,202.5l.3-.2"
  })), _path950 || (_path950 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M844.7,199l.3-.2"
  })), _path951 || (_path951 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M840.1,203.8l.2-.3"
  })), _path952 || (_path952 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M843.5,197.8l.2-.3"
  })), _path953 || (_path953 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M822.2,145.3c-.4-.8-1.3-1.4-2.2-1.4v2.7c-.1,0-.2.1-.2.1s-.1,0-.1-.1v-2.7c-.3,0-.7,0-1.1.3-1.3.7-1.8,2.3-1.1,3.6.7,1.3,2.3,1.8,3.6,1.1,1.3-.7,1.8-2.3,1.1-3.6Z"
  })), _path954 || (_path954 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M820,143v.4"
  })), _path955 || (_path955 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M818.1,143.4l.2.3"
  })), _path956 || (_path956 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M821.3,149.5l.2.3"
  })), _path957 || (_path957 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M816.7,144.7l.3.2"
  })), _path958 || (_path958 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M822.6,148.4l.3.2"
  })), _path959 || (_path959 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M816.2,146.4h.3"
  })), _path960 || (_path960 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M823.1,146.8h.3"
  })), _path961 || (_path961 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M816.6,148.3l.3-.2"
  })), _path962 || (_path962 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M822.7,145.1l.3-.2"
  })), _path963 || (_path963 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M817.9,149.7l.2-.3"
  })), _path964 || (_path964 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M821.6,143.8l.2-.3"
  })), _path965 || (_path965 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M821.4,163.3c-.4-.8-1.3-1.4-2.2-1.4v2.7c-.1,0-.2.1-.2.1s-.1,0-.1-.1v-2.7c-.3,0-.7,0-1.1.3-1.3.7-1.8,2.3-1.1,3.6.7,1.3,2.3,1.8,3.6,1.1,1.3-.7,1.8-2.3,1.1-3.6Z"
  })), _path966 || (_path966 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M819.2,161v.4"
  })), _path967 || (_path967 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M817.3,161.4l.2.3"
  })), _path968 || (_path968 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M820.5,167.5l.2.3"
  })), _path969 || (_path969 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M816,162.7l.3.2"
  })), _path970 || (_path970 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M821.8,166.4l.3.2"
  })), _path971 || (_path971 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M815.4,164.4h.3"
  })), _path972 || (_path972 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M822.3,164.8h.4"
  })), _path973 || (_path973 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M815.8,166.3l.3-.2"
  })), _path974 || (_path974 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M821.9,163.1l.3-.2"
  })), _path975 || (_path975 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M817.1,167.7l.2-.3"
  })), _path976 || (_path976 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M820.8,161.9l.2-.3"
  })), _path977 || (_path977 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M820.6,181.4c-.4-.8-1.3-1.4-2.2-1.4v2.7c-.1,0-.2.1-.2.1s-.1,0-.1-.1v-2.7c-.3,0-.7,0-1.1.3-1.3.7-1.8,2.3-1.1,3.6.7,1.3,2.3,1.8,3.6,1.1,1.3-.7,1.8-2.3,1.1-3.6Z"
  })), _path978 || (_path978 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M818.4,179v.3"
  })), _path979 || (_path979 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M816.6,179.4l.2.3"
  })), _path980 || (_path980 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M819.8,185.5l.2.3"
  })), _path981 || (_path981 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M815.2,180.7l.3.2"
  })), _path982 || (_path982 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M821,184.4l.3.2"
  })), _path983 || (_path983 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M814.6,182.4h.4"
  })), _path984 || (_path984 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M821.5,182.8h.4"
  })), _path985 || (_path985 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M815,184.3l.3-.2"
  })), _path986 || (_path986 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M821.1,181.1l.3-.2"
  })), _path987 || (_path987 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M816.3,185.7l.2-.3"
  })), _path988 || (_path988 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M820,179.9l.2-.3"
  })), _path989 || (_path989 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M819.8,199.4c-.4-.8-1.3-1.4-2.2-1.4v2.7c-.1,0-.2.1-.2.1s-.1,0-.1-.1v-2.7c-.3,0-.7,0-1.1.3-1.3.7-1.8,2.3-1.1,3.6.7,1.3,2.3,1.8,3.6,1.1,1.3-.7,1.8-2.3,1.1-3.6Z"
  })), _path990 || (_path990 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M817.6,197v.4"
  })), _path991 || (_path991 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M815.8,197.4l.2.3"
  })), _path992 || (_path992 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M819,203.5l.2.3"
  })), _path993 || (_path993 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M814.4,198.7l.3.2"
  })), _path994 || (_path994 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M820.2,202.4l.3.2"
  })), _path995 || (_path995 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M813.8,200.5h.4"
  })), _path996 || (_path996 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M820.7,200.8h.4"
  })), _path997 || (_path997 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M814.2,202.3l.3-.2"
  })), _path998 || (_path998 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M820.4,199.1l.3-.2"
  })), _path999 || (_path999 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M815.5,203.7l.2-.3"
  })), _path1000 || (_path1000 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M819.2,197.8l.2-.3"
  })), _path1001 || (_path1001 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M940.7,265.8c0-.6-.5-1.1-1.1-1.1s-1.1.5-1.1,1.1.5,1.1,1.1,1.1,1.1-.5,1.1-1.1Z"
  })), _path1002 || (_path1002 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M942.2,265.8c0-1.4-1.2-2.6-2.6-2.6s-2.6,1.1-2.6,2.6,1.2,2.6,2.6,2.6,2.6-1.1,2.6-2.6Z"
  })), _path1003 || (_path1003 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M932.5,265.8c0-1.4-1.2-2.6-2.6-2.6s-2.6,1.1-2.6,2.6,1.2,2.6,2.6,2.6,2.6-1.1,2.6-2.6Z"
  })), _path1004 || (_path1004 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M963.2,245.9c0-.6-.5-1.1-1.1-1.1s-1.1.5-1.1,1.1.5,1.1,1.1,1.1,1.1-.5,1.1-1.1Z"
  })), _path1005 || (_path1005 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M964.7,245.9c0-1.4-1.2-2.6-2.6-2.6s-2.6,1.1-2.6,2.6,1.2,2.6,2.6,2.6,2.6-1.1,2.6-2.6Z"
  })), _path1006 || (_path1006 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M955,245.9c0-1.4-1.2-2.6-2.6-2.6s-2.6,1.1-2.6,2.6,1.2,2.6,2.6,2.6,2.6-1.1,2.6-2.6Z"
  })), _path1007 || (_path1007 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M932.4,254.5c-1.6-.9-2.6-2.6-2.6-4.5s1.9-4.7,4.3-5.1"
  })), _path1008 || (_path1008 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M935.5,244.9c2.4.4,4.3,2.5,4.3,5.1s-.9,3.3-2.2,4.3"
  })), _path1009 || (_path1009 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M954.9,328.2c-1.6-.9-2.6-2.6-2.6-4.5s1.9-4.7,4.3-5.1"
  })), _path1010 || (_path1010 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M958,318.6c2.4.4,4.3,2.5,4.3,5.1s-.9,3.3-2.2,4.3"
  })), _path1011 || (_path1011 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M988.9,328.2c-1.6-.9-2.6-2.6-2.6-4.5s1.9-4.7,4.3-5.1"
  })), _path1012 || (_path1012 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M992,318.6c2.4.4,4.3,2.5,4.3,5.1s-.9,3.3-2.2,4.3"
  })), _path1013 || (_path1013 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M954.9,347.6c-1.6-.9-2.6-2.6-2.6-4.5s1.9-4.7,4.3-5.1"
  })), _path1014 || (_path1014 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M958,338c2.4.4,4.3,2.5,4.3,5.1s-.9,3.3-2.2,4.3"
  })), _path1015 || (_path1015 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M932.4,223.4c-1.6-.9-2.6-2.6-2.6-4.5s1.9-4.7,4.3-5.1"
  })), _path1016 || (_path1016 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M935.5,213.8c2.4.4,4.3,2.5,4.3,5.1s-.9,3.3-2.2,4.3"
  })), _path1017 || (_path1017 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M954.9,223.5c-1.6-.9-2.6-2.6-2.6-4.5s1.9-4.7,4.3-5.1"
  })), _path1018 || (_path1018 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M958,213.9c2.4.4,4.3,2.5,4.3,5.1s-.9,3.3-2.2,4.3"
  })), _path1019 || (_path1019 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M817.2,324.7c0,0,.1,0,.1-.1v-1.9c0,0,0-.1-.1-.1s-.1,0-.1.1v1.9c0,0,0,.1.1.1Z"
  })), _path1020 || (_path1020 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M817.2,324.8c.1,0,.2,0,.2-.2v-1.9c0-.1,0-.2-.2-.2s-.2,0-.2.2v1.9c0,.1,0,.2.2.2Z"
  })), _path1021 || (_path1021 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M814.5,321.3v4.7c0,.4.3.7.7.7h6.9c.4,0,.7-.3.7-.7v-4.7c0-.4-.3-.7-.7-.7h-6.9c-.4,0-.7.3-.7.7ZM822.5,321.3v4.7c0,.3-.2.5-.5.5h-6.9c-.3,0-.5-.2-.5-.5v-4.7c0-.3.2-.5.5-.5h6.9c.3,0,.5.2.5.5Z"
  })), _path1022 || (_path1022 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M814.4,321.3v4.7c0,.4.3.8.8.8h6.9c.4,0,.8-.3.8-.8v-4.7c0-.4-.3-.8-.8-.8h-6.9c-.4,0-.8.3-.8.8ZM822.4,321.3v4.7c0,.2-.2.4-.4.4h-6.9c-.2,0-.4-.2-.4-.4v-4.7c0-.2.2-.4.4-.4h6.9c.2,0,.4.2.4.4Z"
  })), _path1023 || (_path1023 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M816.3,325.6h4.7c.4,0,.7-.3.7-.7v-2.6c0-.4-.3-.7-.7-.7h-4.7c-.4,0-.7.3-.7.7v2.6c0,.4.3.7.7.7ZM815.8,322.4c0-.3.2-.5.5-.5h4.7c.3,0,.5.2.5.5v2.6c0,.3-.2.5-.5.5h-4.7c-.3,0-.5-.2-.5-.5v-2.6Z"
  })), _path1024 || (_path1024 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M816.3,325.7h4.7c.4,0,.8-.3.8-.8v-2.6c0-.4-.3-.8-.8-.8h-4.7c-.4,0-.8.3-.8.8v2.6c0,.4.3.8.8.8ZM815.9,322.4c0-.2.2-.4.4-.4h4.7c.2,0,.4.2.4.4v2.6c0,.2-.2.4-.4.4h-4.7c-.2,0-.4-.2-.4-.4v-2.6Z"
  })), _path1025 || (_path1025 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M776.8,271.4c0,0,0-.1,0-.2,0,0-.1,0-.2,0-1,.6-1.5,1.6-1.5,2.7,0,1.7,1.4,3.1,3.1,3.1s3.1-1.4,3.1-3.1-.6-2.1-1.5-2.7c0,0-.1,0-.2,0,0,0,0,.1,0,.2.9.5,1.4,1.5,1.4,2.5,0,1.6-1.3,2.9-2.9,2.9s-2.9-1.3-2.9-2.9.5-2,1.4-2.5h0Z"
  })), _path1026 || (_path1026 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M776.9,271.4c0,0,0-.2,0-.3h0,0c0-.1-.2-.1-.3,0h0c-1,.6-1.6,1.6-1.6,2.8,0,1.8,1.4,3.2,3.2,3.2s3.2-1.4,3.2-3.2-.6-2.2-1.6-2.8c-.1,0-.3,0-.3,0,0,.1,0,.3,0,.3.8.5,1.4,1.4,1.4,2.4,0,1.5-1.2,2.8-2.8,2.8s-2.8-1.2-2.8-2.8.5-1.9,1.4-2.4c0,0,0,0,0,0Z"
  })), _path1027 || (_path1027 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M778.3,273.5v-3c0,0,0-.1-.1-.1s-.1,0-.1.1v3c0,0,0,.1.1.1s.1,0,.1-.1Z"
  })), _path1028 || (_path1028 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M778.4,273.5v-3c0-.1-.1-.2-.2-.2s-.2.1-.2.2v3c0,.1.1.2.2.2s.2-.1.2-.2Z"
  })), _path1029 || (_path1029 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M795,271.4c0,0,0-.1,0-.2,0,0-.1,0-.2,0-1,.6-1.5,1.6-1.5,2.7,0,1.7,1.4,3.1,3.1,3.1s3.1-1.4,3.1-3.1-.6-2.1-1.5-2.7c0,0-.1,0-.2,0,0,0,0,.1,0,.2.9.5,1.4,1.5,1.4,2.5,0,1.6-1.3,2.9-2.9,2.9s-2.9-1.3-2.9-2.9.5-2,1.4-2.5h0Z"
  })), _path1030 || (_path1030 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M795.1,271.4c0,0,0-.2,0-.3h0,0c0-.1-.2-.1-.3,0h0c-1,.6-1.6,1.6-1.6,2.8,0,1.8,1.4,3.2,3.2,3.2s3.2-1.4,3.2-3.2-.6-2.2-1.6-2.8c-.1,0-.2,0-.3,0,0,.1,0,.3,0,.3.8.5,1.4,1.4,1.4,2.4,0,1.5-1.2,2.8-2.8,2.8s-2.8-1.2-2.8-2.8.5-1.9,1.4-2.4c0,0,0,0,0,0Z"
  })), _path1031 || (_path1031 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M796.6,273.5v-3c0,0,0-.1-.1-.1s-.1,0-.1.1v3c0,0,0,.1.1.1s.1,0,.1-.1Z"
  })), _path1032 || (_path1032 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M796.7,273.5v-3c0-.1-.1-.2-.2-.2s-.2.1-.2.2v3c0,.1.1.2.2.2s.2-.1.2-.2Z"
  })), _path1033 || (_path1033 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M817.2,247.4c0,0,0-.1,0-.2,0,0-.1,0-.2,0-1,.6-1.5,1.6-1.5,2.7,0,1.7,1.4,3.1,3.1,3.1s3.1-1.4,3.1-3.1-.6-2.1-1.5-2.7c0,0-.1,0-.2,0,0,0,0,.1,0,.2.9.5,1.4,1.5,1.4,2.5,0,1.6-1.3,2.9-2.9,2.9s-2.9-1.3-2.9-2.9.5-2,1.4-2.5h0Z"
  })), _path1034 || (_path1034 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M817.3,247.5c0,0,0-.2,0-.3h0s0,0,0,0c0,0-.2-.1-.3,0h0c-1,.6-1.6,1.6-1.6,2.8,0,1.8,1.4,3.2,3.2,3.2s3.2-1.4,3.2-3.2-.6-2.2-1.6-2.8c-.1,0-.3,0-.3,0,0,.1,0,.3,0,.3.8.5,1.4,1.4,1.4,2.4,0,1.5-1.2,2.8-2.8,2.8s-2.8-1.2-2.8-2.8.5-1.9,1.4-2.4c0,0,0,0,0,0Z"
  })), _path1035 || (_path1035 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M818.8,249.5v-3c0,0,0-.1-.1-.1s-.1,0-.1.1v3c0,0,0,.1.1.1s.1,0,.1-.1Z"
  })), _path1036 || (_path1036 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M818.9,249.5v-3c0-.1-.1-.2-.2-.2s-.2.1-.2.2v3c0,.1.1.2.2.2s.2-.1.2-.2Z"
  })), _path1037 || (_path1037 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M776.8,288.4c0,0,0-.1,0-.2,0,0-.1,0-.2,0-1,.6-1.5,1.6-1.5,2.7,0,1.7,1.4,3.1,3.1,3.1s3.1-1.4,3.1-3.1-.6-2.1-1.5-2.7c0,0-.1,0-.2,0,0,0,0,.1,0,.2.9.5,1.4,1.5,1.4,2.5,0,1.6-1.3,2.9-2.9,2.9s-2.9-1.3-2.9-2.9.5-2,1.4-2.5h0Z"
  })), _path1038 || (_path1038 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M776.9,288.4c0,0,0-.2,0-.3h0s0,0,0,0c0,0-.2-.1-.3,0h0c-1,.6-1.6,1.6-1.6,2.8,0,1.8,1.4,3.2,3.2,3.2s3.2-1.4,3.2-3.2-.6-2.2-1.6-2.8c-.1,0-.3,0-.3,0,0,.1,0,.3,0,.3.8.5,1.4,1.4,1.4,2.4,0,1.5-1.2,2.8-2.8,2.8s-2.8-1.2-2.8-2.8.5-1.9,1.4-2.4c0,0,0,0,0,0Z"
  })), _path1039 || (_path1039 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M778.3,290.5v-3c0,0,0-.1-.1-.1s-.1,0-.1.1v3c0,0,0,.1.1.1s.1,0,.1-.1Z"
  })), _path1040 || (_path1040 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M778.4,290.5v-3c0-.1-.1-.2-.2-.2s-.2.1-.2.2v3c0,.1.1.2.2.2s.2-.1.2-.2Z"
  })), _path1041 || (_path1041 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M795,288.4c0,0,0-.1,0-.2,0,0-.1,0-.2,0-1,.6-1.5,1.6-1.5,2.7,0,1.7,1.4,3.1,3.1,3.1s3.1-1.4,3.1-3.1-.6-2.1-1.5-2.7c0,0-.1,0-.2,0,0,0,0,.1,0,.2.9.5,1.4,1.5,1.4,2.5,0,1.6-1.3,2.9-2.9,2.9s-2.9-1.3-2.9-2.9.5-2,1.4-2.5h0Z"
  })), _path1042 || (_path1042 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M795.1,288.4c0,0,0-.2,0-.3h0s0,0,0,0c0,0-.2-.1-.3,0h0c-1,.6-1.6,1.6-1.6,2.8,0,1.8,1.4,3.2,3.2,3.2s3.2-1.4,3.2-3.2-.6-2.2-1.6-2.8c-.1,0-.2,0-.3,0,0,.1,0,.3,0,.3.8.5,1.4,1.4,1.4,2.4,0,1.5-1.2,2.8-2.8,2.8s-2.8-1.2-2.8-2.8.5-1.9,1.4-2.4c0,0,0,0,0,0Z"
  })), _path1043 || (_path1043 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M796.6,290.5v-3c0,0,0-.1-.1-.1s-.1,0-.1.1v3c0,0,0,.1.1.1s.1,0,.1-.1Z"
  })), _path1044 || (_path1044 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M796.7,290.5v-3c0-.1-.1-.2-.2-.2s-.2.1-.2.2v3c0,.1.1.2.2.2s.2-.1.2-.2Z"
  })), _path1045 || (_path1045 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M776.8,321.3c0,0,0-.1,0-.2,0,0-.1,0-.2,0-1,.6-1.5,1.6-1.5,2.7,0,1.7,1.4,3.1,3.1,3.1s3.1-1.4,3.1-3.1-.6-2.1-1.5-2.7c0,0-.1,0-.2,0,0,0,0,.1,0,.2.9.5,1.4,1.5,1.4,2.5,0,1.6-1.3,2.9-2.9,2.9s-2.9-1.3-2.9-2.9.5-2,1.4-2.5h0Z"
  })), _path1046 || (_path1046 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M776.9,321.4c0,0,0-.2,0-.3h0,0c0-.1-.2-.1-.3,0h0c-1,.6-1.6,1.6-1.6,2.8,0,1.8,1.4,3.2,3.2,3.2s3.2-1.4,3.2-3.2-.6-2.2-1.6-2.8c-.1,0-.3,0-.3,0,0,.1,0,.2,0,.3.8.5,1.4,1.4,1.4,2.4,0,1.5-1.2,2.8-2.8,2.8s-2.8-1.2-2.8-2.8.5-1.9,1.4-2.4c0,0,0,0,0,0Z"
  })), _path1047 || (_path1047 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M778.3,323.5v-3c0,0,0-.1-.1-.1s-.1,0-.1.1v3c0,0,0,.1.1.1s.1,0,.1-.1Z"
  })), _path1048 || (_path1048 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M778.4,323.5v-3c0-.1-.1-.2-.2-.2s-.2.1-.2.2v3c0,.1.1.2.2.2s.2-.1.2-.2Z"
  })), _path1049 || (_path1049 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M795,321.3c0,0,0-.1,0-.2,0,0-.1,0-.2,0-1,.6-1.5,1.6-1.5,2.7,0,1.7,1.4,3.1,3.1,3.1s3.1-1.4,3.1-3.1-.6-2.1-1.5-2.7c0,0-.1,0-.2,0,0,0,0,.1,0,.2.9.5,1.4,1.5,1.4,2.5,0,1.6-1.3,2.9-2.9,2.9s-2.9-1.3-2.9-2.9.5-2,1.4-2.5h0Z"
  })), _path1050 || (_path1050 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M795.1,321.4c0,0,0-.2,0-.3h0,0c0-.1-.2-.1-.3,0h0c-1,.6-1.6,1.6-1.6,2.8,0,1.8,1.4,3.2,3.2,3.2s3.2-1.4,3.2-3.2-.6-2.2-1.6-2.8c-.1,0-.2,0-.3,0,0,.1,0,.2,0,.3.8.5,1.4,1.4,1.4,2.4,0,1.5-1.2,2.8-2.8,2.8s-2.8-1.2-2.8-2.8.5-1.9,1.4-2.4c0,0,0,0,0,0Z"
  })), _path1051 || (_path1051 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M796.6,323.5v-3c0,0,0-.1-.1-.1s-.1,0-.1.1v3c0,0,0,.1.1.1s.1,0,.1-.1Z"
  })), _path1052 || (_path1052 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M796.7,323.5v-3c0-.1-.1-.2-.2-.2s-.2.1-.2.2v3c0,.1.1.2.2.2s.2-.1.2-.2Z"
  })), _path1053 || (_path1053 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M786.5,216.3c0,0,0-.1,0-.2,0,0-.1,0-.2,0-1,.6-1.5,1.6-1.5,2.7,0,1.7,1.4,3.1,3.1,3.1s3.1-1.4,3.1-3.1-.6-2.1-1.5-2.7c0,0-.1,0-.2,0,0,0,0,.1,0,.2.9.5,1.4,1.5,1.4,2.5,0,1.6-1.3,2.9-2.9,2.9s-2.9-1.3-2.9-2.9.5-2,1.4-2.5h0Z"
  })), _path1054 || (_path1054 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M786.6,216.4c0,0,0-.2,0-.3h0c0-.1-.2-.1-.3,0h0c-1,.6-1.6,1.6-1.6,2.8,0,1.8,1.4,3.2,3.2,3.2s3.2-1.4,3.2-3.2-.6-2.2-1.6-2.8c-.1,0-.2,0-.3,0,0,.1,0,.2,0,.3.8.5,1.4,1.4,1.4,2.4,0,1.5-1.2,2.8-2.8,2.8s-2.8-1.2-2.8-2.8.5-1.9,1.4-2.4c0,0,0,0,0,0Z"
  })), _path1055 || (_path1055 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M788,218.5v-3c0,0,0-.1-.1-.1s-.1,0-.1.1v3c0,0,0,.1.1.1s.1,0,.1-.1Z"
  })), _path1056 || (_path1056 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M788.1,218.5v-3c0-.1-.1-.2-.2-.2s-.2.1-.2.2v3c0,.1.1.2.2.2s.2-.1.2-.2Z"
  })), _path1057 || (_path1057 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M817.2,216.3c0,0,0-.1,0-.2,0,0-.1,0-.2,0-1,.6-1.5,1.6-1.5,2.7,0,1.7,1.4,3.1,3.1,3.1s3.1-1.4,3.1-3.1-.6-2.1-1.5-2.7c0,0-.1,0-.2,0,0,0,0,.1,0,.2.9.5,1.4,1.5,1.4,2.5,0,1.6-1.3,2.9-2.9,2.9s-2.9-1.3-2.9-2.9.5-2,1.4-2.5h0Z"
  })), _path1058 || (_path1058 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M817.3,216.4c0,0,0-.2,0-.3h0,0c0-.1-.2-.1-.3,0h0c-1,.6-1.6,1.6-1.6,2.8,0,1.8,1.4,3.2,3.2,3.2s3.2-1.4,3.2-3.2-.6-2.2-1.6-2.8c-.1,0-.3,0-.3,0,0,.1,0,.2,0,.3.8.5,1.4,1.4,1.4,2.4,0,1.5-1.2,2.8-2.8,2.8s-2.8-1.2-2.8-2.8.5-1.9,1.4-2.4c0,0,0,0,0,0Z"
  })), _path1059 || (_path1059 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M818.8,218.5v-3c0,0,0-.1-.1-.1s-.1,0-.1.1v3c0,0,0,.1.1.1s.1,0,.1-.1Z"
  })), _path1060 || (_path1060 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M818.9,218.5v-3c0-.1-.1-.2-.2-.2s-.2.1-.2.2v3c0,.1.1.2.2.2s.2-.1.2-.2Z"
  })), _path1061 || (_path1061 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M840.4,324.5c0,0,.1,0,.1-.1v-1.9c0,0,0-.1-.1-.1s-.1,0-.1.1v1.9c0,0,0,.1.1.1Z"
  })), _path1062 || (_path1062 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M840.4,324.6c.1,0,.2,0,.2-.2v-1.9c0-.1,0-.2-.2-.2s-.2,0-.2.2v1.9c0,.1,0,.2.2.2Z"
  })), _path1063 || (_path1063 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M837.8,321.1v4.7c0,.4.3.7.7.7h6.9c.4,0,.7-.3.7-.7v-4.7c0-.4-.3-.7-.7-.7h-6.9c-.4,0-.7.3-.7.7ZM845.8,321.1v4.7c0,.3-.2.5-.5.5h-6.9c-.3,0-.5-.2-.5-.5v-4.7c0-.3.2-.5.5-.5h6.9c.3,0,.5.2.5.5Z"
  })), _path1064 || (_path1064 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M837.7,321.1v4.7c0,.4.3.8.8.8h6.9c.4,0,.8-.3.8-.8v-4.7c0-.4-.3-.8-.8-.8h-6.9c-.4,0-.8.3-.8.8ZM845.7,321.1v4.7c0,.2-.2.4-.4.4h-6.9c-.2,0-.4-.2-.4-.4v-4.7c0-.2.2-.4.4-.4h6.9c.2,0,.4.2.4.4Z"
  })), _path1065 || (_path1065 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M839.5,325.4h4.7c.4,0,.7-.3.7-.7v-2.6c0-.4-.3-.7-.7-.7h-4.7c-.4,0-.7.3-.7.7v2.6c0,.4.3.7.7.7ZM839.1,322.2c0-.3.2-.5.5-.5h4.7c.3,0,.5.2.5.5v2.6c0,.3-.2.5-.5.5h-4.7c-.3,0-.5-.2-.5-.5v-2.6Z"
  })), _path1066 || (_path1066 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M839.5,325.5h4.7c.4,0,.8-.3.8-.8v-2.6c0-.4-.3-.8-.8-.8h-4.7c-.4,0-.8.3-.8.8v2.6c0,.4.3.8.8.8ZM839.2,322.2c0-.2.2-.4.4-.4h4.7c.2,0,.4.2.4.4v2.6c0,.2-.2.4-.4.4h-4.7c-.2,0-.4-.2-.4-.4v-2.6Z"
  })), _path1067 || (_path1067 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M840.5,247.4c0,0,0-.1,0-.2,0,0-.1,0-.2,0-1,.6-1.5,1.6-1.5,2.7,0,1.7,1.4,3.1,3.1,3.1s3.1-1.4,3.1-3.1-.6-2.1-1.5-2.7c0,0-.1,0-.2,0,0,0,0,.1,0,.2.9.5,1.4,1.5,1.4,2.5,0,1.6-1.3,2.9-2.9,2.9s-2.9-1.3-2.9-2.9.5-2,1.4-2.5h0Z"
  })), _path1068 || (_path1068 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M840.6,247.5c0,0,0-.2,0-.3h0s0,0,0,0c0,0-.2-.1-.3,0h0c-1,.6-1.6,1.6-1.6,2.8,0,1.8,1.4,3.2,3.2,3.2s3.2-1.4,3.2-3.2-.6-2.2-1.6-2.8c-.1,0-.2,0-.3,0,0,.1,0,.3,0,.3.8.5,1.4,1.4,1.4,2.4,0,1.5-1.2,2.8-2.8,2.8s-2.8-1.2-2.8-2.8.5-1.9,1.4-2.4c0,0,0,0,0,0Z"
  })), _path1069 || (_path1069 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M842,249.5v-3c0,0,0-.1-.1-.1s-.1,0-.1.1v3c0,0,0,.1.1.1s.1,0,.1-.1Z"
  })), _path1070 || (_path1070 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M842.1,249.5v-3c0-.1-.1-.2-.2-.2s-.2.1-.2.2v3c0,.1.1.2.2.2s.2-.1.2-.2Z"
  })), _path1071 || (_path1071 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M840.5,216.3c0,0,0-.1,0-.2,0,0-.1,0-.2,0-1,.6-1.5,1.6-1.5,2.7,0,1.7,1.4,3.1,3.1,3.1s3.1-1.4,3.1-3.1-.6-2.1-1.5-2.7c0,0-.1,0-.2,0,0,0,0,.1,0,.2.9.5,1.4,1.5,1.4,2.5,0,1.6-1.3,2.9-2.9,2.9s-2.9-1.3-2.9-2.9.5-2,1.4-2.5h0Z"
  })), _path1072 || (_path1072 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M840.6,216.4c0,0,0-.2,0-.3h0c0-.1-.2-.1-.3,0h0c-1,.6-1.6,1.6-1.6,2.8,0,1.8,1.4,3.2,3.2,3.2s3.2-1.4,3.2-3.2-.6-2.2-1.6-2.8c-.1,0-.2,0-.3,0,0,.1,0,.2,0,.3.8.5,1.4,1.4,1.4,2.4,0,1.5-1.2,2.8-2.8,2.8s-2.8-1.2-2.8-2.8.5-1.9,1.4-2.4c0,0,0,0,0,0Z"
  })), _path1073 || (_path1073 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M842,218.5v-3c0,0,0-.1-.1-.1s-.1,0-.1.1v3c0,0,0,.1.1.1s.1,0,.1-.1Z"
  })), _path1074 || (_path1074 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M842.1,218.5v-3c0-.1-.1-.2-.2-.2s-.2.1-.2.2v3c0,.1.1.2.2.2s.2-.1.2-.2Z"
  })), _path1075 || (_path1075 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M863.7,324.5c0,0,.1,0,.1-.1v-1.9c0,0,0-.1-.1-.1s-.1,0-.1.1v1.9c0,0,0,.1.1.1Z"
  })), _path1076 || (_path1076 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M863.7,324.6c.1,0,.2,0,.2-.2v-1.9c0-.1,0-.2-.2-.2s-.2,0-.2.2v1.9c0,.1,0,.2.2.2Z"
  })), _path1077 || (_path1077 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M861,321.1v4.7c0,.4.3.7.7.7h6.9c.4,0,.7-.3.7-.7v-4.7c0-.4-.3-.7-.7-.7h-6.9c-.4,0-.7.3-.7.7ZM869,321.1v4.7c0,.3-.2.5-.5.5h-6.9c-.3,0-.5-.2-.5-.5v-4.7c0-.3.2-.5.5-.5h6.9c.3,0,.5.2.5.5Z"
  })), _path1078 || (_path1078 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M860.9,321.1v4.7c0,.4.3.8.8.8h6.9c.4,0,.8-.3.8-.8v-4.7c0-.4-.3-.8-.8-.8h-6.9c-.4,0-.8.3-.8.8ZM868.9,321.1v4.7c0,.2-.2.4-.4.4h-6.9c-.2,0-.4-.2-.4-.4v-4.7c0-.2.2-.4.4-.4h6.9c.2,0,.4.2.4.4Z"
  })), _path1079 || (_path1079 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M862.8,325.4h4.7c.4,0,.7-.3.7-.7v-2.6c0-.4-.3-.7-.7-.7h-4.7c-.4,0-.7.3-.7.7v2.6c0,.4.3.7.7.7ZM862.3,322.2c0-.3.2-.5.5-.5h4.7c.3,0,.5.2.5.5v2.6c0,.3-.2.5-.5.5h-4.7c-.3,0-.5-.2-.5-.5v-2.6Z"
  })), _path1080 || (_path1080 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M862.8,325.5h4.7c.4,0,.8-.3.8-.8v-2.6c0-.4-.3-.8-.8-.8h-4.7c-.4,0-.8.3-.8.8v2.6c0,.4.3.8.8.8ZM862.4,322.2c0-.2.2-.4.4-.4h4.7c.2,0,.4.2.4.4v2.6c0,.2-.2.4-.4.4h-4.7c-.2,0-.4-.2-.4-.4v-2.6Z"
  })), _path1081 || (_path1081 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M863.7,247.4c0,0,0-.1,0-.2,0,0-.1,0-.2,0-1,.6-1.5,1.6-1.5,2.7,0,1.7,1.4,3.1,3.1,3.1s3.1-1.4,3.1-3.1-.6-2.1-1.5-2.7c0,0-.1,0-.2,0,0,0,0,.1,0,.2.9.5,1.4,1.5,1.4,2.5,0,1.6-1.3,2.9-2.9,2.9s-2.9-1.3-2.9-2.9.5-2,1.4-2.5h0Z"
  })), _path1082 || (_path1082 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M863.8,247.5c0,0,0-.2,0-.3h0s0,0,0,0c0,0-.2-.1-.3,0h0c-1,.6-1.6,1.6-1.6,2.8,0,1.8,1.4,3.2,3.2,3.2s3.2-1.4,3.2-3.2-.6-2.2-1.6-2.8c-.1,0-.3,0-.3,0,0,.1,0,.3,0,.3.8.5,1.4,1.4,1.4,2.4,0,1.5-1.2,2.8-2.8,2.8s-2.8-1.2-2.8-2.8.5-1.9,1.4-2.4c0,0,0,0,0,0Z"
  })), _path1083 || (_path1083 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M865.3,249.5v-3c0,0,0-.1-.1-.1s-.1,0-.1.1v3c0,0,0,.1.1.1s.1,0,.1-.1Z"
  })), _path1084 || (_path1084 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M865.4,249.5v-3c0-.1-.1-.2-.2-.2s-.2.1-.2.2v3c0,.1.1.2.2.2s.2-.1.2-.2Z"
  })), _path1085 || (_path1085 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M863.7,216.3c0,0,0-.1,0-.2,0,0-.1,0-.2,0-1,.6-1.5,1.6-1.5,2.7,0,1.7,1.4,3.1,3.1,3.1s3.1-1.4,3.1-3.1-.6-2.1-1.5-2.7c0,0-.1,0-.2,0,0,0,0,.1,0,.2.9.5,1.4,1.5,1.4,2.5,0,1.6-1.3,2.9-2.9,2.9s-2.9-1.3-2.9-2.9.5-2,1.4-2.5h0Z"
  })), _path1086 || (_path1086 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M863.8,216.4c0,0,0-.2,0-.3h0,0c0-.1-.2-.1-.3,0h0c-1,.6-1.6,1.6-1.6,2.8,0,1.8,1.4,3.2,3.2,3.2s3.2-1.4,3.2-3.2-.6-2.2-1.6-2.8c-.1,0-.3,0-.3,0,0,.1,0,.2,0,.3.8.5,1.4,1.4,1.4,2.4,0,1.5-1.2,2.8-2.8,2.8s-2.8-1.2-2.8-2.8.5-1.9,1.4-2.4c0,0,0,0,0,0Z"
  })), _path1087 || (_path1087 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M865.3,218.5v-3c0,0,0-.1-.1-.1s-.1,0-.1.1v3c0,0,0,.1.1.1s.1,0,.1-.1Z"
  })), _path1088 || (_path1088 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M865.4,218.5v-3c0-.1-.1-.2-.2-.2s-.2.1-.2.2v3c0,.1.1.2.2.2s.2-.1.2-.2Z"
  })), _path1089 || (_path1089 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M886.9,324.5c0,0,.1,0,.1-.1v-1.9c0,0,0-.1-.1-.1s-.1,0-.1.1v1.9c0,0,0,.1.1.1Z"
  })), _path1090 || (_path1090 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M886.9,324.6c.1,0,.2,0,.2-.2v-1.9c0-.1,0-.2-.2-.2s-.2,0-.2.2v1.9c0,.1,0,.2.2.2Z"
  })), _path1091 || (_path1091 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M884.2,321.1v4.7c0,.4.3.7.7.7h6.9c.4,0,.7-.3.7-.7v-4.7c0-.4-.3-.7-.7-.7h-6.9c-.4,0-.7.3-.7.7ZM892.2,321.1v4.7c0,.3-.2.5-.5.5h-6.9c-.3,0-.5-.2-.5-.5v-4.7c0-.3.2-.5.5-.5h6.9c.3,0,.5.2.5.5Z"
  })), _path1092 || (_path1092 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M884.1,321.1v4.7c0,.4.3.8.8.8h6.9c.4,0,.8-.3.8-.8v-4.7c0-.4-.3-.8-.8-.8h-6.9c-.4,0-.8.3-.8.8ZM892.1,321.1v4.7c0,.2-.2.4-.4.4h-6.9c-.2,0-.4-.2-.4-.4v-4.7c0-.2.2-.4.4-.4h6.9c.2,0,.4.2.4.4Z"
  })), _path1093 || (_path1093 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M886,325.4h4.7c.4,0,.7-.3.7-.7v-2.6c0-.4-.3-.7-.7-.7h-4.7c-.4,0-.7.3-.7.7v2.6c0,.4.3.7.7.7ZM885.5,322.2c0-.3.2-.5.5-.5h4.7c.3,0,.5.2.5.5v2.6c0,.3-.2.5-.5.5h-4.7c-.3,0-.5-.2-.5-.5v-2.6Z"
  })), _path1094 || (_path1094 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M886,325.5h4.7c.4,0,.8-.3.8-.8v-2.6c0-.4-.3-.8-.8-.8h-4.7c-.4,0-.8.3-.8.8v2.6c0,.4.3.8.8.8ZM885.6,322.2c0-.2.2-.4.4-.4h4.7c.2,0,.4.2.4.4v2.6c0,.2-.2.4-.4.4h-4.7c-.2,0-.4-.2-.4-.4v-2.6Z"
  })), _path1095 || (_path1095 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M886.9,247.4c0,0,0-.1,0-.2,0,0-.1,0-.2,0-1,.6-1.5,1.6-1.5,2.7,0,1.7,1.4,3.1,3.1,3.1s3.1-1.4,3.1-3.1-.6-2.1-1.5-2.7c0,0-.1,0-.2,0,0,0,0,.1,0,.2.9.5,1.4,1.5,1.4,2.5,0,1.6-1.3,2.9-2.9,2.9s-2.9-1.3-2.9-2.9.5-2,1.4-2.5h0Z"
  })), _path1096 || (_path1096 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M887,247.5c0,0,0-.2,0-.3h0s0,0,0,0c0,0-.2-.1-.3,0h0c-1,.6-1.6,1.6-1.6,2.8,0,1.8,1.4,3.2,3.2,3.2s3.2-1.4,3.2-3.2-.6-2.2-1.6-2.8c-.1,0-.2,0-.3,0,0,.1,0,.3,0,.3.8.5,1.4,1.4,1.4,2.4,0,1.5-1.2,2.8-2.8,2.8s-2.8-1.2-2.8-2.8.5-1.9,1.4-2.4c0,0,0,0,0,0Z"
  })), _path1097 || (_path1097 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M888.5,249.5v-3c0,0,0-.1-.1-.1s-.1,0-.1.1v3c0,0,0,.1.1.1s.1,0,.1-.1Z"
  })), _path1098 || (_path1098 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M888.6,249.5v-3c0-.1-.1-.2-.2-.2s-.2.1-.2.2v3c0,.1.1.2.2.2s.2-.1.2-.2Z"
  })), _path1099 || (_path1099 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M886.9,215.9c0,0,0-.1,0-.2,0,0-.1,0-.2,0-1,.6-1.5,1.6-1.5,2.7,0,1.7,1.4,3.1,3.1,3.1s3.1-1.4,3.1-3.1-.6-2.1-1.5-2.7c0,0-.1,0-.2,0,0,0,0,.1,0,.2.9.5,1.4,1.5,1.4,2.5,0,1.6-1.3,2.9-2.9,2.9s-2.9-1.3-2.9-2.9.5-2,1.4-2.5h0Z"
  })), _path1100 || (_path1100 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M887,215.9c0,0,0-.2,0-.3h0c0-.1-.2-.1-.3,0h0c-1,.6-1.6,1.6-1.6,2.8,0,1.8,1.4,3.2,3.2,3.2s3.2-1.4,3.2-3.2-.6-2.2-1.6-2.8c-.1,0-.2,0-.3,0,0,.1,0,.2,0,.3.8.5,1.4,1.4,1.4,2.4,0,1.5-1.2,2.8-2.8,2.8s-2.8-1.2-2.8-2.8.5-1.9,1.4-2.4c0,0,0,0,0,0Z"
  })), _path1101 || (_path1101 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M888.5,218v-3c0,0,0-.1-.1-.1s-.1,0-.1.1v3c0,0,0,.1.1.1s.1,0,.1-.1Z"
  })), _path1102 || (_path1102 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M888.6,218v-3c0-.1-.1-.2-.2-.2s-.2.1-.2.2v3c0,.1.1.2.2.2s.2-.1.2-.2Z"
  })), _path1103 || (_path1103 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M910.1,324.5c0,0,.1,0,.1-.1v-1.9c0,0,0-.1-.1-.1s-.1,0-.1.1v1.9c0,0,0,.1.1.1Z"
  })), _path1104 || (_path1104 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M910.1,324.6c.1,0,.2,0,.2-.2v-1.9c0-.1,0-.2-.2-.2s-.2,0-.2.2v1.9c0,.1,0,.2.2.2Z"
  })), _path1105 || (_path1105 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M907.5,321.1v4.7c0,.4.3.7.7.7h6.9c.4,0,.7-.3.7-.7v-4.7c0-.4-.3-.7-.7-.7h-6.9c-.4,0-.7.3-.7.7ZM915.5,321.1v4.7c0,.3-.2.5-.5.5h-6.9c-.3,0-.5-.2-.5-.5v-4.7c0-.3.2-.5.5-.5h6.9c.3,0,.5.2.5.5Z"
  })), _path1106 || (_path1106 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M907.4,321.1v4.7c0,.4.3.8.8.8h6.9c.4,0,.8-.3.8-.8v-4.7c0-.4-.3-.8-.8-.8h-6.9c-.4,0-.8.3-.8.8ZM915.4,321.1v4.7c0,.2-.2.4-.4.4h-6.9c-.2,0-.4-.2-.4-.4v-4.7c0-.2.2-.4.4-.4h6.9c.2,0,.4.2.4.4Z"
  })), _path1107 || (_path1107 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M909.2,325.4h4.7c.4,0,.7-.3.7-.7v-2.6c0-.4-.3-.7-.7-.7h-4.7c-.4,0-.7.3-.7.7v2.6c0,.4.3.7.7.7ZM908.7,322.2c0-.3.2-.5.5-.5h4.7c.3,0,.5.2.5.5v2.6c0,.3-.2.5-.5.5h-4.7c-.3,0-.5-.2-.5-.5v-2.6Z"
  })), _path1108 || (_path1108 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M909.2,325.5h4.7c.4,0,.8-.3.8-.8v-2.6c0-.4-.3-.8-.8-.8h-4.7c-.4,0-.8.3-.8.8v2.6c0,.4.3.8.8.8ZM908.8,322.2c0-.2.2-.4.4-.4h4.7c.2,0,.4.2.4.4v2.6c0,.2-.2.4-.4.4h-4.7c-.2,0-.4-.2-.4-.4v-2.6Z"
  })), _path1109 || (_path1109 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M910.1,247.4c0,0,0-.1,0-.2,0,0-.1,0-.2,0-1,.6-1.5,1.6-1.5,2.7,0,1.7,1.4,3.1,3.1,3.1s3.1-1.4,3.1-3.1-.6-2.1-1.5-2.7c0,0-.1,0-.2,0,0,0,0,.1,0,.2.9.5,1.4,1.5,1.4,2.5,0,1.6-1.3,2.9-2.9,2.9s-2.9-1.3-2.9-2.9.5-2,1.4-2.5h0Z"
  })), _path1110 || (_path1110 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M910.2,247.5c0,0,0-.2,0-.3h0s0,0,0,0c0,0-.2-.1-.3,0h0c-1,.6-1.6,1.6-1.6,2.8,0,1.8,1.4,3.2,3.2,3.2s3.2-1.4,3.2-3.2-.6-2.2-1.6-2.8c-.1,0-.2,0-.3,0,0,.1,0,.3,0,.3.8.5,1.4,1.4,1.4,2.4,0,1.5-1.2,2.8-2.8,2.8s-2.8-1.2-2.8-2.8.5-1.9,1.4-2.4c0,0,0,0,0,0Z"
  })), _path1111 || (_path1111 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M911.7,249.5v-3c0,0,0-.1-.1-.1s-.1,0-.1.1v3c0,0,0,.1.1.1s.1,0,.1-.1Z"
  })), _path1112 || (_path1112 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M911.8,249.5v-3c0-.1-.1-.2-.2-.2s-.2.1-.2.2v3c0,.1.1.2.2.2s.2-.1.2-.2Z"
  })), _path1113 || (_path1113 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M910.1,216.3c0,0,0-.1,0-.2,0,0-.1,0-.2,0-1,.6-1.5,1.6-1.5,2.7,0,1.7,1.4,3.1,3.1,3.1s3.1-1.4,3.1-3.1-.6-2.1-1.5-2.7c0,0-.1,0-.2,0,0,0,0,.1,0,.2.9.5,1.4,1.5,1.4,2.5,0,1.6-1.3,2.9-2.9,2.9s-2.9-1.3-2.9-2.9.5-2,1.4-2.5h0Z"
  })), _path1114 || (_path1114 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M910.2,216.4c0,0,0-.2,0-.3h0,0c0-.1-.2-.1-.3,0h0c-1,.6-1.6,1.6-1.6,2.8,0,1.8,1.4,3.2,3.2,3.2s3.2-1.4,3.2-3.2-.6-2.2-1.6-2.8c-.1,0-.2,0-.3,0,0,.1,0,.2,0,.3.8.5,1.4,1.4,1.4,2.4,0,1.5-1.2,2.8-2.8,2.8s-2.8-1.2-2.8-2.8.5-1.9,1.4-2.4c0,0,0,0,0,0Z"
  })), _path1115 || (_path1115 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M911.7,218.5v-3c0,0,0-.1-.1-.1s-.1,0-.1.1v3c0,0,0,.1.1.1s.1,0,.1-.1Z"
  })), _path1116 || (_path1116 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M911.8,218.5v-3c0-.1-.1-.2-.2-.2s-.2.1-.2.2v3c0,.1.1.2.2.2s.2-.1.2-.2Z"
  })), _path1117 || (_path1117 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M933.3,324.5c0,0,.1,0,.1-.1v-1.9c0,0,0-.1-.1-.1s-.1,0-.1.1v1.9c0,0,0,.1.1.1Z"
  })), _path1118 || (_path1118 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M933.3,324.6c.1,0,.2,0,.2-.2v-1.9c0-.1,0-.2-.2-.2s-.2,0-.2.2v1.9c0,.1,0,.2.2.2Z"
  })), _path1119 || (_path1119 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M930.7,321.1v4.7c0,.4.3.7.7.7h6.9c.4,0,.7-.3.7-.7v-4.7c0-.4-.3-.7-.7-.7h-6.9c-.4,0-.7.3-.7.7ZM938.7,321.1v4.7c0,.3-.2.5-.5.5h-6.9c-.3,0-.5-.2-.5-.5v-4.7c0-.3.2-.5.5-.5h6.9c.3,0,.5.2.5.5Z"
  })), _path1120 || (_path1120 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M930.6,321.1v4.7c0,.4.3.8.8.8h6.9c.4,0,.8-.3.8-.8v-4.7c0-.4-.3-.8-.8-.8h-6.9c-.4,0-.8.3-.8.8ZM938.6,321.1v4.7c0,.2-.2.4-.4.4h-6.9c-.2,0-.4-.2-.4-.4v-4.7c0-.2.2-.4.4-.4h6.9c.2,0,.4.2.4.4Z"
  })), _path1121 || (_path1121 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M932.4,325.4h4.7c.4,0,.7-.3.7-.7v-2.6c0-.4-.3-.7-.7-.7h-4.7c-.4,0-.7.3-.7.7v2.6c0,.4.3.7.7.7ZM932,322.2c0-.3.2-.5.5-.5h4.7c.3,0,.5.2.5.5v2.6c0,.3-.2.5-.5.5h-4.7c-.3,0-.5-.2-.5-.5v-2.6Z"
  })), _path1122 || (_path1122 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M932.4,325.5h4.7c.4,0,.8-.3.8-.8v-2.6c0-.4-.3-.8-.8-.8h-4.7c-.4,0-.8.3-.8.8v2.6c0,.4.3.8.8.8ZM932.1,322.2c0-.2.2-.4.4-.4h4.7c.2,0,.4.2.4.4v2.6c0,.2-.2.4-.4.4h-4.7c-.2,0-.4-.2-.4-.4v-2.6Z"
  })), _path1123 || (_path1123 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M933.4,247.4c0,0,0-.1,0-.2,0,0-.1,0-.2,0-1,.6-1.5,1.6-1.5,2.7,0,1.7,1.4,3.1,3.1,3.1s3.1-1.4,3.1-3.1-.6-2.1-1.5-2.7c0,0-.1,0-.2,0,0,0,0,.1,0,.2.9.5,1.4,1.5,1.4,2.5,0,1.6-1.3,2.9-2.9,2.9s-2.9-1.3-2.9-2.9.5-2,1.4-2.5h0Z"
  })), _path1124 || (_path1124 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M933.5,247.5c0,0,0-.2,0-.3h0s0,0,0,0c0,0-.2-.1-.3,0h0c-1,.6-1.6,1.6-1.6,2.8,0,1.8,1.4,3.2,3.2,3.2s3.2-1.4,3.2-3.2-.6-2.2-1.6-2.8c-.1,0-.2,0-.3,0,0,.1,0,.3,0,.3.8.5,1.4,1.4,1.4,2.4,0,1.5-1.2,2.8-2.8,2.8s-2.8-1.2-2.8-2.8.5-1.9,1.4-2.4c0,0,0,0,0,0Z"
  })), _path1125 || (_path1125 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M934.9,249.5v-3c0,0,0-.1-.1-.1s-.1,0-.1.1v3c0,0,0,.1.1.1s.1,0,.1-.1Z"
  })), _path1126 || (_path1126 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M935,249.5v-3c0-.1-.1-.2-.2-.2s-.2.1-.2.2v3c0,.1.1.2.2.2s.2-.1.2-.2Z"
  })), _path1127 || (_path1127 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M955.8,321.2c0,0,0-.1,0-.2,0,0-.1,0-.2,0-1,.6-1.5,1.6-1.5,2.7,0,1.7,1.4,3.1,3.1,3.1s3.1-1.4,3.1-3.1-.6-2.1-1.5-2.7c0,0-.1,0-.2,0,0,0,0,.1,0,.2.9.5,1.4,1.5,1.4,2.5,0,1.6-1.3,2.9-2.9,2.9s-2.9-1.3-2.9-2.9.5-2,1.4-2.5h0Z"
  })), _path1128 || (_path1128 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M955.9,321.2c0,0,0-.2,0-.3h0,0c0-.1-.2-.1-.3,0h0c-1,.6-1.6,1.6-1.6,2.8,0,1.8,1.4,3.2,3.2,3.2s3.2-1.4,3.2-3.2-.6-2.2-1.6-2.8c-.1,0-.2,0-.3,0,0,.1,0,.2,0,.3.8.5,1.4,1.4,1.4,2.4,0,1.5-1.2,2.8-2.8,2.8s-2.8-1.2-2.8-2.8.5-1.9,1.4-2.4c0,0,0,0,0,0Z"
  })), _path1129 || (_path1129 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M957.4,323.3v-3c0,0,0-.1-.1-.1s-.1,0-.1.1v3c0,0,0,.1.1.1s.1,0,.1-.1Z"
  })), _path1130 || (_path1130 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M957.5,323.3v-3c0-.1-.1-.2-.2-.2s-.2.1-.2.2v3c0,.1.1.2.2.2s.2-.1.2-.2Z"
  })), _path1131 || (_path1131 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M989.8,321.2c0,0,0-.1,0-.2,0,0-.1,0-.2,0-1,.6-1.5,1.6-1.5,2.7,0,1.7,1.4,3.1,3.1,3.1s3.1-1.4,3.1-3.1-.6-2.1-1.5-2.7c0,0-.1,0-.2,0,0,0,0,.1,0,.2.9.5,1.4,1.5,1.4,2.5,0,1.6-1.3,2.9-2.9,2.9s-2.9-1.3-2.9-2.9.5-2,1.4-2.5h0Z"
  })), _path1132 || (_path1132 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M989.9,321.2c0,0,0-.2,0-.3h0c0-.1-.2-.1-.3,0h0c-1,.6-1.6,1.6-1.6,2.8,0,1.8,1.4,3.2,3.2,3.2s3.2-1.4,3.2-3.2-.6-2.2-1.6-2.8c-.1,0-.2,0-.3,0,0,.1,0,.2,0,.3.8.5,1.4,1.4,1.4,2.4,0,1.5-1.2,2.8-2.8,2.8s-2.8-1.2-2.8-2.8.5-1.9,1.4-2.4c0,0,0,0,0,0Z"
  })), _path1133 || (_path1133 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M991.4,323.3v-3c0,0,0-.1-.1-.1s-.1,0-.1.1v3c0,0,0,.1.1.1s.1,0,.1-.1Z"
  })), _path1134 || (_path1134 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M991.5,323.3v-3c0-.1-.1-.2-.2-.2s-.2.1-.2.2v3c0,.1.1.2.2.2s.2-.1.2-.2Z"
  })), _path1135 || (_path1135 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M955.8,340.5c0,0,0-.1,0-.2,0,0-.1,0-.2,0-1,.6-1.5,1.6-1.5,2.7,0,1.7,1.4,3.1,3.1,3.1s3.1-1.4,3.1-3.1-.6-2.1-1.5-2.7c0,0-.1,0-.2,0,0,0,0,.1,0,.2.9.5,1.4,1.5,1.4,2.5,0,1.6-1.3,2.9-2.9,2.9s-2.9-1.3-2.9-2.9.5-2,1.4-2.5h0Z"
  })), _path1136 || (_path1136 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M955.9,340.6c0,0,0-.2,0-.3h0,0c0-.1-.2-.1-.3,0h0c-1,.6-1.6,1.6-1.6,2.8,0,1.8,1.4,3.2,3.2,3.2s3.2-1.4,3.2-3.2-.6-2.2-1.6-2.8c-.1,0-.2,0-.3,0,0,.1,0,.3,0,.3.8.5,1.4,1.4,1.4,2.4,0,1.5-1.2,2.8-2.8,2.8s-2.8-1.2-2.8-2.8.5-1.9,1.4-2.4c0,0,0,0,0,0Z"
  })), _path1137 || (_path1137 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M957.4,342.6v-3c0,0,0-.1-.1-.1s-.1,0-.1.1v3c0,0,0,.1.1.1s.1,0,.1-.1Z"
  })), _path1138 || (_path1138 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M957.5,342.6v-3c0-.1-.1-.2-.2-.2s-.2.1-.2.2v3c0,.1.1.2.2.2s.2-.1.2-.2Z"
  })), _path1139 || (_path1139 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M933.4,216.3c0,0,0-.1,0-.2,0,0-.1,0-.2,0-1,.6-1.5,1.6-1.5,2.7,0,1.7,1.4,3.1,3.1,3.1s3.1-1.4,3.1-3.1-.6-2.1-1.5-2.7c0,0-.1,0-.2,0,0,0,0,.1,0,.2.9.5,1.4,1.5,1.4,2.5,0,1.6-1.3,2.9-2.9,2.9s-2.9-1.3-2.9-2.9.5-2,1.4-2.5h0Z"
  })), _path1140 || (_path1140 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M933.5,216.4c0,0,0-.2,0-.3h0c0-.1-.2-.1-.3,0h0c-1,.6-1.6,1.6-1.6,2.8,0,1.8,1.4,3.2,3.2,3.2s3.2-1.4,3.2-3.2-.6-2.2-1.6-2.8c-.1,0-.2,0-.3,0,0,.1,0,.2,0,.3.8.5,1.4,1.4,1.4,2.4,0,1.5-1.2,2.8-2.8,2.8s-2.8-1.2-2.8-2.8.5-1.9,1.4-2.4c0,0,0,0,0,0Z"
  })), _path1141 || (_path1141 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M934.9,218.5v-3c0,0,0-.1-.1-.1s-.1,0-.1.1v3c0,0,0,.1.1.1s.1,0,.1-.1Z"
  })), _path1142 || (_path1142 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M935,218.5v-3c0-.1-.1-.2-.2-.2s-.2.1-.2.2v3c0,.1.1.2.2.2s.2-.1.2-.2Z"
  })), _path1143 || (_path1143 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M955.8,216.5c0,0,0-.1,0-.2,0,0-.1,0-.2,0-1,.6-1.5,1.6-1.5,2.7,0,1.7,1.4,3.1,3.1,3.1s3.1-1.4,3.1-3.1-.6-2.1-1.5-2.7c0,0-.1,0-.2,0,0,0,0,.1,0,.2.9.5,1.4,1.5,1.4,2.5,0,1.6-1.3,2.9-2.9,2.9s-2.9-1.3-2.9-2.9.5-2,1.4-2.5h0Z"
  })), _path1144 || (_path1144 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M955.9,216.5c0,0,0-.2,0-.3h0,0c0-.1-.2-.1-.3,0h0c-1,.6-1.6,1.6-1.6,2.8,0,1.8,1.4,3.2,3.2,3.2s3.2-1.4,3.2-3.2-.6-2.2-1.6-2.8c-.1,0-.2,0-.3,0,0,.1,0,.3,0,.3.8.5,1.4,1.4,1.4,2.4,0,1.5-1.2,2.8-2.8,2.8s-2.8-1.2-2.8-2.8.5-1.9,1.4-2.4c0,0,0,0,0,0Z"
  })), _path1145 || (_path1145 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M957.4,218.6v-3c0,0,0-.1-.1-.1s-.1,0-.1.1v3c0,0,0,.1.1.1s.1,0,.1-.1Z"
  })), _path1146 || (_path1146 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M957.5,218.6v-3c0-.1-.1-.2-.2-.2s-.2.1-.2.2v3c0,.1.1.2.2.2s.2-.1.2-.2Z"
  })), _path1147 || (_path1147 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M1003.3,172.9c0,0,0-.1,0-.2,0,0-.1,0-.2,0-1,.6-1.5,1.6-1.5,2.7,0,1.7,1.4,3.1,3.1,3.1s3.1-1.4,3.1-3.1-.6-2.1-1.5-2.7c0,0-.1,0-.2,0,0,0,0,.1,0,.2.9.5,1.4,1.5,1.4,2.5,0,1.6-1.3,2.9-2.8,2.9s-2.9-1.3-2.9-2.9.5-2,1.4-2.5h0Z"
  })), _path1148 || (_path1148 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1003.4,173c0,0,0-.2,0-.3h0c0-.1-.2-.1-.3,0h0c-1,.6-1.6,1.6-1.6,2.8,0,1.8,1.4,3.2,3.2,3.2s3.2-1.4,3.2-3.2-.6-2.2-1.6-2.8c-.1,0-.2,0-.3,0,0,.1,0,.3,0,.3.8.5,1.4,1.4,1.4,2.4,0,1.5-1.2,2.8-2.8,2.8s-2.8-1.2-2.8-2.8.5-1.9,1.4-2.4c0,0,0,0,0,0Z"
  })), _path1149 || (_path1149 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M1004.9,175.1v-3c0,0,0-.1-.1-.1s-.1,0-.1.1v3c0,0,0,.1.1.1s.1,0,.1-.1Z"
  })), _path1150 || (_path1150 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1005,175.1v-3c0-.1-.1-.2-.2-.2s-.2.1-.2.2v3c0,.1.1.2.2.2s.2-.1.2-.2Z"
  })), _path1151 || (_path1151 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1002.4,180c-1.6-.9-2.6-2.6-2.6-4.5s1.9-4.7,4.3-5.1"
  })), _path1152 || (_path1152 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1005.5,170.4c2.4.4,4.3,2.5,4.3,5.1s-.9,3.3-2.2,4.3"
  })), _path1153 || (_path1153 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M801.6,111.3h-9.5c-.2,0-.4.2-.4.4v12.7c0,.2.2.4.4.4h9.5c.2,0,.4-.2.4-.4v-12.7c0-.2-.2-.4-.4-.4ZM799.7,120.4c0,.2-.1.3-.3.3h-5.1c-.2,0-.3-.1-.3-.3v-3.7c0,0,0-.2,0-.2l.9-.9c0,0,.1,0,.2,0h3.3c0,0,.2,0,.2,0l.9.9c0,0,0,.1,0,.2v3.7h0Z"
  })), _path1154 || (_path1154 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M784.6,111.3h-9.5c-.2,0-.4.2-.4.4v12.7c0,.2.2.4.4.4h9.5c.2,0,.4-.2.4-.4v-12.7c0-.2-.2-.4-.4-.4ZM782.7,120.4c0,.2-.1.3-.3.3h-5.1c-.2,0-.3-.1-.3-.3v-3.7c0,0,0-.2,0-.2l.9-.9c0,0,.1,0,.2,0h3.3c0,0,.2,0,.2,0l.9.9c0,0,0,.1,0,.2v3.7h0Z"
  })), _path1155 || (_path1155 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M894,342.8h-34.4c-.1,0-.3.1-.3.3v1.6c0,.1.1.3.3.3h34.4c.1,0,.3-.1.3-.3v-1.6c0-.1-.1-.3-.3-.3Z"
  })), _path1156 || (_path1156 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M876.6,338.3v11c0,.1,0,.3.2.3s.2-.1.2-.3v-11c0-.1,0-.3-.2-.3s-.2.1-.2.3Z"
  })), _path1157 || (_path1157 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M876.5,338.3v11c0,0,0,.2,0,.2,0,0,.1.1.2.1s.2,0,.2-.1c0,0,0-.2,0-.2v-11c0,0,0-.2,0-.2,0,0-.1-.1-.2-.1s-.2,0-.2.1c0,0,0,.2,0,.2Z"
  })), _path1158 || (_path1158 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M959.6,260.6c-.5-.8-1.3-1.3-2.2-1.3v2.7c0,0,0,.1,0,.1s-.1,0-.1-.1v-2.7c-.4,0-.9.1-1.2.4-1.3.7-1.7,2.4-1,3.7.7,1.3,2.4,1.7,3.7,1,1.3-.7,1.7-2.4,1-3.7h0Z"
  })), _path1159 || (_path1159 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M957.3,258.3v.4"
  })), _path1160 || (_path1160 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M955.4,258.8l.2.3"
  })), _path1161 || (_path1161 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M958.9,264.7l.2.3"
  })), _path1162 || (_path1162 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M954.1,260.1l.3.2"
  })), _path1163 || (_path1163 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M960.1,263.5l.3.2"
  })), _path1164 || (_path1164 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M953.6,261.9h.4"
  })), _path1165 || (_path1165 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M960.5,261.9h.4"
  })), _path1166 || (_path1166 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M954.1,263.7l.3-.2"
  })), _path1167 || (_path1167 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M960.1,260.3l.3-.2"
  })), _path1168 || (_path1168 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M955.4,265l.2-.3"
  })), _path1169 || (_path1169 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M958.9,259.1l.2-.3"
  })), _path1170 || (_path1170 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M959.6,274.3c-.5-.8-1.3-1.3-2.2-1.3v2.7c0,0,0,.1,0,.1s-.1,0-.1-.1v-2.7c-.4,0-.9.1-1.2.4-1.3.7-1.7,2.4-1,3.7.7,1.3,2.4,1.7,3.7,1,1.3-.7,1.7-2.4,1-3.7h0Z"
  })), _path1171 || (_path1171 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M957.3,272v.3"
  })), _path1172 || (_path1172 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M955.4,272.5l.2.3"
  })), _path1173 || (_path1173 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M958.9,278.5l.2.3"
  })), _path1174 || (_path1174 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M954.1,273.8l.3.2"
  })), _path1175 || (_path1175 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M960.1,277.3l.3.2"
  })), _path1176 || (_path1176 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M953.6,275.6h.4"
  })), _path1177 || (_path1177 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M960.5,275.6h.4"
  })), _path1178 || (_path1178 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M954.1,277.4l.3-.2"
  })), _path1179 || (_path1179 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M960.1,274l.3-.2"
  })), _path1180 || (_path1180 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M955.4,278.8l.2-.3"
  })), _path1181 || (_path1181 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M958.9,272.8l.2-.3"
  })), _path1182 || (_path1182 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M959.8,306.6c0-1.4-1.2-2.6-2.6-2.6s-2.6,1.1-2.6,2.6,1.2,2.6,2.6,2.6,2.6-1.1,2.6-2.6Z"
  })), _path1183 || (_path1183 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M949.7,227.4h16.3"
  })), _path1184 || (_path1184 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M949.7,210.8h16.3"
  })), _path1185 || (_path1185 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M949.7,241.2h16.3"
  })), _path1186 || (_path1186 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M949.7,251.3h16.3"
  })), _path1187 || (_path1187 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M981.5,124.5c0-.6-.5-1.1-1.1-1.1s-1.1.5-1.1,1.1.5,1.1,1.1,1.1,1.1-.5,1.1-1.1Z"
  })), _path1188 || (_path1188 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M983,124.5c0-1.4-1.2-2.6-2.6-2.6s-2.6,1.2-2.6,2.6,1.2,2.6,2.6,2.6,2.6-1.2,2.6-2.6Z"
  })), _path1189 || (_path1189 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M1007.3,141.3c0-1.4-1.2-2.6-2.6-2.6s-2.6,1.1-2.6,2.6,1.2,2.6,2.6,2.6,2.6-1.1,2.6-2.6Z"
  })), _path1190 || (_path1190 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M1006.1,152.4c-.8-.5-1.8-.5-2.6,0l1.4,2.4c0,0,0,.1,0,.2,0,0-.1,0-.2,0l-1.4-2.4c-.4.2-.7.5-.9.9-.8,1.3-.3,2.9,1,3.7,1.3.7,3,.3,3.7-1,.8-1.3.3-2.9-1-3.7h0Z"
  })), _path1191 || (_path1191 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M1002.9,151.6l.2.3"
  })), _path1192 || (_path1192 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M1001.6,152.9l.3.2"
  })), _path1193 || (_path1193 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M1007.6,156.4l.3.2"
  })), _path1194 || (_path1194 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M1001.1,154.8h.4"
  })), _path1195 || (_path1195 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M1008,154.8h.3"
  })), _path1196 || (_path1196 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M1001.6,156.6l.3-.2"
  })), _path1197 || (_path1197 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M1007.6,153.1l.3-.2"
  })), _path1198 || (_path1198 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M1002.9,157.9l.2-.3"
  })), _path1199 || (_path1199 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M1006.4,151.9l.2-.3"
  })), _path1200 || (_path1200 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M1004.7,158.4v-.4"
  })), _path1201 || (_path1201 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M1004.8,151.5v-.4"
  })), _path1202 || (_path1202 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M981.9,256c0-1.4-1.2-2.6-2.6-2.6s-2.6,1.1-2.6,2.6,1.2,2.6,2.6,2.6,2.6-1.1,2.6-2.6Z"
  })), _path1203 || (_path1203 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M993.8,256c0-1.4-1.2-2.6-2.6-2.6s-2.6,1.1-2.6,2.6,1.2,2.6,2.6,2.6,2.6-1.1,2.6-2.6Z"
  })), _path1204 || (_path1204 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M1005.8,256c0-1.4-1.2-2.6-2.6-2.6s-2.6,1.1-2.6,2.6,1.1,2.6,2.6,2.6,2.6-1.1,2.6-2.6Z"
  })), _path1205 || (_path1205 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M981.9,269.7c0-1.4-1.2-2.6-2.6-2.6s-2.6,1.2-2.6,2.6,1.2,2.6,2.6,2.6,2.6-1.1,2.6-2.6Z"
  })), _path1206 || (_path1206 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M993.8,269.7c0-1.4-1.2-2.6-2.6-2.6s-2.6,1.2-2.6,2.6,1.2,2.6,2.6,2.6,2.6-1.1,2.6-2.6Z"
  })), _path1207 || (_path1207 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M1005.8,269.7c0-1.4-1.2-2.6-2.6-2.6s-2.6,1.2-2.6,2.6,1.1,2.6,2.6,2.6,2.6-1.1,2.6-2.6Z"
  })), _path1208 || (_path1208 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M991.2,345.3c1.8,0,3.3-1.5,3.3-3.2s-1.5-3.2-3.3-3.2-3.2,1.5-3.2,3.2,1.5,3.2,3.2,3.2Z"
  })), _path1209 || (_path1209 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M991.2,347.2c2.9,0,5.2-2.3,5.2-5.2s-2.3-5.2-5.2-5.2-5.2,2.3-5.2,5.2,2.3,5.2,5.2,5.2Z"
  })), _path1210 || (_path1210 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M435.8,45.5c.3,0,.5-.2.5-.5s-.2-.5-.5-.5-.5.2-.5.5.2.5.5.5Z"
  })), _path1211 || (_path1211 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M456.3,45.5c.3,0,.5-.2.5-.5s-.2-.5-.5-.5-.5.2-.5.5.2.5.5.5Z"
  })), _path1212 || (_path1212 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M476.7,45.5c.3,0,.5-.2.5-.5s-.2-.5-.5-.5-.5.2-.5.5.2.5.5.5Z"
  })), _path1213 || (_path1213 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M497.1,45.5c.3,0,.5-.2.5-.5s-.2-.5-.5-.5-.5.2-.5.5.2.5.5.5Z"
  })), _path1214 || (_path1214 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M513.6,50h0c-.3,0-.5-.2-.5-.5v-2.2c0,0,0-.1-.1-.1h-3.8c0,0-.1,0-.1-.1v-1.8c0,0,0-.1-.1-.1h-1.3c0,0-.1,0-.1-.1v-1.5c0,0,0-.1-.1-.1h-5.4c0,0-.1,0-.1.1v1.5c0,0,0,.1-.1.1h-1.3c0,0-.1,0-.1.1v1.8c0,0,0,.1-.1.1h-3.8c0,0-.1,0-.1.1v2.2c0,.3-.2.5-.5.5h0c-.3,0-.5.2-.5.5v2.8c0,.3.2.5.5.5h0c.3,0,.5.2.5.5v2.5c0,0,0,.1.1.1h3.1v-3.8c0-.2.2-.4.4-.4s.4.2.4.4v3.8h.8v-3.8c0-.2.2-.4.4-.4s.4.2.4.4v3.8h.8v-3.8c0-.2.2-.4.4-.4s.4.2.4.4v3.8h.8v-3.8c0-.2.2-.4.4-.4s.4.2.4.4v3.8h.8v-3.8c0-.2.2-.4.4-.4s.4.2.4.4v3.8h.8v-3.8c0-.2.2-.4.4-.4s.4.2.4.4v3.8h.8v-3.8c0-.2.2-.4.4-.4s.4.2.4.4v3.8h3.1c0,0,.1,0,.1-.1v-2.5c0-.3.2-.5.5-.5h0c.3,0,.5-.2.5-.5v-2.8c0-.3-.2-.5-.5-.5h0Z"
  })), _path1215 || (_path1215 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M493.2,50h0c-.3,0-.5-.2-.5-.5v-2.2c0,0,0-.1-.1-.1h-3.8c0,0-.1,0-.1-.1v-1.8c0,0,0-.1-.1-.1h-1.3c0,0-.1,0-.1-.1v-1.5c0,0,0-.1-.1-.1h-5.4c0,0-.1,0-.1.1v1.5c0,0,0,.1-.1.1h-1.3c0,0-.1,0-.1.1v1.8c0,0,0,.1-.1.1h-3.8c0,0-.1,0-.1.1v2.2c0,.3-.2.5-.5.5h0c-.3,0-.5.2-.5.5v2.8c0,.3.2.5.5.5h0c.3,0,.5.2.5.5v2.5c0,0,0,.1.1.1h3.1v-3.8c0-.2.2-.4.4-.4s.4.2.4.4v3.8h.8v-3.8c0-.2.2-.4.4-.4s.4.2.4.4v3.8h.8v-3.8c0-.2.2-.4.4-.4s.4.2.4.4v3.8h.8v-3.8c0-.2.2-.4.4-.4s.4.2.4.4v3.8h.8v-3.8c0-.2.2-.4.4-.4s.4.2.4.4v3.8h.8v-3.8c0-.2.2-.4.4-.4s.4.2.4.4v3.8h.8v-3.8c0-.2.2-.4.4-.4s.4.2.4.4v3.8h3.1c0,0,.1,0,.1-.1v-2.5c0-.3.2-.5.5-.5h0c.3,0,.5-.2.5-.5v-2.8c0-.3-.2-.5-.5-.5h0Z"
  })), _path1216 || (_path1216 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M472.8,50h0c-.3,0-.5-.2-.5-.5v-2.2c0,0,0-.1-.1-.1h-3.8c0,0-.1,0-.1-.1v-1.8c0,0,0-.1-.1-.1h-1.3c0,0-.1,0-.1-.1v-1.5c0,0,0-.1-.1-.1h-5.4c0,0-.1,0-.1.1v1.5c0,0,0,.1-.1.1h-1.3c0,0-.1,0-.1.1v1.8c0,0,0,.1-.1.1h-3.8c0,0-.1,0-.1.1v2.2c0,.3-.2.5-.5.5h0c-.3,0-.5.2-.5.5v2.8c0,.3.2.5.5.5h0c.3,0,.5.2.5.5v2.5c0,0,0,.1.1.1h3.1v-3.8c0-.2.2-.4.4-.4s.4.2.4.4v3.8h.8v-3.8c0-.2.2-.4.4-.4s.4.2.4.4v3.8h.8v-3.8c0-.2.2-.4.4-.4s.4.2.4.4v3.8h.8v-3.8c0-.2.2-.4.4-.4s.4.2.4.4v3.8h.8v-3.8c0-.2.2-.4.4-.4s.4.2.4.4v3.8h.8v-3.8c0-.2.2-.4.4-.4s.4.2.4.4v3.8h.8v-3.8c0-.2.2-.4.4-.4s.4.2.4.4v3.8h3.1c0,0,.1,0,.1-.1v-2.5c0-.3.2-.5.5-.5h0c.3,0,.5-.2.5-.5v-2.8c0-.3-.2-.5-.5-.5h0Z"
  })), _path1217 || (_path1217 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M452.3,50h0c-.3,0-.5-.2-.5-.5v-2.2c0,0,0-.1-.1-.1h-3.8c0,0-.1,0-.1-.1v-1.8c0,0,0-.1-.1-.1h-1.3c0,0-.1,0-.1-.1v-1.5c0,0,0-.1-.1-.1h-5.4c0,0-.1,0-.1.1v1.5c0,0,0,.1-.1.1h-1.3c0,0-.1,0-.1.1v1.8c0,0,0,.1-.1.1h-3.8c0,0-.1,0-.1.1v2.2c0,.3-.2.5-.5.5h0c-.3,0-.5.2-.5.5v2.8c0,.3.2.5.5.5h0c.3,0,.5.2.5.5v2.5c0,0,0,.1.1.1h3.1v-3.8c0-.2.2-.4.4-.4s.4.2.4.4v3.8h.8v-3.8c0-.2.2-.4.4-.4s.4.2.4.4v3.8h.8v-3.8c0-.2.2-.4.4-.4s.4.2.4.4v3.8h.8v-3.8c0-.2.2-.4.4-.4s.4.2.4.4v3.8h.8v-3.8c0-.2.2-.4.4-.4s.4.2.4.4v3.8h.8v-3.8c0-.2.2-.4.4-.4s.4.2.4.4v3.8h.8v-3.8c0-.2.2-.4.4-.4s.4.2.4.4v3.8h3.1c0,0,.1,0,.1-.1v-2.5c0-.3.2-.5.5-.5h0c.3,0,.5-.2.5-.5v-2.8c0-.3-.2-.5-.5-.5h0Z"
  })), _path1218 || (_path1218 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M374.4,45.5c.3,0,.5-.2.5-.5s-.2-.5-.5-.5-.5.2-.5.5.2.5.5.5Z"
  })), _path1219 || (_path1219 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M353.9,45.5c.3,0,.5-.2.5-.5s-.2-.5-.5-.5-.5.2-.5.5.2.5.5.5Z"
  })), _path1220 || (_path1220 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M394.9,45.5c.3,0,.5-.2.5-.5s-.2-.5-.5-.5-.5.2-.5.5.2.5.5.5Z"
  })), _path1221 || (_path1221 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M415.3,45.5c.3,0,.5-.2.5-.5s-.2-.5-.5-.5-.5.2-.5.5.2.5.5.5Z"
  })), _path1222 || (_path1222 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M431.8,50h0c-.3,0-.5-.2-.5-.5v-2.2c0,0,0-.1-.1-.1h-3.8c0,0-.1,0-.1-.1v-1.8c0,0,0-.1-.1-.1h-1.3c0,0-.1,0-.1-.1v-1.5c0,0,0-.1-.1-.1h-5.4c0,0-.1,0-.1.1v1.5c0,0,0,.1-.1.1h-1.3c0,0-.1,0-.1.1v1.8c0,0,0,.1-.1.1h-3.8c0,0-.1,0-.1.1v2.2c0,.3-.2.5-.5.5h0c-.3,0-.5.2-.5.5v2.8c0,.3.2.5.5.5h0c.3,0,.5.2.5.5v2.5c0,0,0,.1.1.1h3.1v-3.8c0-.2.2-.4.4-.4s.4.2.4.4v3.8h.8v-3.8c0-.2.2-.4.4-.4s.4.2.4.4v3.8h.8v-3.8c0-.2.2-.4.4-.4s.4.2.4.4v3.8h.8v-3.8c0-.2.2-.4.4-.4s.4.2.4.4v3.8h.8v-3.8c0-.2.2-.4.4-.4s.4.2.4.4v3.8h.8v-3.8c0-.2.2-.4.4-.4s.4.2.4.4v3.8h.8v-3.8c0-.2.2-.4.4-.4s.4.2.4.4v3.8h3.1c0,0,.1,0,.1-.1v-2.5c0-.3.2-.5.5-.5h0c.3,0,.5-.2.5-.5v-2.8c0-.3-.2-.5-.5-.5h0Z"
  })), _path1223 || (_path1223 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M411.4,50h0c-.3,0-.5-.2-.5-.5v-2.2c0,0,0-.1-.1-.1h-3.8c0,0-.1,0-.1-.1v-1.8c0,0,0-.1-.1-.1h-1.3c0,0-.1,0-.1-.1v-1.5c0,0,0-.1-.1-.1h-5.4c0,0-.1,0-.1.1v1.5c0,0,0,.1-.1.1h-1.3c0,0-.1,0-.1.1v1.8c0,0,0,.1-.1.1h-3.8c0,0-.1,0-.1.1v2.2c0,.3-.2.5-.5.5h0c-.3,0-.5.2-.5.5v2.8c0,.3.2.5.5.5h0c.3,0,.5.2.5.5v2.5c0,0,0,.1.1.1h3.1v-3.8c0-.2.2-.4.4-.4s.4.2.4.4v3.8h.8v-3.8c0-.2.2-.4.4-.4s.4.2.4.4v3.8h.8v-3.8c0-.2.2-.4.4-.4s.4.2.4.4v3.8h.8v-3.8c0-.2.2-.4.4-.4s.4.2.4.4v3.8h.8v-3.8c0-.2.2-.4.4-.4s.4.2.4.4v3.8h.8v-3.8c0-.2.2-.4.4-.4s.4.2.4.4v3.8h.8v-3.8c0-.2.2-.4.4-.4s.4.2.4.4v3.8h3.1c0,0,.1,0,.1-.1v-2.5c0-.3.2-.5.5-.5h0c.3,0,.5-.2.5-.5v-2.8c0-.3-.2-.5-.5-.5h0Z"
  })), _path1224 || (_path1224 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M390.9,50h0c-.3,0-.5-.2-.5-.5v-2.2c0,0,0-.1-.1-.1h-3.8c0,0-.1,0-.1-.1v-1.8c0,0,0-.1-.1-.1h-1.3c0,0-.1,0-.1-.1v-1.5c0,0,0-.1-.1-.1h-5.4c0,0-.1,0-.1.1v1.5c0,0,0,.1-.1.1h-1.3c0,0-.1,0-.1.1v1.8c0,0,0,.1-.1.1h-3.8c0,0-.1,0-.1.1v2.2c0,.3-.2.5-.5.5h0c-.3,0-.5.2-.5.5v2.8c0,.3.2.5.5.5h0c.3,0,.5.2.5.5v2.5c0,0,0,.1.1.1h3.1v-3.8c0-.2.2-.4.4-.4s.4.2.4.4v3.8h.8v-3.8c0-.2.2-.4.4-.4s.4.2.4.4v3.8h.8v-3.8c0-.2.2-.4.4-.4s.4.2.4.4v3.8h.8v-3.8c0-.2.2-.4.4-.4s.4.2.4.4v3.8h.8v-3.8c0-.2.2-.4.4-.4s.4.2.4.4v3.8h.8v-3.8c0-.2.2-.4.4-.4s.4.2.4.4v3.8h.8v-3.8c0-.2.2-.4.4-.4s.4.2.4.4v3.8h3.1c0,0,.1,0,.1-.1v-2.5c0-.3.2-.5.5-.5h0c.3,0,.5-.2.5-.5v-2.8c0-.3-.2-.5-.5-.5h0Z"
  })), _path1225 || (_path1225 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M370.5,50h0c-.3,0-.5-.2-.5-.5v-2.2c0,0,0-.1-.1-.1h-3.8c0,0-.1,0-.1-.1v-1.8c0,0,0-.1-.1-.1h-1.3c0,0-.1,0-.1-.1v-1.5c0,0,0-.1-.1-.1h-5.4c0,0-.1,0-.1.1v1.5c0,0,0,.1-.1.1h-1.3c0,0-.1,0-.1.1v1.8c0,0,0,.1-.1.1h-3.8c0,0-.1,0-.1.1v2.2c0,.3-.2.5-.5.5h0c-.3,0-.5.2-.5.5v2.8c0,.3.2.5.5.5h0c.3,0,.5.2.5.5v2.5c0,0,0,.1.1.1h3.1v-3.8c0-.2.2-.4.4-.4s.4.2.4.4v3.8h.8v-3.8c0-.2.2-.4.4-.4s.4.2.4.4v3.8h.8v-3.8c0-.2.2-.4.4-.4s.4.2.4.4v3.8h.8v-3.8c0-.2.2-.4.4-.4s.4.2.4.4v3.8h.8v-3.8c0-.2.2-.4.4-.4s.4.2.4.4v3.8h.8v-3.8c0-.2.2-.4.4-.4s.4.2.4.4v3.8h.8v-3.8c0-.2.2-.4.4-.4s.4.2.4.4v3.8h3.1c0,0,.1,0,.1-.1v-2.5c0-.3.2-.5.5-.5h0c.3,0,.5-.2.5-.5v-2.8c0-.3-.2-.5-.5-.5h0Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 332.9,
    y: 36.5,
    width: 200.4,
    height: 30.6,
    rx: 1.7,
    ry: 1.7
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 347.7,
    y: 40.8,
    width: 170.8,
    height: 19.1,
    rx: 0.6,
    ry: 0.6
  })), _path1226 || (_path1226 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M242.6,1h168.1c12.1,0,22,9,22,20v15"
  })), _path1227 || (_path1227 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M675.1,1h-61.5c-12.1,0-22,9-22,20v93.5"
  })), _path1228 || (_path1228 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M675.1,1h82.5c12.1,0,22,9,22,20v66.6"
  })), _path1229 || (_path1229 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M454.6,266.9c-12.1,0-22-9-22-20V67.6"
  })), _path1230 || (_path1230 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M454.6,266.9c12.1,0,20.6-9,20.6-20v-23.4"
  })), _path1231 || (_path1231 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M570.9,266.9c12.1,0,20.6-9,20.6-20V114.5"
  })), _path1232 || (_path1232 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M570.9,266.9c-12.1,0-22-9-22-20v-23.4"
  })), _path1233 || (_path1233 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M242.6,1h-124.5c-12.1,0-22,9-22,20v67.9"
  })), _path1234 || (_path1234 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M777.6,113.6h4.5c.1,0,.2,0,.2-.2v-6.2c0-.1,0-.2-.2-.2h-4.5c-.1,0-.2,0-.2.2v6.2c0,.1,0,.2.2.2Z"
  })), _path1235 || (_path1235 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M776.2,93.5l1.3-2.1s0,0,0-.2v-3.4c0-.1,0-.2.2-.2h4s.1,0,.1.2v3.4c0,0,0,.1,0,.2l1.3,2.1s0,0,0,.2v13.6c0,.1-.1.2-.2.2h-6.9c-.1,0-.2,0-.2-.2v-13.6c0,0,0-.1,0-.2Z"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 451.4,
    y: 104,
    width: 119,
    height: 119,
    rx: 19.5,
    ry: 19.5
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-9",
    cx: 510.9,
    cy: 205.5,
    r: 9.5
  })), _path1236 || (_path1236 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M498.9,118.9v-3.4h12.3l2.4,3.4h8.4v3.4h-6.1l-2.4-3.4h-14.5Z"
  })), _path1237 || (_path1237 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M508.2,298.8c-.6,0-1.1-.1-1.6-.4-.5-.3-.8-.7-1.1-1.2-.3-.5-.4-1.1-.4-1.8s.1-1.3.4-1.8c.3-.5.6-.9,1.1-1.2.5-.3,1-.4,1.6-.4s1.1.1,1.6.4c.5.3.8.7,1.1,1.2.3.5.4,1.1.4,1.8s-.1,1.3-.4,1.8c-.3.5-.6.9-1.1,1.2-.5.3-1,.4-1.6.4ZM508.2,297.7c.4,0,.7-.1,1-.3.3-.2.5-.5.6-.8.1-.3.2-.7.2-1.2s0-.8-.2-1.1c-.1-.4-.3-.6-.6-.8-.3-.2-.6-.3-1-.3s-.7.1-1,.3c-.3.2-.5.5-.6.8-.1.3-.2.7-.2,1.1s0,.8.2,1.2c.1.4.3.6.6.8.3.2.6.3,1,.3ZM512.8,298.6v-6.5h1.2v1h0c.1-.4.3-.6.6-.8.3-.2.6-.3,1-.3s.2,0,.3,0c.1,0,.2,0,.3,0v1.2c0,0-.1,0-.3,0-.1,0-.3,0-.4,0-.3,0-.6,0-.8.2-.2.1-.4.3-.6.5-.1.2-.2.5-.2.8v4h-1.3Z"
  })), _path1238 || (_path1238 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M447.1,345.4c-1.9,0-3.5,1.6-3.5,3.5v76.5c0,1.9,1.6,3.5,3.5,3.5h127c1.8,0,3.3-1.4,3.5-3.1h-5.3v-2.8h5.4v2.5h0c0,0,0,0,0-.1v-15.2h-3.6v-2.8h3.6v-58.5c0-1.9-1.6-3.5-3.5-3.5h-127ZM443.6,363.4h3.6v-2.8h-3.6v2.8ZM447.2,372.1h-3.6v-2.8h3.6v2.8ZM443.6,379h33.9v-2.8h-33.9v2.8ZM456.1,385.9h-5.4v-2.8h5.4v2.8ZM443.6,394.6h16.1v-2.8h-16.1v2.8ZM449,403.2h-5.4v-2.8h5.4v2.8ZM450.7,425.7h7.1v-2.8h-7.1v2.8ZM477.5,425.7h-3.6v-2.8h3.6v2.8ZM479.3,425.7h10.7v-2.8h-10.7v2.8ZM524,425.7h-28.6v-2.8h28.6v2.8ZM538.3,425.7h3.6v-2.8h-3.6v2.8ZM570.5,425.7h-16.1v-2.8h16.1v2.8ZM457.9,410.2h-7.1v-2.8h7.1v2.8ZM461.5,410.2h21.4v-2.8h-21.4v2.8ZM502.6,418.8h-41.1v-2.8h41.1v2.8ZM506.1,418.8h5.4v-2.8h-5.4v2.8ZM534.7,418.8h-21.4v-2.8h21.4v2.8ZM543.7,418.8h12.5v-2.8h-12.5v2.8ZM577.6,418.8h-17.9v-2.8h17.9v2.8ZM484.7,410.2h25v-2.8h-25v2.8ZM529.4,410.2h-3.6v-2.8h3.6v2.8ZM534.7,410.2h14.3v-2.8h-14.3v2.8ZM456.1,403.2h21.4v-2.8h-21.4v2.8ZM499,403.2h-12.5v-2.8h12.5v2.8ZM518.6,403.2h7.1v-2.8h-7.1v2.8ZM536.5,403.2h-5.4v-2.8h5.4v2.8ZM547.2,403.2h8.9v-2.8h-8.9v2.8ZM574,403.2h-14.3v-2.8h14.3v2.8ZM463.2,394.6h10.7v-2.8h-10.7v2.8ZM516.9,394.6h-28.6v-2.8h28.6v2.8ZM524,394.6h5.4v-2.8h-5.4v2.8ZM547.2,394.6h-7.1v-2.8h7.1v2.8ZM561.5,394.6h7.1v-2.8h-7.1v2.8ZM518.6,385.9h-35.7v-2.8h35.7v2.8ZM527.6,385.9h10.7v-2.8h-10.7v2.8ZM552.6,385.9h-7.1v-2.8h7.1v2.8ZM479.3,379h3.6v-2.8h-3.6v2.8ZM495.4,379h-5.4v-2.8h5.4v2.8ZM497.2,379h8.9v-2.8h-8.9v2.8ZM527.6,379h-8.9v-2.8h8.9v2.8ZM532.9,379h14.3v-2.8h-14.3v2.8ZM565.1,379h-7.1v-2.8h7.1v2.8ZM454.3,372.1h5.4v-2.8h-5.4v2.8ZM493.6,372.1h-12.5v-2.8h12.5v2.8ZM502.6,372.1h17.9v-2.8h-17.9v2.8ZM545.4,372.1h-8.9v-2.8h8.9v2.8ZM547.2,372.1h1.8v-2.8h-1.8v2.8ZM557.9,372.1h-5.4v-2.8h5.4v2.8ZM559.7,372.1h10.7v-2.8h-10.7v2.8ZM456.1,363.4h-7.1v-2.8h7.1v2.8ZM479.3,363.4h7.1v-2.8h-7.1v2.8ZM527.6,363.4h-25v-2.8h25v2.8ZM543.7,363.4h1.8v-2.8h-1.8v2.8ZM577.6,363.4h-16.1v-2.8h16.1v2.8ZM461.5,363.4h1.8v-2.8h-1.8v2.8Z"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-19",
    x: 443.6,
    y: 352.1,
    width: 134,
    height: 6
  })), _path1239 || (_path1239 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M452.9,353.7h-4.1v1.2h4.8l-.8-1.2Z"
  })), _path1240 || (_path1240 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M454.4,356.1h1.7v-1.2h-2.4l.7,1.2Z"
  })), _path1241 || (_path1241 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M159.4,88.8H32.6c-1.8.1-3.3,1.6-3.3,3.5v14.4H5.1c-2.8,0-5.1,2.3-5.1,5.1v241.2c0,2.8,2.3,5.1,5.1,5.1h183c2.2,0,4-1.8,4-4V110.7c0-2.2-1.8-4-4-4h-25.5v-14.6c0-1.8-1.5-3.3-3.3-3.3ZM33,89.8h0s126.3,0,126.3,0c1.3,0,2.3,1,2.3,2.3v14.6H30.3v-14.4c0-1.4,1.1-2.5,2.5-2.5h.2ZM34.1,98.6c0-.2.1-.3.3-.3h16.2c.2,0,.3.1.3.3v4c0,.2-.1.3-.3.3h-16.2c-.2,0-.3-.1-.3-.3v-4ZM34.4,97.6c-.6,0-1.1.5-1.1,1.1v4c0,.6.5,1.1,1.1,1.1h16.2c.6,0,1.1-.5,1.1-1.1v-4c0-.6-.5-1.1-1.1-1.1h-16.2ZM140.7,98.3c-.2,0-.3.1-.3.3v4c0,.2.1.3.3.3h16.2c.2,0,.3-.1.3-.3v-4c0-.2-.1-.3-.3-.3h-16.2ZM139.6,98.6c0-.6.5-1.1,1.1-1.1h16.2c.6,0,1.1.5,1.1,1.1v4c0,.6-.5,1.1-1.1,1.1h-16.2c-.6,0-1.1-.5-1.1-1.1v-4ZM1,111.8c0-2.3,1.8-4.1,4.1-4.1h24.3v74c0,.5.4.8.8.8h131.4c.5,0,.8-.4.8-.8v-13.7c3,1.2,6.3,1.9,9.7,1.9s7-.7,10.1-2c.5-.2.8-.7.8-1.2v-12.2c2.2-2.4,3.6-5.6,3.8-9.1.2-4.1-1.2-7.9-3.8-10.7v-12.2c0-.5-.3-1-.8-1.2-3.1-1.3-6.5-2-10.1-2s-6.7.7-9.7,1.9v-13.5h25.7c1.6,0,3,1.3,3,3v243.5c0,1.6-1.3,3-3,3H5.1c-2.3,0-4.1-1.8-4.1-4.1V111.8ZM177.2,158.5c-1.4.5-3,.8-4.5.8v9.8c3.4,0,6.5-.8,9.4-2h0c.2,0,.4-.3.4-.5v-11.3c-1.5,1.4-3.3,2.5-5.2,3.1ZM171.5,159.3c-.6,0-1.1,0-1.7-.2-2.8-.5-5.3-1.7-7.3-3.4v11.5c2.9,1.2,6.1,1.9,9.5,2v-9.8c-.1,0-.3,0-.4,0ZM172.2,158.5c1.7,0,3.2-.3,4.7-.8,5.2-1.8,9-6.6,9.3-12.4.4-6.6-3.9-12.4-9.9-14.2-1.3-.4-2.7-.6-4.1-.6s-.8,0-1.2,0c-6.8.6-12.3,6.1-12.7,13.1-.4,7.2,4.7,13.4,11.6,14.5.8.1,1.5.2,2.3.2ZM157.6,143.8c.2-3.7,1.7-7,4.1-9.4v-12.8h0v-13.7l-10.2,5.1v64.4l10.2,4.2v-13.9h0v-12.8c-2.8-2.8-4.4-6.8-4.1-11.1ZM160.3,107.7l-9.6,4.8H41.3h0c0,0-9.6-4.8-9.6-4.8h128.6ZM40.9,177.3v-64.3l-10.7-5.3v73.8l10.7-4.3ZM41.4,177.9v-.2c0,0,109.4,0,109.4,0h0c0,.1,9.6,4.1,9.6,4.1H31.7l9.7-3.8ZM170.9,129.9c.3,0,.7,0,1,0v-9.8c-3.3,0-6.5.7-9.4,1.9v11.5c2.3-2,5.2-3.2,8.4-3.5ZM173.1,129.9c1.2,0,2.3.3,3.4.6,2.2.7,4.2,1.8,5.9,3.4v-11.3c0-.2-.1-.4-.3-.5h0c-2.9-1.2-6.1-1.9-9.4-2v9.8c.1,0,.3,0,.4,0ZM23.3,128.6c-1.8-.1-3.2-1.7-3.1-3.5s1.7-3.2,3.5-3.1c1.8,0,3.2,1.7,3.1,3.5-.1,1.8-1.7,3.2-3.5,3.1ZM19.5,125.1c-.1,2.2,1.6,4.1,3.8,4.3,2.2.1,4.1-1.6,4.3-3.8.1-2.2-1.6-4.1-3.8-4.3s-4.1,1.6-4.3,3.8ZM19.6,191.3c0-.2.2-.4.4-.4h7.1c.2,0,.4.2.4.4s-.2.4-.4.4h-7.1c-.2,0-.4-.2-.4-.4ZM171.9,151.7c-3.9-.2-7-3.6-6.7-7.5s3.6-7,7.5-6.7c3.9.2,7,3.6,6.7,7.5-.2,3.9-3.6,7-7.5,6.7ZM164.4,144.1c-.2,4.4,3.1,8.1,7.4,8.3s8.1-3.1,8.3-7.4c.2-4.4-3.1-8.1-7.4-8.3-4.4-.2-8.1,3.1-8.3,7.4ZM119.1,98.6c0-.2.1-.3.3-.3h16.2c.2,0,.3.1.3.3v4c0,.2-.1.3-.3.3h-16.2c-.2,0-.3-.1-.3-.3v-4ZM119.4,97.6c-.6,0-1.1.5-1.1,1.1v4c0,.6.5,1.1,1.1,1.1h16.2c.6,0,1.1-.5,1.1-1.1v-4c0-.6-.5-1.1-1.1-1.1h-16.2ZM98.2,98.3c-.2,0-.3.1-.3.3v4c0,.2.1.3.3.3h16.2c.2,0,.3-.1.3-.3v-4c0-.2-.1-.3-.3-.3h-16.2ZM97.1,98.6c0-.6.5-1.1,1.1-1.1h16.2c.6,0,1.1.5,1.1,1.1v4c0,.6-.5,1.1-1.1,1.1h-16.2c-.6,0-1.1-.5-1.1-1.1v-4ZM76.6,98.6c0-.2.1-.3.3-.3h16.2c.2,0,.3.1.3.3v4c0,.2-.1.3-.3.3h-16.2c-.2,0-.3-.1-.3-.3v-4ZM76.9,97.6c-.6,0-1.1.5-1.1,1.1v4c0,.6.5,1.1,1.1,1.1h16.2c.6,0,1.1-.5,1.1-1.1v-4c0-.6-.5-1.1-1.1-1.1h-16.2ZM55.7,98.3c-.2,0-.3.1-.3.3v4c0,.2.1.3.3.3h16.2c.2,0,.3-.1.3-.3v-4c0-.2-.1-.3-.3-.3h-16.2ZM54.6,98.6c0-.6.5-1.1,1.1-1.1h16.2c.6,0,1.1.5,1.1,1.1v4c0,.6-.5,1.1-1.1,1.1h-16.2c-.6,0-1.1-.5-1.1-1.1v-4ZM6,137.4c-.2,0-.3.1-.3.3v9.7c0,.2.1.3.3.3h19.9c.2,0,.3-.1.3-.3v-9.7c0-.2-.1-.3-.3-.3H6ZM4.9,137.8c0-.6.5-1.1,1.1-1.1h19.9c.6,0,1.1.5,1.1,1.1v9.7c0,.6-.5,1.1-1.1,1.1H6c-.6,0-1.1-.5-1.1-1.1v-9.7ZM5.7,113.2c0-.2.1-.3.3-.3h10.7c.2,0,.3.1.3.3v9.7c0,.2-.1.3-.3.3H6c-.2,0-.3-.1-.3-.3v-9.7ZM6,112.2c-.6,0-1.1.5-1.1,1.1v9.7c0,.6.5,1.1,1.1,1.1h10.7c.6,0,1.1-.5,1.1-1.1v-9.7c0-.6-.5-1.1-1.1-1.1H6ZM6,171.4c-.2,0-.3.1-.3.3v3.2c0,.2.1.3.3.3h8.2c.2,0,.3-.1.3-.3v-3.2c0-.2-.1-.3-.3-.3H6ZM4.9,171.7c0-.6.5-1.1,1.1-1.1h8.2c.6,0,1.1.5,1.1,1.1v3.2c0,.6-.5,1.1-1.1,1.1H6c-.6,0-1.1-.5-1.1-1.1v-3.2ZM6.1,188.9c0-.2.1-.3.3-.3h10.7c.2,0,.3.1.3.3v4.6c0,.2-.1.3-.3.3H6.4c-.2,0-.3-.1-.3-.3v-4.6ZM6.4,187.9c-.6,0-1.1.5-1.1,1.1v4.6c0,.6.5,1.1,1.1,1.1h10.7c.6,0,1.1-.5,1.1-1.1v-4.6c0-.6-.5-1.1-1.1-1.1H6.4ZM30.5,188c-.2,0-.3.1-.3.3v5.9c0,.2.1.3.3.3h12c.2,0,.3-.1.3-.3v-5.9c0-.2-.1-.3-.3-.3h-12ZM29.4,188.3c0-.6.5-1.1,1.1-1.1h12c.6,0,1.1.5,1.1,1.1v5.9c0,.6-.5,1.1-1.1,1.1h-12c-.6,0-1.1-.5-1.1-1.1v-5.9ZM17.3,171.7c0-.2.1-.3.3-.3h8.2c.2,0,.3.1.3.3v3.2c0,.2-.1.3-.3.3h-8.2c-.2,0-.3-.1-.3-.3v-3.2ZM17.7,170.7c-.6,0-1.1.5-1.1,1.1v3.2c0,.6.5,1.1,1.1,1.1h8.2c.6,0,1.1-.5,1.1-1.1v-3.2c0-.6-.5-1.1-1.1-1.1h-8.2ZM25.2,309.4c0,4.3-3.5,7.9-7.9,7.9s-7.9-3.5-7.9-7.9,3.5-7.9,7.9-7.9,7.9,3.5,7.9,7.9ZM25.2,335.5c0,4.3-3.5,7.9-7.9,7.9s-7.9-3.5-7.9-7.9,3.5-7.9,7.9-7.9,7.9,3.5,7.9,7.9ZM155.3,308.5c1.2,0,2.1-.9,2.1-2.1s-.9-2.1-2.1-2.1-2.1.9-2.1,2.1.9,2.1,2.1,2.1ZM23.2,291.7c2,0,3.5-1.6,3.5-3.5s-1.6-3.5-3.5-3.5-3.5,1.6-3.5,3.5,1.6,3.5,3.5,3.5ZM12.2,291.7c2,0,3.5-1.7,3.4-3.7,0-2-1.7-3.5-3.7-3.4-2,0-3.5,1.7-3.4,3.7,0,2,1.7,3.5,3.7,3.4ZM26.7,274c0,2-1.6,3.5-3.5,3.5s-3.5-1.6-3.5-3.5,1.6-3.5,3.5-3.5,3.5,1.6,3.5,3.5ZM15.6,274c0,2-1.6,3.5-3.5,3.5s-3.5-1.6-3.5-3.5,1.6-3.5,3.5-3.5,3.5,1.6,3.5,3.5ZM180.3,341.5c0,.7-.6,1.3-1.3,1.3h-8.6c-.7,0-1.3-.6-1.3-1.3v-4.4h11.1v4.4ZM170.5,269.7c-.7,0-1.3.6-1.3,1.3v4.4h11.1v-4.4c0-.7-.6-1.3-1.3-1.3h-8.6ZM174.2,261c1.5,0,2.8-1.2,2.8-2.8s-1.2-2.8-2.8-2.8-2.8,1.2-2.8,2.8,1.2,2.8,2.8,2.8ZM177,247.7c0,1.5-1.2,2.8-2.8,2.8s-2.8-1.2-2.8-2.8,1.2-2.8,2.8-2.8,2.8,1.2,2.8,2.8ZM41.3,270.9c0-30.3,24.6-54.9,54.9-54.9s54.9,24.6,54.9,54.9-24.6,54.9-54.9,54.9-54.9-24.6-54.9-54.9ZM50.1,270.9c0,25.5,20.6,46.1,46.1,46.1s46.1-20.6,46.1-46.1-20.6-46.1-46.1-46.1-46.1,20.6-46.1,46.1ZM11,219.8c0,1.5-1.2,2.8-2.8,2.8s-2.8-1.2-2.8-2.8,1.2-2.8,2.8-2.8,2.8,1.2,2.8,2.8ZM24.9,222.6c1.5,0,2.8-1.2,2.8-2.8s-1.2-2.8-2.8-2.8-2.8,1.2-2.8,2.8,1.2,2.8,2.8,2.8ZM13.5,206c.1-2.2-1.6-4.1-3.8-4.2-2.2-.1-4.1,1.6-4.2,3.8-.1,2.2,1.6,4.1,3.8,4.2,2.2.1,4.1-1.6,4.2-3.8ZM16.1,158.4c1.8,0,3.2,1.6,3.1,3.4,0,1.8-1.6,3.2-3.4,3.1-1.8,0-3.2-1.6-3.1-3.4,0-1.8,1.6-3.2,3.4-3.1ZM25.6,125.5c0-1.2-.8-2.2-2-2.2-1.2,0-2.2.8-2.2,2,0,1.2.8,2.2,2,2.2,1.2,0,2.2-.8,2.2-2ZM28.9,205.8c0,2.2-1.8,4-4,4s-4-1.8-4-4,1.8-4,4-4,4,1.8,4,4ZM45.7,205.8c0,2.2-1.8,4-4,4s-4-1.8-4-4,1.8-4,4-4,4,1.8,4,4ZM169.5,189.1c0-3.2,2.6-5.8,5.8-5.8h0c3.2,0,5.8,2.6,5.8,5.8s-2.6,5.8-5.8,5.8-2-.3-2.8-.7l2.8-5c0,0,0-.2,0-.2,0,0-.2,0-.2,0l-2.8,5c-1.7-1-2.7-2.8-2.7-4.9ZM178.1,144.9c.2-3.2-2.3-6-5.5-6.2-3.2-.2-6,2.3-6.2,5.5-.2,3.2,2.3,6,5.5,6.2,3.2.2,6-2.3,6.2-5.5ZM149.5,216.1h0s0,0,0,0h0ZM149.5,220v-3.9c2.1.1,3.8,1.8,3.8,4s-1.8,4-4,4-4-1.9-4-4,1.7-3.9,3.9-4v3.9c0,.1,0,.2.2.2s.2-.2.2-.2ZM151.5,204.5c0-1.5,1.2-2.8,2.8-2.8s2.8,1.2,2.8,2.8-1.2,2.8-2.8,2.8-2.8-1.2-2.8-2.8ZM143,201.7c-1.5,0-2.8,1.2-2.8,2.8s1.2,2.8,2.8,2.8,2.8-1.2,2.8-2.8-1.2-2.8-2.8-2.8ZM128.9,204.5c0-1.5,1.2-2.8,2.8-2.8s2.8,1.2,2.8,2.8-1.2,2.8-2.8,2.8-2.8-1.2-2.8-2.8ZM120.4,201.7c-1.5,0-2.8,1.2-2.8,2.8s1.2,2.8,2.8,2.8,2.8-1.2,2.8-2.8-1.2-2.8-2.8-2.8ZM171.2,181.9c.2-.1.5,0,.6.2l.4.7c.1.2,0,.5-.2.6-.2.1-.5,0-.6-.2l-.4-.7c-.1-.2,0-.5.2-.6ZM168.8,184.8c-.2-.1-.5,0-.6.1-.1.2,0,.5.1.6l.6.4c.2.1.5,0,.6-.1.1-.2,0-.5-.1-.6l-.6-.4ZM181.1,192.4c.1-.2.4-.3.6-.2l.7.4c.2.1.3.4.2.6-.1.2-.4.3-.6.2l-.7-.4c-.2-.1-.3-.4-.2-.6ZM167.5,188.7c-.2,0-.4.2-.4.4s.2.4.4.4h.8c.2,0,.4-.2.4-.4s-.2-.4-.4-.4h-.8ZM182,189.1c0-.2.2-.4.4-.4h.8c.2,0,.4.2.4.4s-.2.4-.4.4h-.8c-.2,0-.4-.2-.4-.4ZM169.4,193c.2-.1.3-.4.1-.6-.1-.2-.4-.3-.6-.1l-.6.4c-.2.1-.3.4-.1.6.1.2.4.3.6.1l.6-.4ZM182.5,185c.1.2,0,.5-.2.6l-.7.4c-.2.1-.5,0-.6-.2-.1-.2,0-.5.2-.6l.7-.4c.2-.1.5,0,.6.2ZM179.6,182.5c.1-.2,0-.5-.2-.6-.2-.1-.5,0-.6.2l-.4.7c-.1.2,0,.5.2.6.2.1.5,0,.6-.2l.4-.7ZM31.9,192.8c-.2,0-.4.2-.4.4s.2.4.4.4h9.2c.2,0,.4-.2.4-.4s-.2-.4-.4-.4h-9.2ZM47.3,188c-.2,0-.3.1-.3.3v5.9c0,.2.1.3.3.3h12c.2,0,.3-.1.3-.3v-5.9c0-.2-.1-.3-.3-.3h-12ZM46.2,188.3c0-.6.5-1.1,1.1-1.1h12c.6,0,1.1.5,1.1,1.1v5.9c0,.6-.5,1.1-1.1,1.1h-12c-.6,0-1.1-.5-1.1-1.1v-5.9ZM48.7,192.8c-.2,0-.4.2-.4.4s.2.4.4.4h9.2c.2,0,.4-.2.4-.4s-.2-.4-.4-.4h-9.2ZM64.1,188c-.2,0-.3.1-.3.3v5.9c0,.2.1.3.3.3h12c.2,0,.3-.1.3-.3v-5.9c0-.2-.1-.3-.3-.3h-12ZM63,188.3c0-.6.5-1.1,1.1-1.1h12c.6,0,1.1.5,1.1,1.1v5.9c0,.6-.5,1.1-1.1,1.1h-12c-.6,0-1.1-.5-1.1-1.1v-5.9ZM65.5,192.8c-.2,0-.4.2-.4.4s.2.4.4.4h9.2c.2,0,.4-.2.4-.4s-.2-.4-.4-.4h-9.2ZM80.9,188c-.2,0-.3.1-.3.3v5.9c0,.2.1.3.3.3h12c.2,0,.3-.1.3-.3v-5.9c0-.2-.1-.3-.3-.3h-12ZM79.9,188.3c0-.6.5-1.1,1.1-1.1h12c.6,0,1.1.5,1.1,1.1v5.9c0,.6-.5,1.1-1.1,1.1h-12c-.6,0-1.1-.5-1.1-1.1v-5.9ZM82.3,192.8c-.2,0-.4.2-.4.4s.2.4.4.4h9.2c.2,0,.4-.2.4-.4s-.2-.4-.4-.4h-9.2ZM97.7,188c-.2,0-.3.1-.3.3v5.9c0,.2.1.3.3.3h12c.2,0,.3-.1.3-.3v-5.9c0-.2-.1-.3-.3-.3h-12ZM96.7,188.3c0-.6.5-1.1,1.1-1.1h12c.6,0,1.1.5,1.1,1.1v5.9c0,.6-.5,1.1-1.1,1.1h-12c-.6,0-1.1-.5-1.1-1.1v-5.9ZM99.1,192.8c-.2,0-.4.2-.4.4s.2.4.4.4h9.2c.2,0,.4-.2.4-.4s-.2-.4-.4-.4h-9.2ZM114.5,188c-.2,0-.3.1-.3.3v5.9c0,.2.1.3.3.3h12c.2,0,.3-.1.3-.3v-5.9c0-.2-.1-.3-.3-.3h-12ZM113.5,188.3c0-.6.5-1.1,1.1-1.1h12c.6,0,1.1.5,1.1,1.1v5.9c0,.6-.5,1.1-1.1,1.1h-12c-.6,0-1.1-.5-1.1-1.1v-5.9ZM115.9,192.8c-.2,0-.4.2-.4.4s.2.4.4.4h9.2c.2,0,.4-.2.4-.4s-.2-.4-.4-.4h-9.2ZM131.3,188c-.2,0-.3.1-.3.3v5.9c0,.2.1.3.3.3h12c.2,0,.3-.1.3-.3v-5.9c0-.2-.1-.3-.3-.3h-12ZM130.3,188.3c0-.6.5-1.1,1.1-1.1h12c.6,0,1.1.5,1.1,1.1v5.9c0,.6-.5,1.1-1.1,1.1h-12c-.6,0-1.1-.5-1.1-1.1v-5.9ZM132.7,192.8c-.2,0-.4.2-.4.4s.2.4.4.4h9.2c.2,0,.4-.2.4-.4s-.2-.4-.4-.4h-9.2ZM148.1,188c-.2,0-.3.1-.3.3v5.9c0,.2.1.3.3.3h12c.2,0,.3-.1.3-.3v-5.9c0-.2-.1-.3-.3-.3h-12ZM147.1,188.3c0-.6.5-1.1,1.1-1.1h12c.6,0,1.1.5,1.1,1.1v5.9c0,.6-.5,1.1-1.1,1.1h-12c-.6,0-1.1-.5-1.1-1.1v-5.9ZM149.5,192.8c-.2,0-.4.2-.4.4s.2.4.4.4h9.2c.2,0,.4-.2.4-.4s-.2-.4-.4-.4h-9.2ZM179.2,195c-.1-.2-.4-.3-.6-.2-.2.1-.3.4-.2.6l.4.7c.1.2.4.3.6.2.2-.1.3-.4.2-.6l-.4-.7ZM163.9,201.5c0-.2.1-.3.3-.3h10.7v6.7h-10.7c-.2,0-.3-.1-.3-.3v-6.1ZM175.6,207.9v-6.7h10.7c.2,0,.3.1.3.3v6.1c0,.2-.1.3-.3.3h-10.7ZM164.2,200.5c-.6,0-1.1.5-1.1,1.1v6.1c0,.6.5,1.1,1.1,1.1h22.1c.6,0,1.1-.5,1.1-1.1v-6.1c0-.6-.5-1.1-1.1-1.1h-22.1ZM146.5,204.5c0-.2.2-.4.4-.4h3.6c.2,0,.4.2.4.4s-.2.4-.4.4h-3.6c-.2,0-.4-.2-.4-.4ZM36.8,285.8c-8.2-32.8,11.7-66.1,44.5-74.3,32.8-8.2,66.1,11.7,74.3,44.5,8.2,32.8-11.7,66.1-44.5,74.3-32.8,8.2-66.1-11.7-74.3-44.5ZM81.1,210.7c-33.2,8.3-53.4,42-45,75.2,8.3,33.2,42,53.4,75.2,45,33.2-8.3,53.4-42,45-75.2-8.3-33.2-42-53.4-75.2-45ZM6.9,247c-.4,0-.8.4-.8,1.2v9.1c0,.7.5,1.2.8,1.2h9.4v-11.4H6.9ZM26.4,258.4h-9.4v-11.4h9.4c.4,0,.8.4.8,1.2v9.1c0,.7-.5,1.2-.8,1.2ZM5.3,248.2c0-1,.6-1.9,1.6-1.9h19.6c1,0,1.6.9,1.6,1.9v9.1c0,1-.6,1.9-1.6,1.9H6.9c-1,0-1.6-.9-1.6-1.9v-9.1ZM7.7,249.6c0-.5.3-.7.4-.7h6.3c.2,0,.4.2.4.7v6.2c0,.5-.3.7-.4.7h-6.3c-.2,0-.4-.2-.4-.7v-6.2ZM8.1,248.2c-.7,0-1.2.7-1.2,1.4v6.2c0,.7.4,1.4,1.2,1.4h6.3c.7,0,1.2-.7,1.2-1.4v-6.2c0-.7-.4-1.4-1.2-1.4h-6.3ZM12,269.3c-2.6,0-4.7,2.1-4.7,4.7s2.1,4.7,4.7,4.7h11.2c2.6,0,4.7-2.1,4.7-4.7s-2.1-4.7-4.7-4.7h-11.2ZM6.6,274c0-3,2.4-5.4,5.4-5.4h11.2c3,0,5.4,2.4,5.4,5.4s-2.4,5.4-5.4,5.4h-11.2c-3,0-5.4-2.4-5.4-5.4ZM169.6,277.3c-.2,0-.5.2-.5.5s.2.5.5.5h4.4c.3,0,.5-.2.5-.5s0-.2-.1-.3-.2-.1-.3-.1h-4.4ZM175.5,277.3c-.2,0-.5.2-.5.5s.2.5.5.5h4.4c.1,0,.2,0,.3-.1s.1-.2.1-.3c0-.2-.2-.5-.5-.5h-4.4ZM169.6,279.9c-.2,0-.5.2-.5.5s.2.5.5.5h4.4c.3,0,.5-.2.5-.5s0-.2-.1-.3-.2-.1-.3-.1h-4.4ZM175.5,279.9c-.2,0-.5.2-.5.5s.2.5.5.5h4.4c.1,0,.2,0,.3-.1s.1-.2.1-.3c0-.2-.2-.5-.5-.5h-4.4ZM169.6,282.5c-.2,0-.5.2-.5.5s.2.5.5.5h4.4c.3,0,.5-.2.5-.5s0-.2-.1-.3-.2-.1-.3-.1h-4.4ZM175.5,282.5c-.2,0-.5.2-.5.5s.2.5.5.5h4.4c.1,0,.2,0,.3-.1s.1-.2.1-.3c0-.2-.2-.5-.5-.5h-4.4ZM169.6,285c-.2,0-.5.2-.5.5s.2.5.5.5h4.4c.3,0,.5-.2.5-.5s0-.2-.1-.3-.2-.1-.3-.1h-4.4ZM175.5,285c-.2,0-.5.2-.5.5s.2.5.5.5h4.4c.1,0,.2,0,.3-.1s.1-.2.1-.3c0-.2-.2-.5-.5-.5h-4.4ZM169.6,287.6c-.2,0-.5.2-.5.5s.2.5.5.5h4.4c.3,0,.5-.2.5-.5s0-.2-.1-.3-.2-.1-.3-.1h-4.4ZM175.5,287.6c-.2,0-.5.2-.5.5s.2.5.5.5h4.4c.1,0,.2,0,.3-.1s.1-.2.1-.3c0-.2-.2-.5-.5-.5h-4.4ZM169.6,292.7c-.2,0-.5.2-.5.5s.2.5.5.5h4.4c.3,0,.5-.2.5-.5s0-.2-.1-.3c0,0-.2-.1-.3-.1h-4.4ZM169.6,290.1c-.2,0-.5.2-.5.5s.2.5.5.5h4.4c.3,0,.5-.2.5-.5s0-.2-.1-.3-.2-.1-.3-.1h-4.4ZM175.5,292.8c-.2,0-.5.2-.5.5s.2.5.5.5h4.4c.1,0,.2,0,.3-.1s.1-.2.1-.3c0-.2-.2-.5-.5-.5h-4.4ZM175.5,290.2c-.2,0-.5.2-.5.5s.2.5.5.5h4.4c.1,0,.2,0,.3-.1s.1-.2.1-.3c0-.2-.2-.5-.5-.5h-4.4ZM169.6,295.3c-.2,0-.5.2-.5.5s.2.5.5.5h4.4c.3,0,.5-.2.5-.5s0-.2-.1-.3-.2-.1-.3-.1h-4.4ZM175.5,295.3c-.2,0-.5.2-.5.5s.2.5.5.5h4.4c.1,0,.2,0,.3-.1s.1-.2.1-.3c0-.2-.2-.5-.5-.5h-4.4ZM169.6,297.9c-.2,0-.5.2-.5.5s.2.5.5.5h4.4c.3,0,.5-.2.5-.5s0-.2-.1-.3-.2-.1-.3-.1h-4.4ZM175.5,297.9c-.2,0-.5.2-.5.5s.2.5.5.5h4.4c.1,0,.2,0,.3-.1,0,0,.1-.2.1-.3,0-.2-.2-.5-.5-.5h-4.4ZM169.6,300.5c-.2,0-.5.2-.5.5s.2.5.5.5h4.4c.3,0,.5-.2.5-.5s0-.2-.1-.3-.2-.1-.3-.1h-4.4ZM175.5,300.5c-.2,0-.5.2-.5.5s.2.5.5.5h4.4c.1,0,.2,0,.3-.1s.1-.2.1-.3c0-.2-.2-.5-.5-.5h-4.4ZM169.8,305.8c-.2,0-.3,0-.4,0-.1,0-.3.2-.3.4s0,.2.1.2.1,0,.2.1c.1,0,.3,0,.4,0h9.8c.2,0,.3,0,.4,0,0,0,.1,0,.2-.1s.1-.1.1-.2,0-.2-.1-.2c0,0-.1,0-.2-.1-.1,0-.3,0-.4,0h-9.8ZM169.6,311.1c-.2,0-.5.2-.5.5s.2.5.5.5h4.4c.3,0,.5-.2.5-.5s0-.2-.1-.3-.2-.1-.3-.1h-4.4ZM175.5,311.1c-.2,0-.5.2-.5.5s.2.5.5.5h4.4c.1,0,.2,0,.3-.1,0,0,.1-.2.1-.3,0-.2-.2-.5-.5-.5h-4.4ZM169.6,313.7c-.2,0-.5.2-.5.5s.2.5.5.5h4.4c.3,0,.5-.2.5-.5s0-.2-.1-.3c0,0-.2-.1-.3-.1h-4.4ZM175.5,313.7c-.2,0-.5.2-.5.5s.2.5.5.5h4.4c.1,0,.2,0,.3-.1s.1-.2.1-.3c0-.2-.2-.5-.5-.5h-4.4ZM169.6,316.3c-.2,0-.5.2-.5.5s.2.5.5.5h4.4c.3,0,.5-.2.5-.5s0-.2-.1-.3-.2-.1-.3-.1h-4.4ZM175.5,316.3c-.2,0-.5.2-.5.5s.2.5.5.5h4.4c.1,0,.2,0,.3-.1s.1-.2.1-.3c0-.2-.2-.5-.5-.5h-4.4ZM169.6,318.8c-.2,0-.5.2-.5.5s.2.5.5.5h4.4c.3,0,.5-.2.5-.5s0-.2-.1-.3-.2-.1-.3-.1h-4.4ZM175.5,318.8c-.2,0-.5.2-.5.5s.2.5.5.5h4.4c.1,0,.2,0,.3-.1s.1-.2.1-.3c0-.2-.2-.5-.5-.5h-4.4ZM169.6,321.4c-.2,0-.5.2-.5.5s.2.5.5.5h4.4c.3,0,.5-.2.5-.5s0-.2-.1-.3-.2-.1-.3-.1h-4.4ZM175.5,321.4c-.2,0-.5.2-.5.5s.2.5.5.5h4.4c.1,0,.2,0,.3-.1,0,0,.1-.2.1-.3,0-.2-.2-.5-.5-.5h-4.4ZM169.6,324c-.2,0-.5.2-.5.5s.2.5.5.5h4.4c.3,0,.5-.2.5-.5s0-.2-.1-.3-.2-.1-.3-.1h-4.4ZM175.5,324c-.2,0-.5.2-.5.5s.2.5.5.5h4.4c.1,0,.2,0,.3-.1s.1-.2.1-.3c0-.2-.2-.5-.5-.5h-4.4ZM169.6,326.6c-.2,0-.5.2-.5.5s.2.5.5.5h4.4c.3,0,.5-.2.5-.5s0-.2-.1-.3-.2-.1-.3-.1h-4.4ZM175.5,326.6c-.2,0-.5.2-.5.5s.2.5.5.5h4.4c.1,0,.2,0,.3-.1s.1-.2.1-.3c0-.2-.2-.5-.5-.5h-4.4ZM169.6,329.1c-.2,0-.5.2-.5.5s.2.5.5.5h4.4c.3,0,.5-.2.5-.5s0-.2-.1-.3-.2-.1-.3-.1h-4.4ZM175.5,329.1c-.2,0-.5.2-.5.5s.2.5.5.5h4.4c.1,0,.2,0,.3-.1s.1-.2.1-.3c0-.2-.2-.5-.5-.5h-4.4ZM169.6,331.7c-.2,0-.5.2-.5.5s.2.5.5.5h4.4c.3,0,.5-.2.5-.5s0-.2-.1-.3-.2-.1-.3-.1h-4.4ZM175.5,331.7c-.2,0-.5.2-.5.5s.2.5.5.5h4.4c.1,0,.2,0,.3-.1s.1-.2.1-.3c0-.2-.2-.5-.5-.5h-4.4ZM169.6,334.3c-.2,0-.5.2-.5.5s.2.5.5.5h4.4c.3,0,.5-.2.5-.5s0-.2-.1-.3c0,0-.2-.1-.3-.1h-4.4ZM175.5,334.3c-.2,0-.5.2-.5.5s.2.5.5.5h4.4c.1,0,.2,0,.3-.1s.1-.2.1-.3c0-.2-.2-.5-.5-.5h-4.4ZM155.3,303.3c-1.7,0-3.1,1.4-3.1,3.1s1.4,3.1,3.1,3.1,3.1-1.4,3.1-3.1-1.4-3.1-3.1-3.1ZM151.3,306.4c0-2.2,1.8-3.9,3.9-3.9s3.9,1.8,3.9,3.9-1.8,3.9-3.9,3.9-3.9-1.8-3.9-3.9ZM7.7,309.4c0-5.3,4.3-9.6,9.6-9.6s9.6,4.3,9.6,9.6-4.3,9.6-9.6,9.6-9.6-4.3-9.6-9.6ZM17.3,299c-5.7,0-10.4,4.7-10.4,10.4s4.7,10.4,10.4,10.4,10.4-4.7,10.4-10.4-4.7-10.4-10.4-10.4ZM6.9,335.5c0-5.7,4.7-10.4,10.4-10.4s10.4,4.7,10.4,10.4-4.7,10.4-10.4,10.4-10.4-4.7-10.4-10.4ZM17.3,325.9c-5.3,0-9.6,4.3-9.6,9.6s4.3,9.6,9.6,9.6,9.6-4.3,9.6-9.6-4.3-9.6-9.6-9.6ZM12.1,282.7c-3,0-5.4,2.4-5.4,5.4s2.4,5.4,5.4,5.4h11.2c3,0,5.4-2.4,5.4-5.4s-2.4-5.4-5.4-5.4h-11.2ZM7.4,288.1c0-2.6,2.1-4.7,4.7-4.7h11.2c2.6,0,4.7,2.1,4.7,4.7s-2.1,4.7-4.7,4.7h-11.2c-2.6,0-4.7-2.1-4.7-4.7ZM121.5,276.7c3.2-14-5.4-27.9-19.4-31.2-14-3.2-27.9,5.4-31.2,19.4-3.3,14,5.4,27.9,19.4,31.2s27.9-5.4,31.2-19.4ZM167,267.6c0-.2.1-.3.3-.3h14.9c.2,0,.3.1.3.3v77.2c0,.2-.1.3-.3.3h-14.9c-.2,0-.3-.1-.3-.3v-77.2ZM167.3,266.6c-.6,0-1.1.5-1.1,1.1v77.2c0,.6.5,1.1,1.1,1.1h14.9c.6,0,1.1-.5,1.1-1.1v-77.2c0-.6-.5-1.1-1.1-1.1h-14.9ZM13,219.8c0-.2.2-.4.4-.4h7.2c.2,0,.4.2.4.4s-.2.4-.4.4h-7.2c-.2,0-.4-.2-.4-.4ZM30,219.5c-.2,0-.4.2-.4.4s.2.4.4.4h7.1c.2,0,.4-.2.4-.4s-.2-.4-.4-.4h-7.1ZM15.2,205.4c-.2,0-.4.2-.4.4s.2.4.4.4h3.9c.2,0,.4-.2.4-.4s-.2-.4-.4-.4h-3.9ZM30,205.8c0-.2.2-.4.4-.4h5.8c.2,0,.4.2.4.4s-.2.4-.4.4h-5.8c-.2,0-.4-.2-.4-.4ZM47.1,205.4c-.2,0-.4.2-.4.4s.2.4.4.4h8.6c.2,0,.4-.2.4-.4s-.2-.4-.4-.4h-8.6ZM164.2,216.9c-.2,0-.3.1-.3.3v16.7c0,.2.1.3.3.3h22.1c.2,0,.3-.1.3-.3v-16.7c0-.2-.1-.3-.3-.3h-22.1ZM163.1,217.3c0-.6.5-1.1,1.1-1.1h22.1c.6,0,1.1.5,1.1,1.1v16.7c0,.6-.5,1.1-1.1,1.1h-22.1c-.6,0-1.1-.5-1.1-1.1v-16.7ZM165.9,219.1c-.2,0-.3.1-.3.3v5.3c0,.2.1.3.3.3h6.4c.2,0,.3-.1.3-.3v-5.3c0-.2-.1-.3-.3-.3h-6.4ZM164.8,219.4c0-.6.5-1.1,1.1-1.1h6.4c.6,0,1.1.5,1.1,1.1v5.3c0,.6-.5,1.1-1.1,1.1h-6.4c-.6,0-1.1-.5-1.1-1.1v-5.3ZM177.9,219.4c0-.2.1-.3.3-.3h6.4c.2,0,.3.1.3.3v5.3c0,.2-.1.3-.3.3h-6.4c-.2,0-.3-.1-.3-.3v-5.3ZM178.2,218.4c-.6,0-1.1.5-1.1,1.1v5.3c0,.6.5,1.1,1.1,1.1h6.4c.6,0,1.1-.5,1.1-1.1v-5.3c0-.6-.5-1.1-1.1-1.1h-6.4ZM169,228.7c-.2,0-.3.1-.3.3v2.3c0,.2.1.3.3.3h12.5c.2,0,.3-.1.3-.3v-2.3c0-.2-.1-.3-.3-.3h-12.5ZM167.9,229c0-.6.5-1.1,1.1-1.1h12.5c.6,0,1.1.5,1.1,1.1v2.3c0,.6-.5,1.1-1.1,1.1h-12.5c-.6,0-1.1-.5-1.1-1.1v-2.3ZM135.5,204.1c-.2,0-.4.2-.4.4s.2.4.4.4h3.6c.2,0,.4-.2.4-.4s-.2-.4-.4-.4h-3.6ZM123.9,204.5c0-.2.2-.4.4-.4h3.6c.2,0,.4.2.4.4s-.2.4-.4.4h-3.6c-.2,0-.4-.2-.4-.4ZM172,194.8c.2.1.3.4.2.6l-.4.7c-.1.2-.4.3-.6.2s-.3-.4-.2-.6l.4-.7c.1-.2.4-.3.6-.2ZM149.7,214.5c0-.2-.2-.4-.4-.4s-.4.2-.4.4v.7c0,.2.2.4.4.4s.4-.2.4-.4v-.7ZM147,214.6c.2,0,.5,0,.6.2l.2.5c0,.2,0,.5-.2.6-.2,0-.5,0-.6-.2l-.2-.5c0-.2,0-.5.2-.6ZM145.6,215.9c-.2-.2-.4-.2-.6,0-.2.2-.2.4,0,.6l.4.4c.2.2.4.2.6,0,.2-.2.2-.4,0-.6l-.4-.4ZM152.6,223.4c.2-.2.4-.2.6,0l1.1,1.1c.2.2.2.4,0,.6-.2.2-.4.2-.6,0l-1.1-1.1c-.2-.2-.2-.4,0-.6ZM144.2,217.6c-.2,0-.5,0-.5.2,0,.2,0,.5.2.5l.5.2c.2,0,.5,0,.5-.2,0-.2,0-.5-.2-.5l-.5-.2ZM153.6,221.9c0-.2.3-.3.5-.2l.5.2c.2,0,.3.3.2.5,0,.2-.3.3-.5.2l-.5-.2c-.2,0-.3-.3-.2-.5ZM143.7,219.7c-.2,0-.4.2-.4.4s.2.4.4.4h.6c.2,0,.4-.2.4-.4s-.2-.4-.4-.4h-.6ZM153.9,220.1c0-.2.2-.4.4-.4h.6c.2,0,.4.2.4.4s-.2.4-.4.4h-.6c-.2,0-.4-.2-.4-.4ZM144.8,222.5c.2,0,.3-.3.2-.5,0-.2-.3-.3-.5-.2l-.5.2c-.2,0-.3.3-.2.5,0,.2.3.3.5.2l.5-.2ZM154.9,217.8c0,.2,0,.5-.2.5l-.5.2c-.2,0-.5,0-.5-.2,0-.2,0-.5.2-.5l.5-.2c.2,0,.5,0,.5.2ZM146,224c.2-.2.2-.4,0-.6-.2-.2-.4-.2-.6,0l-1.1,1.1c-.2.2-.2.4,0,.6s.4.2.6,0l1.1-1.1ZM153.6,215.9c.2.2.2.4,0,.6l-.4.4c-.2.2-.4.2-.6,0s-.2-.4,0-.6l.4-.4c.2-.2.4-.2.6,0ZM151.8,215.1c0-.2,0-.5-.2-.5s-.5,0-.5.2l-.2.5c0,.2,0,.5.2.5s.5,0,.5-.2l.2-.5ZM17.2,229.7v7.4h.8v-7.4h-.8ZM26.1,233.5l-1,.5-1,.5v-2l1,.5,1,.5ZM9.9,234l-1-.5,1-.5,1-.5v2l-1-.5ZM6.2,230.1s0,0,0,0h8.2s0,0,0,0v6.6s0,0,0,0H6.2s0,0,0,0v-6.6ZM6.2,229.3c-.4,0-.8.4-.8.8v6.6c0,.4.4.8.8.8h8.2c.4,0,.8-.4.8-.8v-6.6c0-.4-.4-.8-.8-.8H6.2ZM20.8,230.1s0,0,0,0v6.6s0,0,0,0h8.2s0,0,0,0v-6.6s0,0,0,0h-8.2ZM20,230.1c0-.4.4-.8.8-.8h8.2c.4,0,.8.4.8.8v6.6c0,.4-.4.8-.8.8h-8.2c-.4,0-.8-.4-.8-.8v-6.6Z"
  })), _path1242 || (_path1242 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M443.4,342.7h134.5c1.4,0,2.5,1.1,2.5,2.5v86.5h-139.4v-86.5c0-1.4,1.1-2.5,2.5-2.5ZM577.8,341.7h-134.5c-1.9,0-3.5,1.6-3.5,3.5v86.9l-8.9,17.2h-.4c0,.3,0,.7,0,1,.5,4.2,4,7.4,8.3,7.4h143.3c4.3,0,7.8-3.2,8.3-7.4,0-.3,0-.7,0-1h-.4l-8.9-17.1v-87c0-1.9-1.6-3.5-3.5-3.5ZM432.1,449.4h58l4.2,2h31.3l4.8-2h58.6l-8.6-16.7h-139.7l-8.6,16.7ZM530.6,450.4h58.9c-.5,3.6-3.6,6.4-7.3,6.4h-143.3c-3.7,0-6.8-2.8-7.3-6.4h58.3l4.2,2h31.7l4.8-2Z"
  })), _path1243 || (_path1243 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M476.3,136.1c0-1.1.9-2,2-2h65.3c1.1,0,2,.9,2,2v49.3c0,1.1-.9,2-2,2h-65.3c-1.1,0-2-.9-2-2v-20h7.4v-2.9h-7.4v-16.2h16.8v-2.9h-16.8v-7.4ZM504.3,175h-5.6v-2.9h5.6v2.9ZM509.9,180.7h5.6v-2.9h-5.6v2.9ZM485.6,180.7h-5.6v-2.9h5.6v2.9ZM524.9,175h2.6v-2.9h-2.6v2.9ZM538,175h-5.6v-2.9h5.6v2.9ZM539.9,175h5.6v-2.9h-5.6v2.9ZM491.2,165.5h-5.6v-2.9h5.6v2.9ZM500.6,165.5h15v-2.9h-15v2.9ZM523,165.5h-3.7v-2.9h3.7v2.9ZM528.7,165.5h3.7v-2.9h-3.7v2.9ZM545.5,165.5h-5.6v-2.9h5.6v2.9ZM496.8,156h18.7v-2.9h-18.7v2.9ZM526.8,146.4h-18.7v-2.9h18.7v2.9ZM538,146.4h7.5v-2.9h-7.5v2.9Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFullSetupDesktop);
export default __webpack_public_path__ + "static/media/full-setup-desktop.805267aafa85341f4bcf5e264dfe3e9d.svg";
export { ForwardRef as ReactComponent };